var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import Luff, { luffState, React, Each, LibraryObject, PropTypes, LibraryDOM, LibraryNumber, LibraryString, ComponentSimple, State, Culture, luffDate, ComponentFactory, Route } from "luff";
function initDisabled(context) {
  let isWriteAllowed = !0;
  context.props.isPermissionWriteRequired && (isWriteAllowed = context.ParentComponent.Permission.IsAllowWrite);
  let disabledState = context.props.disabled, disabledBoolean = context.props.disabled;
  disabledState && disabledState.SubState ? context._IsDisabled = disabledState.SubState((isDisabled) => isDisabled || !isWriteAllowed) : context._IsDisabled = luffState(disabledBoolean || !isWriteAllowed);
}
__name(initDisabled, "initDisabled");
const defaultProps = {
  dataDelegateValue: /* @__PURE__ */ __name((d) => d, "dataDelegateValue"),
  dataDelegateView: /* @__PURE__ */ __name((d) => d.toString(), "dataDelegateView"),
  isInputMode: !1,
  placeholder: "",
  notFoundValue: "Не выбрано",
  listEmptyText: "(список пуст)",
  listClassName: "",
  isSearchEnabled: !1,
  listVisibleLinesCount: 10,
  isPermissionWriteRequired: !1,
  searchSuggestionDataAsyncDelay: 1e3,
  isAlwaysShowAllList: !1
}, _ComboBox = class _ComboBox extends Luff.Content {
  constructor() {
    super(...arguments), this._IsBusy = this.CreateState(!1), this.ListItems = this.props.data ? this.props.data : this.CreateState(this.props.dataStatic), this.SearchText = this.CreateState(""), this.CursorIndex = this.CreateState(-1), this.IsListOpen = this.CreateState(!1), this.IsListClosed = this.IsListOpen.SubState((s) => !s), this.IsListOpenUp = this.CreateState(!1), this.ViewportListenersAttached = !1, this.OnViewportChange = () => {
      this.IsListOpen.SValue && this.UpdateListPosition();
    };
  }
  get IsBusy() {
    return this._IsBusy.SValue;
  }
  set IsBusy(isBusy) {
    this._IsBusy.SValue = isBusy;
  }
  get HasInput() {
    return this.props.isInputMode || this.props.isSearchEnabled;
  }
  BeforeBuild() {
    initDisabled(this);
  }
  AfterBuild() {
    var _a;
    super.AfterBuild(), this.EachOfferList = this.GetComponentByName("each-l-offer-list"), this.Screen = this.GetComponentByName("l-cb-screen").DOM, this.Placeholder = this.GetComponentByName("l-cb-placeholder").DOM, this.OfferListWrapDom = this.GetComponentByName("l-cb-offer-list_wrap").DOM, this.OfferListDom = this.GetComponentByName("l-cb-offer-list").DOM, this.TbxSearch = this.GetComponentByName("l-cb-textbox_search").DOM, this.props.value.AddOnChange(() => this.MountCurrentView()), (_a = this.props.data) === null || _a === void 0 || _a.AddOnChange(() => this.MountCurrentView()), this.SearchText.AddOnChange(() => this.CursorUpdate()), this.MountCurrentView();
  }
  OnAppear() {
    super.OnAppear(), this.MountCurrentView();
  }
  UpdateValue(value, item) {
    const { onChange, onChangeAsync } = this.props;
    onChange ? onChange(value, item) : onChangeAsync ? (this._IsBusy.SValue = !0, onChangeAsync(value, item).finally(() => this._IsBusy.SValue = !1)) : this.props.value.SValue = value;
  }
  _OnOfferClick(item) {
    this._IsBusy.SValue = !!this.props.onChangeAsync;
    const newValue = this.props.dataDelegateValue(item);
    this.IsListOpen.SValue = !1, this.props.value.SValue == newValue && this.MountCurrentView(), this.UpdateValue(newValue, item), this.DOM.appendChild(this.OfferListWrapDom);
  }
  ToggleList() {
    this._IsDisabled.SValue || (this.IsListOpen.SValue ? this.OfferListClose() : this.OfferListOpen());
  }
  OfferListOpen() {
    this.IsListOpen.SValue = !0, this.EachOfferList.Refresh(), document.body.appendChild(this.OfferListWrapDom), this.UpdateListPosition(), this.CursorUpdate(), this.SearchText.SValue = "", this.RunAsyncSearch("", !0), this.TbxSearch.focus();
    const selectedDom = this.OfferListDom.querySelector(".l-cb-selected");
    selectedDom && selectedDom.scrollIntoView(), this.AttachViewportListeners();
  }
  OfferListClose() {
    this.IsListOpen.SValue = !1, this.DOM.appendChild(this.OfferListWrapDom), this.MountCurrentView(), this.DetachViewportListeners();
  }
  RenderOfferItem(item) {
    const onClick = /* @__PURE__ */ __name((e) => {
      Luff.DOM.IsDescendant(e.target, this.DOM) || (this._OnOfferClick(item.SValue), e.stopPropagation());
    }, "onClick"), value = this.props.value, dataDelegateValue = this.props.dataDelegateValue, isSelected = item.SubState((x) => dataDelegateValue(x) == value, [this.props.value]), isCursored = item.SubState((x) => {
      if (!this.EachOfferList)
        return !1;
      const index = this.CursorIndex.SValue;
      if (index < 0)
        return !1;
      const fo = this.EachOfferList.GetFilterPassedItems();
      if (fo.length == 0)
        return !1;
      const xVal = dataDelegateValue(x);
      return index >= fo.length ? (console.warn(`[Cbx] index out of border. index=${index}, len=${fo.length}, xVal=${xVal}`, fo), !1) : xVal == dataDelegateValue(fo[this.CursorIndex.SValue]);
    }, [this.CursorIndex]), classDict = {
      "l-cb-selected": isSelected,
      "l-cb-cursored": isCursored
    };
    if (this.props.dataRender) {
      const r = this.props.dataRender(item);
      r.Attributes || (r.Attributes = {});
      let props = r.Attributes;
      return props.onClick = onClick, props.classDict || (props.classDict = {}), props.classDict = Object.assign(Object.assign({}, props.classDict), classDict), r;
    }
    return this.RenderOfferItemDefault(item, classDict, onClick);
  }
  RenderOfferItemDefault(item, classDict, onClick) {
    return React.createElement("div", { className: "l-cb-offer-item", classDict, onClick }, item.SubState((it) => this.props.dataDelegateView(it)));
  }
  RenderList(list) {
    return React.createElement(
      "div",
      { className: "l-cb-offer-list", compName: "l-cb-offer-list" },
      React.createElement(Each, { compName: "each-l-offer-list", source: list, render: /* @__PURE__ */ __name((item) => this.RenderOfferItem(item), "render"), renderOnEmpty: /* @__PURE__ */ __name(() => React.createElement("div", { className: "l-cb-offer-empty" }, this.props.listEmptyText), "renderOnEmpty"), deps: [this.SearchText], filter: /* @__PURE__ */ __name((x) => {
        const text = this.SearchText.SValue, view = this.props.dataDelegateView(x);
        try {
          return Luff.String.Contains(view, text, !0) || Luff.String.Contains(view, Luff.String.KeyboardSwitch(text), !0);
        } catch (e) {
          console.error(this.GetComponentPath(!1)), console.error(e);
        }
      }, "filter") })
    );
  }
  MountCurrentView() {
    if (this.IsListOpen.SValue || !this.ListItems || !this.ListItems.SValue || this.ListItems.SValue.length == 0)
      return;
    const v = this.props.value.SValue, valState = this.ListItems.FirstOrDefault((x) => this.props.dataDelegateValue(x) == v), children = Array.from(this.Screen.children);
    for (let child of children)
      child.remove();
    if (valState) {
      const dom = this.EachOfferList.GetDOMByItemState(valState);
      if (!dom)
        return;
      this.Screen.appendChild(this.HasInput ? dom : dom.cloneNode(!0));
    } else
      this.Screen.appendChild(this.Placeholder);
  }
  CursorUpdate() {
    const items = this.EachOfferList.GetFilterPassedItems();
    if (items.length == 0) {
      this.CursorIndex.SValue = -1;
      return;
    }
    let currentItemIndex = items.findIndex((x) => this.props.dataDelegateValue(x) == this.props.value.SValue);
    currentItemIndex < 0 && (currentItemIndex = 0), this.CursorIndex.SValue = currentItemIndex;
  }
  CursorMove(direction) {
    const items = this.EachOfferList.GetFilterPassedItems();
    let newIndex = this.CursorIndex.SValue + direction;
    newIndex < 0 ? newIndex = items.length - 1 : newIndex >= items.length && (newIndex = 0), this.CursorIndex.SValue = newIndex;
  }
  GetListAnchor() {
    return this.props.isUseParentPositionForList && this.DOM.parentElement ? this.DOM.parentElement : this.DOM;
  }
  UpdateListPosition() {
    var _a;
    const anchor = this.GetListAnchor();
    if (!anchor)
      return;
    const rect = anchor.getBoundingClientRect();
    let maxLines = (_a = this.props.listVisibleLinesCount) !== null && _a !== void 0 ? _a : defaultProps.listVisibleLinesCount;
    maxLines > this.ListItems.length && (maxLines = this.ListItems.length);
    const wrap = this.OfferListWrapDom;
    if (this.OfferListDom.children.length > 0) {
      const firstElem = this.OfferListDom.children[0], lastElem = this.OfferListDom.children[this.OfferListDom.children.length - 1], h1 = firstElem.getBoundingClientRect().height, h2 = firstElem != lastElem ? lastElem.getBoundingClientRect().height : h1, lineHeight = Math.max(h1, h2), listCss = getComputedStyle(this.OfferListDom), chromeY = parseFloat(listCss.borderTopWidth) + parseFloat(listCss.borderBottomWidth) + parseFloat(listCss.paddingTop) + parseFloat(listCss.paddingBottom), isBorderBox = listCss.boxSizing === "border-box", preferredHeight = maxLines * lineHeight + chromeY, spaceBelow = window.innerHeight - rect.bottom - 8, spaceAbove = rect.top - 8, openUp = spaceBelow < preferredHeight && spaceAbove > spaceBelow;
      this.IsListOpenUp.SValue = openUp;
      const availableSpace = Math.max(openUp ? spaceAbove : spaceBelow, lineHeight), availableForContent = Math.max(lineHeight, availableSpace - chromeY), visibleLines = Math.max(1, Math.min(maxLines, Math.floor(availableForContent / lineHeight))), listHeight = visibleLines * lineHeight, listOuterHeight = listHeight + chromeY;
      wrap.style.setProperty("--l-combobox-lines", String(visibleLines)), openUp ? wrap.style.top = `${rect.top - listOuterHeight - 1}px` : (wrap.style.bottom = "auto", wrap.style.top = `${rect.bottom}px`), this.OfferListDom.style.maxHeight = `${isBorderBox ? listOuterHeight : listHeight}px`;
    }
    let widthPx = rect.width;
    const listWidth = Luff.State.GetSValueOrValue(this.props.listWidth);
    if (listWidth) {
      wrap.style.width = listWidth;
      const parsedWidth = parseFloat(listWidth);
      Number.isNaN(parsedWidth) || (widthPx = parsedWidth);
    } else
      wrap.style.width = `${rect.width}px`;
    let left = rect.left;
    left + widthPx > window.innerWidth - 8 && (left = Math.max(8, window.innerWidth - widthPx - 8)), wrap.style.position = "fixed", wrap.style.left = `${left}px`, wrap.style.zIndex = "10000";
  }
  HandleKeyDown(e) {
    switch (e.key) {
      case "ArrowDown":
        this.CursorMove(1);
        break;
      case "ArrowUp":
        this.CursorMove(-1);
        break;
      case "Enter":
        this.CommitCursorValue(), this.OfferListClose();
        break;
      case "Escape":
        e.preventDefault(), this.OfferListClose();
        break;
    }
  }
  HandleTextInput(value) {
    value = this.ApplyInputFilter(value.trim()), this.SearchText.SValue = value, this.props.isInputMode && this.CommitInputValue(), this.props.searchSuggestionDataAsync && this.RunAsyncSearch(value);
  }
  RunAsyncSearch(search, isInstant = !1) {
    var _a;
    const asyncSearch = this.props.searchSuggestionDataAsync;
    if (!asyncSearch)
      return;
    clearTimeout(this.SearchTimer);
    const delay = isInstant ? 0 : (_a = this.props.searchSuggestionDataAsyncDelay) !== null && _a !== void 0 ? _a : defaultProps.searchSuggestionDataAsyncDelay;
    this.SearchTimer = setTimeout(() => {
      var _a2;
      this._IsBusy.SValue = !0;
      const take = (_a2 = this.props.listVisibleLinesCount) !== null && _a2 !== void 0 ? _a2 : defaultProps.listVisibleLinesCount;
      asyncSearch(search, 0, take).then((items) => {
        this.ListItems.SValue = items;
      }).finally(() => {
        this._IsBusy.SValue = !1, this.IsListClosed.SValue && this.MountCurrentView();
      });
    }, delay);
  }
  ApplyInputFilter(value) {
    var _a, _b;
    const regex = this.props.inputFilterRegex;
    if (!regex)
      return value;
    const flags = regex.flags.includes("g") ? regex.flags : regex.flags + "g", allowed = new RegExp(regex.source, flags);
    return allowed.lastIndex = 0, (_b = (_a = value.match(allowed)) === null || _a === void 0 ? void 0 : _a.join("")) !== null && _b !== void 0 ? _b : "";
  }
  CommitInputValue() {
    const text = this.SearchText.SValue.trim();
    if (this.props.isInputMode) {
      const type = typeof this.props.value.SValue;
      type == "string" ? this.UpdateValue(text, null) : type == "number" ? this.UpdateValue(text.length > 0 ? parseFloat(text) : 0, null) : type == "boolean" && text.toLowerCase() && this.UpdateValue(text.length > 0 ? text.toLowerCase() != "false" : !1, null);
      return;
    }
  }
  CommitCursorValue() {
    const cursorIndex = this.CursorIndex.SValue;
    if (cursorIndex > -1) {
      const item = this.EachOfferList.GetFilterPassedItems()[cursorIndex];
      this.UpdateValue(this.props.dataDelegateValue(item), item);
      return;
    }
  }
  AttachViewportListeners() {
    this.ViewportListenersAttached || (window.addEventListener("resize", this.OnViewportChange), window.addEventListener("scroll", this.OnViewportChange, !0), this.ViewportListenersAttached = !0);
  }
  DetachViewportListeners() {
    this.ViewportListenersAttached && (window.removeEventListener("resize", this.OnViewportChange), window.removeEventListener("scroll", this.OnViewportChange, !0), this.ViewportListenersAttached = !1);
  }
  Render() {
    const { value, dataDelegateValue, dataDelegateView, isInputMode, isSearchEnabled, placeholder, notFoundValue } = this.props, isShowScreen = this.IsListOpen.SubState((isOpen) => !isInputMode && !isSearchEnabled ? !0 : !isOpen), isShowInput = this.IsListOpen.SubState((isOpen) => (isInputMode || isSearchEnabled) && isOpen);
    let deps = [];
    Luff.State.IsState(placeholder) && deps.push(placeholder), Luff.State.IsState(notFoundValue) && deps.push(notFoundValue);
    const valueView = value.SubState((v) => {
      const item = this.ListItems.SValue.find((x) => dataDelegateValue(x) == v);
      return item ? dataDelegateView(item) : isInputMode ? (v == null || v == null ? "" : v.toString()).length > 0 ? v : placeholder : Luff.State.ValueOf(notFoundValue);
    }, deps);
    return React.createElement(
      "div",
      { className: Luff.State.Concat("l-combo-box", this.props.className), classDict: {
        "l-busy": this._IsBusy,
        "l-cb-disabled": this._IsDisabled
      } },
      React.createElement(
        "div",
        {
          compName: "l-cb-screen",
          className: "l-cb-screen l-textbox",
          classDict: {
            //active: this.IsListVisible,
            "l-cb-disabled": this._IsDisabled
          },
          isVisible: isShowScreen,
          //isVisible={!isUseTextBox}
          onClick: /* @__PURE__ */ __name(() => this.ToggleList(), "onClick")
        },
        React.createElement("div", { className: "l-cb-placeholder", compName: "l-cb-placeholder" }, valueView)
      ),
      React.createElement("input", {
        className: "l-cb-textbox l-textbox",
        compName: "l-cb-textbox_search",
        type: "text",
        placeholder: this.props.placeholder,
        autocomplete: "off",
        value: this.SearchText,
        isVisible: isShowInput,
        //disabled={this._IsDisabled}
        onFocus: /* @__PURE__ */ __name((e) => {
          e.currentTarget.select();
        }, "onFocus"),
        onChange: /* @__PURE__ */ __name((e) => {
          this.HandleTextInput(e.currentTarget.value);
        }, "onChange"),
        //onChange={e => this.HandleTextInput((e.currentTarget as HTMLInputElement).value)}
        onKeyDown: /* @__PURE__ */ __name((e) => this.HandleKeyDown(e), "onKeyDown")
      }),
      React.createElement("div", { className: "l-cb-drop-icon", classDict: {
        active: this.IsListOpen
      }, onClick: /* @__PURE__ */ __name((e) => {
        e.stopPropagation(), this.ToggleList();
      }, "onClick") }),
      React.createElement("div", { compName: "l-cb-offer-list_wrap", className: Luff.State.Concat("l-cb-offer-list_wrap", this.props.listClassName), classDict: {
        "--open-up": this.IsListOpenUp
      } }, this.RenderList(this.ListItems))
    );
  }
  Ctor() {
    return {
      OnOutSideClick: /* @__PURE__ */ __name((e) => {
        if (this.IsListClosed.SValue)
          return;
        const target = e.target;
        Luff.DOM.IsDescendant(target, this.DOM) || Luff.DOM.IsDescendant(target, this.OfferListWrapDom) || this.OfferListClose();
      }, "OnOutSideClick")
    };
  }
};
__name(_ComboBox, "ComboBox");
let ComboBox = _ComboBox;
ComboBox.defaultProps = defaultProps;
const branchLast = "└─ ", branchIntermediate = "├─ ", branchAncestor = "│ ", indentWidth = branchIntermediate.length;
function getAncestorSegment(hasMoreSiblings) {
  return hasMoreSiblings ? branchAncestor.padEnd(indentWidth, " ") : " ".repeat(indentWidth);
}
__name(getAncestorSegment, "getAncestorSegment");
function getTreeChildren(item, subKey) {
  const raw = Luff.State.GetSValueOrValue(item[subKey]);
  return Array.isArray(raw) ? raw : [];
}
__name(getTreeChildren, "getTreeChildren");
function flattenTreeWithIndent(tree, subKey, indentMap, ancestorNotLast = []) {
  const res = [];
  for (let i = 0; i < tree.length; i++) {
    const item = tree[i], isLast = i === tree.length - 1;
    let prefix = "";
    if (ancestorNotLast.length > 0) {
      for (let j = 0; j < ancestorNotLast.length - 1; j++)
        prefix += getAncestorSegment(ancestorNotLast[j + 1]);
      prefix += isLast ? branchLast : branchIntermediate;
    }
    indentMap.set(item, prefix), res.push(item);
    const children = getTreeChildren(item, subKey);
    children.length && res.push(...flattenTreeWithIndent(children, subKey, indentMap, [...ancestorNotLast, !isLast]));
  }
  return res;
}
__name(flattenTreeWithIndent, "flattenTreeWithIndent");
const _ComboBoxTree = class _ComboBoxTree extends ComboBox {
  constructor() {
    super(...arguments), this.IndentMap = /* @__PURE__ */ new Map(), this.ListItems = (this.props.data ? this.props.data : Luff.State(this.props.dataStatic)).SubState((list) => (this.IndentMap.clear(), flattenTreeWithIndent(list, this.props.subKey, this.IndentMap)));
  }
  RenderOfferItemDefault(item, classDict, onClick) {
    const indent = item.SubState((it) => {
      var _a;
      return (_a = this.IndentMap.get(it)) !== null && _a !== void 0 ? _a : "";
    });
    return React.createElement(
      "div",
      { className: "l-cb-offer-item l-cbt-offer-item", classDict, onClick },
      React.createElement("span", { className: "l-cbt-prefix" }, indent),
      React.createElement("span", { className: "l-cbt-label" }, item.SubState((it) => this.props.dataDelegateView(it)))
    );
  }
};
__name(_ComboBoxTree, "ComboBoxTree");
let ComboBoxTree = _ComboBoxTree;
const _RadioButton = class _RadioButton extends Luff.Content {
  constructor() {
    super(...arguments), this._IsChecked = this.props.currentValue.SubState((c) => c === this.GetRadioValue(), [this.props.value]), this._IsDisabled = Luff.State(this.props.disabled), this._IsIndeterminate = Luff.State(this.props.indeterminate);
  }
  static GetRadioGroup() {
    return "lrg-" + Luff.Number.GetID();
  }
  GetRadioGroup() {
    return this.props.radioGroup ? this.props.radioGroup : "lrg-auto-" + this.props.currentValue._ID;
  }
  get IsChecked() {
    return this._IsChecked.SValue;
  }
  // set IsChecked(val: boolean) {
  //     this.State.IsChecked.SValue = val;
  // }
  // get IsDisabled() : boolean {
  //     return this._IsDisabled.SValue;
  // }
  // set IsDisabled(val: boolean) {
  //     this._IsDisabled.SValue = val;
  // }
  get IsIndeterminate() {
    return this._IsIndeterminate.SValue;
  }
  set IsIndeterminate(val) {
    this._IsIndeterminate.SValue = val;
  }
  get IsDisabled() {
    return this._IsDisabled.SValue;
  }
  set IsDisabled(val) {
    this._IsDisabled.SValue = val;
  }
  BeforeBuild() {
    initDisabled(this);
  }
  GetOnClick() {
    if (this.props.onClick)
      return (e) => {
        this.props.onClick(e, this);
      };
  }
  GetRadioValue() {
    return this.props.value.valueOf();
  }
  Render() {
    return this.props.onClick, React.createElement(
      React.Fragment,
      null,
      React.createElement("input", {
        type: "checkbox",
        className: "l-radio",
        id: "l-radio-id-" + this._ID,
        //radioGroup={this.GetRadioGroup()}
        name: this.GetRadioGroup(),
        onChange: /* @__PURE__ */ __name((e) => {
          const isChecked = e.target.checked, radioValue = this.GetRadioValue();
          if (e.target.checked = !isChecked, this.props.onChange)
            return this.props.onChange(radioValue);
          this.props.currentValue.SValue = radioValue;
        }, "onChange"),
        checked: this._IsChecked,
        disabled: this._IsDisabled,
        indeterminate: this._IsIndeterminate
      }),
      React.createElement("label", { for: "l-radio-id-" + this._ID, className: "l-radio-label " + this.props.className, onClick: this.GetOnClick() }, this.props.children)
    );
  }
};
__name(_RadioButton, "RadioButton");
let RadioButton = _RadioButton;
RadioButton.defaultProps = {
  className: "",
  state: Luff.State(-1),
  value: -1,
  disabled: !1,
  indeterminate: !1
};
const LOCK_PING_SENSITIVITY_MS = 50, _ButtonBusy = class _ButtonBusy extends Luff.Content {
  //private _Disabled = Luff.State(this.props.disabled ?? false);
  AfterBuild() {
    this.Button = this.Components.AllByName.button.DOM;
  }
  Lock() {
    const btn = this.Button;
    btn.disabled = !0, this.TimeoutLock = window.setTimeout(() => {
      this.props.justLock || btn.classList.add("l-busy");
    }, LOCK_PING_SENSITIVITY_MS);
  }
  UnLock(isBtnDisabled) {
    clearTimeout(this.TimeoutLock);
    const btn = this.Button;
    this.props && (this.props.disabled ? this.props.disabled && !Luff.State.ValueOf(this.props.disabled) && (btn.disabled = !1) : btn.disabled = isBtnDisabled, this.props.justLock || btn.classList.remove("l-busy"));
  }
  //private _btnRef: React.RefObject<HTMLButtonElement> = React.createRef();
  _onClick(e) {
    const wasBtnDisabled = this.Button.disabled;
    this.Lock();
    let res;
    if (!this.props.useConformationWindow)
      res = this.props.onClick(e);
    else {
      const form = this.props.useConformationWindow(e);
      form ? res = Luff.RunConfirmPromise(form.Caption, form.Message, {
        OnAgree: /* @__PURE__ */ __name(() => this.props.onClick.call(this.ParentComponent, e), "OnAgree")
      }) : res = this.props.onClick(e);
    }
    const cb = /* @__PURE__ */ __name(() => {
      this.UnLock(wasBtnDisabled);
    }, "cb");
    res == null || res.then(cb), res == null || res.catch(cb);
  }
  GetClassName() {
    const classNameDefault = this.props.justLock ? "" : "l-button ";
    let className;
    return !this.props.className || typeof this.props.className == "string" ? className = classNameDefault + (this.props.className ? this.props.className : "") : className = this.props.className.SubState((c) => classNameDefault + " " + c), className;
  }
  Click() {
    this._onClick(null);
  }
  Render() {
    return React.createElement("button", { compName: "button", className: this.GetClassName(), classDict: this.props.classDict, onClick: /* @__PURE__ */ __name((e) => this._onClick(e), "onClick"), disabled: this.props.disabled, title: this.props.title }, this.props.children);
  }
};
__name(_ButtonBusy, "ButtonBusy");
let ButtonBusy = _ButtonBusy;
ButtonBusy.defaultProps = {
  disabled: !1,
  justLock: !1
};
const seriesSample = {
  Type: "line",
  Data: [],
  Name: "",
  Title: "",
  Visible: !0,
  //Enabled: true,
  Format: null,
  AxisX: {
    Data: void 0,
    Start: null,
    End: null,
    Step: null,
    Skip: null
    //Skip: 30,
    //Skip: (value)=>{return value},
    //Linear: true, // false if Skip is a function
  },
  AxisY: {
    Position: "left",
    Min: null,
    Max: null,
    Step: null,
    Visible: !1
  },
  Marker: {
    Radius: null,
    Shape: "circle",
    Visible: !0
  },
  Width: 2,
  /* Draw */
  Labels: {
    Data: [],
    Format: null,
    Visible: !0
  }
}, defaultCtor = {
  Series: [],
  Graph: [],
  Draws: [],
  //Target: '',
  Type: "line",
  Title: "",
  Animation: {
    Bar: "l-animate-svg-bar",
    Line: "l-animate-svg-line",
    Marker: "l-animate-svg-mark",
    Pie: "l-animate-svg-pie",
    Ring: "l-animate-svg-ring"
  },
  Legend: {
    Position: "top",
    Visible: !0
  },
  Grid: {
    Visible: !0,
    Html: ""
  },
  AxisX: {
    Data: [],
    Format: null,
    Rotation: "auto",
    Skip: null,
    Step: null,
    Position: "bottom",
    Visible: !0
  },
  AxisY: {
    Position: "left",
    Min: null,
    Max: null,
    Step: null,
    StepMin: 0,
    Visible: !0
  },
  Tooltip: {
    Format: null,
    FormatGraph: /* @__PURE__ */ __name(function(Tip) {
      let valueX = String(Tip.ValueX), valueY = `${Tip.Episode.Name}: ${Tip.Value}`;
      (Tip.ValueX === void 0 || Tip.ValueX === null) && (valueX = Tip.Episode.Name, valueY = String(Tip.Value));
      let color = Tip.Episode.Color;
      return this.Options.Series[Tip.EpisodeIndex].Colors && this.Options.Series[Tip.EpisodeIndex].Colors[Tip.ValueIndex] && (color = this.Options.Series[Tip.Episode.Line].Colors[Tip.ValueIndex]), `<div class="tip">
                              <div class="tip-bg"></div>
                              <div class="tip-value">
                                <div class="l-row">
                                  <div class="tip-icon" style="background-color: ${color}"></div>
                                  <div class="tip-label">${valueX}</div>
                                </div>
                                <div class="l-row">${valueY}</div> 
                              </div>
                            </div>`;
    }, "FormatGraph"),
    FormatDraws: /* @__PURE__ */ __name(function(Tip) {
      let Percent = Tip.Value / Tip.Episode.Sum * 100;
      return isNaN(Percent) && (Percent = 0), Percent > 1 ? Percent = Math.round(Percent) : Percent = Math.round(Percent * 100) / 100, `<div class="tip">
                              <div class="tip-bg"></div>
                              <div class="tip-value">
                                <div class="l-row l-flexa-center">
                                  <div class="tip-icon" style="background-color: ${Tip.Color}"></div>
                                  <div class="tip-label">${Tip.Name}: ${Tip.Value} (${Percent}%)</div>
                                </div>
                              </div>
                            </div>`;
    }, "FormatDraws"),
    Template: "<div>Name: {{Name}}</div><div>Value: {{Value}}</div>",
    Visible: !0,
    Duration: 200,
    Timeout: 700,
    TipPrev: null,
    Tip: {
      Left: 0,
      Top: 0,
      Color: "#000"
    },
    Episode: null,
    Position: null,
    x: 0,
    y: 0
    //MultiValues: false
  },
  SeriesOptions: {
    Colors: ["red", "green", "cornflowerblue", "purple", "palevioletred", "orange", "tomato", "darkblue", "cadetblue", "crimson"],
    // _Bar:{
    //     Stack: false,
    //     Gradient: true,
    //
    //     _Count: 0,
    // },
    BarStack: !1,
    BarGradient: !0,
    PieStack: !1,
    PieType: "pie",
    StartAngle: 0,
    Width: 2,
    Marker: {
      Radius: null,
      Shape: "circle",
      Visible: !0
    }
  },
  Height: 400,
  Width: 600,
  Responsible: !0
}, LuffChartInitializer = {
  isGraph: /* @__PURE__ */ __name(function(type) {
    return LuffChartInitializer.Type.Graph.indexOf(type.toLowerCase()) > -1;
  }, "isGraph"),
  isDraw: /* @__PURE__ */ __name(function(type) {
    return LuffChartInitializer.Type.Draw.indexOf(type.toLowerCase()) > -1;
  }, "isDraw"),
  Type: {
    Graph: ["line", "bar"],
    Draw: ["pie", "ring"]
  },
  Default: {
    Color: ["red", "green", "cornflowerblue", "purple", "palevioletred", "orange", "tomato", "darkblue", "cadetblue", "crimson"],
    R: defaultCtor
  },
  RAnimation(R) {
    if (R.Animation === null) {
      R.Animation = {
        Bar: "",
        Line: "",
        Marker: "",
        Pie: "",
        Ring: ""
      };
      return;
    }
    R.Animation = Object.assign(Object.assign({}, defaultCtor.Animation), R.Animation);
  },
  RLegend(R) {
    R.Legend = Object.assign(Object.assign({}, defaultCtor.Legend), R.Legend);
  },
  RLabels(R) {
    R.Labels = Object.assign(Object.assign({}, defaultCtor.Labels), R.Labels);
  },
  RGrid(R) {
    R.Grid = Object.assign(Object.assign({}, defaultCtor.Grid), R.Grid);
  },
  RAxisX(R) {
    R.AxisX = Object.assign(Object.assign({}, defaultCtor.AxisX), R.AxisX), R.AxisX.Data.length === 0 && (R.AxisX.Visible = !1);
  },
  RAxisY(R) {
    R.AxisY = Object.assign(Object.assign({}, defaultCtor.AxisY), R.AxisY);
  },
  RTooltip(R) {
    R.Tooltip = Object.assign(Object.assign({}, defaultCtor.Tooltip), R.Tooltip);
  },
  RSeries(R) {
  },
  RSeriesOptions(R) {
    R.SeriesOptions = Object.assign(Object.assign({}, defaultCtor.SeriesOptions), R.SeriesOptions), R.SeriesOptions.Marker = Object.assign(Object.assign({}, defaultCtor.SeriesOptions.Marker), R.SeriesOptions.Marker);
  },
  /*###*/
  GetSeries(R) {
    let Series = R.Series, SeriesList = [];
    for (let i = 0; i < Series.length; i++) {
      let Ep = Series[i];
      Ep.Line = i, Ep.Type = Ep.Type !== void 0 ? Ep.Type.toLowerCase() : R.Type, Ep.Name = Ep.Name !== void 0 ? Ep.Name : "", Ep.Title = Ep.Title !== void 0 ? Ep.Title : "", Ep.Color = Ep.Color !== void 0 ? Ep.Color : R.SeriesOptions.Colors[i], Ep.Color = Ep.Color !== void 0 ? Ep.Color : "#000", Ep.Width = Ep.Width !== void 0 ? Ep.Width : R.SeriesOptions.Width, Ep.Visible = Ep.Visible !== void 0 ? Ep.Visible : seriesSample.Visible, Ep.Format = Ep.Format !== void 0 ? Ep.Format : seriesSample.Format, Ep.AxisX = Ep.AxisX !== void 0 ? Ep.AxisX : LibraryObject.Clone(seriesSample.AxisX), Ep.AxisX.Data = Ep.AxisX.Data !== void 0 ? Ep.AxisX.Data : R.AxisX.Data, Ep.AxisX.Start = Ep.AxisX.Start !== void 0 ? Ep.AxisX.Start : seriesSample.AxisX.Start, Ep.AxisX.End = Ep.AxisX.End !== void 0 ? Ep.AxisX.End : seriesSample.AxisX.End, Ep.AxisY = Ep.AxisY !== void 0 ? Ep.AxisY : LibraryObject.Clone(seriesSample.AxisY), Ep.AxisY.Visible = Ep.AxisY.Visible !== void 0 ? Ep.AxisY.Visible : Ep.AxisY !== void 0 ? !0 : seriesSample.AxisY.Visible, Ep.AxisY.Position = Ep.AxisY.Position !== void 0 ? Ep.AxisY.Position : seriesSample.AxisY.Position, Ep.AxisY.Min = Ep.AxisY.Min !== void 0 ? Ep.AxisY.Min : seriesSample.AxisY.Min, Ep.AxisY.Max = Ep.AxisY.Max !== void 0 ? Ep.AxisY.Max : seriesSample.AxisY.Max, Ep.AxisY.Step = Ep.AxisY.Step !== void 0 ? Ep.AxisY.Step : seriesSample.AxisY.Step, Ep.Marker = Ep.Marker !== void 0 ? Ep.Marker : LibraryObject.Clone(R.SeriesOptions.Marker), Ep.Marker.Visible = Ep.Marker.Visible !== void 0 ? Ep.Marker.Visible : R.SeriesOptions.Marker.Visible, Ep.Marker.Shape = Ep.Marker.Shape !== void 0 ? Ep.Marker.Shape : R.SeriesOptions.Marker.Shape, Ep.Marker.Radius = Ep.Marker.Radius !== void 0 ? Ep.Marker.Radius : R.SeriesOptions.Marker.Radius, Ep.Marker.Radius = Ep.Marker.Radius !== null ? Ep.Marker.Radius : 4 + Ep.Width / 4, LuffChartInitializer.Type.Draw.indexOf(Ep.Type) > -1 && (Ep.Colors = Ep.Colors ? Ep.Colors : LuffChartInitializer.Default.Color, Ep.Width = Ep.Width ? Ep.Width : 30, Ep.AngleStart = Ep.AngleStart ? Ep.AngleStart : 0, Ep.Margin = Ep.Margin ? Ep.Margin : 0, Ep.Labels = Ep.Labels !== void 0 ? Ep.Labels : seriesSample.Labels, Ep.Labels.Visible = Ep.Labels.Visible !== void 0 ? Ep.Labels.Visible : seriesSample.Labels.Visible, Ep.Labels.Data = Ep.Labels.Data !== void 0 ? Ep.Labels.Data : seriesSample.Labels.Data, Ep.Labels.Format = Ep.Labels.Format !== void 0 ? Ep.Labels.Format : seriesSample.Labels.Format, Ep.Visibles = Ep.Visibles !== void 0 ? Ep.Visibles : Ep.Data.map(() => !0)), SeriesList.push(Ep);
    }
    return SeriesList;
  },
  InitR: /* @__PURE__ */ __name(function(R) {
    R.Name = R.Name !== void 0 ? R.Name : "", R.Title = R.Title !== void 0 ? R.Title : "", R.Type = R.Type !== void 0 ? R.Type.toLowerCase() : "line", R.Height = R.Height !== void 0 ? R.Height : "auto", R.Width = R.Width !== void 0 ? R.Width : "auto", R.Responsible = R.Responsible !== void 0 ? R.Responsible : !0, LuffChartInitializer.RAnimation(R), LuffChartInitializer.RLegend(R), LuffChartInitializer.RGrid(R), LuffChartInitializer.RAxisX(R), LuffChartInitializer.RAxisY(R), LuffChartInitializer.RTooltip(R), LuffChartInitializer.RSeriesOptions(R), R.DrawAfterInit = R.DrawAfterInit !== void 0 ? R.DrawAfterInit : !0, this.Options = R, this.Options.Series = LuffChartInitializer.GetSeries(R), this.Options.Svg = {
      Html: "",
      Height: 0
    }, this.Options.AxisX.Html = "", this.Options.AxisY.HtmlLeft = "", this.Options.AxisY.HtmlRight = "", this.Options.Grid.Html = "", this.Options.Legend.Html = "", this.Options.Tooltip.Html = "", this.isGraph = this.Options.Series.filter((s) => s.Type.toLowerCase() !== "line" && s.Type.toLowerCase() !== "bar").length === 0, this.Options._Series = {
      Padding: 0,
      Line: {
        Count: 0,
        CountPrepared: 0
      },
      Bar: {
        Count: this.Options.Series.filter((s) => s.Type === "bar").length,
        CountPrepared: 0
      },
      Pie: {
        Count: this.Options.Series.filter((s) => s.Type === "bar").length,
        CountPrepared: 0
      },
      Ring: {
        Count: this.Options.Series.filter((s) => s.Type === "ring").length,
        CountPrepared: 0
      }
    };
  }, "InitR")
}, _BChartContent = class _BChartContent {
  Refresh(options) {
  }
  GetTip(ValueX, EpisodeNum, ValueNum) {
    return null;
  }
  GetEpisodeWidthRange(episode, width) {
    let XData = episode.AxisX.Data;
    XData.length === 0 && (XData = Object.keys(episode.Data));
    let Type = PropTypes.GetType(episode.AxisX.Data[0]), Start = 0, End = width;
    if (Type === "date" && (XData = XData.map((x) => x.valueOf())), episode.AxisX.Start !== null && (Type === "number" || Type === "date")) {
      let S = Type !== "date" ? episode.AxisX.Start : episode.AxisX.Start.valueOf(), pos = XData.indexOf(S);
      pos > -1 && (Start = width * pos / episode.AxisX.Data.length);
    }
    if (episode.AxisX.End !== null && (Type === "number" || Type === "date")) {
      let E = Type !== "date" ? episode.AxisX.Start : episode.AxisX.End.valueOf(), pos = XData.indexOf(E);
      pos > -1 && (End = width * pos / episode.AxisX.Data.length);
    }
    let EpisodeWidth = End - Start;
    return {
      Start,
      EpisodeWidth
    };
  }
  GetValuesY(Episode, Scale, DefaultScale, Height) {
    let Ys = [], MaxValue = DefaultScale.Values[DefaultScale.Values.length - 1], MinValue = DefaultScale.Values[0];
    MaxValue = Scale ? Scale.Values[Scale.Values.length - 1] : MaxValue, MinValue = Scale ? Scale.Values[0] : MinValue;
    for (let j = 0; j < Episode.Data.length; j++)
      Ys.push(Height - (Episode.Data[j] - MinValue) * Height / (MaxValue - MinValue));
    return Ys;
  }
  GetValuesX(Episode, Width) {
    if (Episode.Data.length < 1)
      return [0];
    let w = this.GetEpisodeWidthRange(Episode, Width - 2 * this.Options._Series.Padding), EpisodeWidth = w.EpisodeWidth;
    if (Episode.Data.length < 2) {
      const stepX2 = EpisodeWidth / (this.Options.Graph.length - 1);
      return [w.Start + Episode.Line * stepX2];
    }
    let stepX = EpisodeWidth / (Episode.Data.length - 1);
    return Episode.Data.map((x, i) => x !== null ? w.Start + i * stepX : 0);
  }
  GetPoints(xs, ys) {
    let Points = [];
    for (let i = 0; i < ys.length; i++)
      Points.push([xs[i] + this.Options._Series.Padding, ys[i]]);
    return Points;
  }
  GetContent() {
    let HTMLLegend = '<div class="legend"></div>';
    return LibraryDOM.CreateElementFromString(`<div class="l-chart l-col">
                        <table class="l-chart-t">
                            <tr class="tr-hook-top">
                                <td colspan="5" class="td-hook-top">
                                    <div class="chart-name"></div>
                                    ${this.Options.Legend.Visible && this.Options.Legend.Position === "top" ? HTMLLegend : ""}
                                </td>
                            </tr>
                            
                            <tr class="tr-hook-mid">
                                <td>${this.Options.Legend.Visible && this.Options.Legend.Position === "left" ? HTMLLegend : ""}</td> 
                                <td rowspan="1">
                                    <div class="hook-axis-y hook left"></div>
                                </td>
                                <td rowspan="1" class="hook-chart">
                                    <div class="chart-svg-wrapper">
                                        <svg class="chart-svg"></svg>
                                    </div>
                                    <div class="chart-grid"></div>
                                    <div class="chart-tooltip"></div>
                                    <div class="v-stick"></div>
                                </td> 
                                <td rowspan="1">
                                    <div class="hook-axis-y hook right"></div>
                                </td> 
                                <td>${this.Options.Legend.Visible && this.Options.Legend.Position === "right" ? HTMLLegend : ""}</td>
                            </tr>
                            
                            <tr class="tr-hook-axis-x">
                                <td colspan="1" class="td-hook-null"></td> 
                                <td colspan="1" class="td-hook-null"></td> 
                                <td colspan="1" class="hook-axis-x">
                                    ${this.Options.AxisX.Visible ? '<div class="axis-x"></div>' : ""} 
                                </td> 
                                <td colspan="1" class="td-hook-null"></td>
                                <td colspan="1" class="td-hook-null"></td>
                            </tr>
                            <tr class="tr-hook-bottom">
                                <td colspan="5" class="td-hook-bottom">
                                    ${this.Options.Legend.Visible && this.Options.Legend.Position === "bottom" ? HTMLLegend : ""}
                                </td>
                            </tr>
                        </table>
                      </div>`);
  }
  GetContentDraw() {
    let HTMLLegend = '<div class="legend"></div>';
    return LibraryDOM.CreateElementFromString(`<div class="l-chart l-col">
                        <table class="l-chart-t">
                            <tr class="tr-hook-top">
                                <td colspan="5" class="td-hook-top">
                                    <div class="chart-name"></div>
                                    ${this.Options.Legend.Visible && this.Options.Legend.Position === "top" ? HTMLLegend : ""}
                                </td>
                            </tr>
                            
                            <tr class="tr-hook-mid">
                                <td>${this.Options.Legend.Visible && this.Options.Legend.Position === "left" ? HTMLLegend : ""}</td> 
                                <td rowspan="1">
                                    <div class="hook-axis-y hook left"></div>
                                </td>
                                <td rowspan="1" class="hook-chart">
                                    <div class="chart-svg-wrapper">
                                        <svg class="chart-svg"></svg>
                                    </div>
                                    <div class="chart-tooltip"></div>
                                </td> 
                                <td rowspan="1">
                                    <div class="hook-axis-y hook right"></div>
                                </td> 
                                <td>${this.Options.Legend.Visible && this.Options.Legend.Position === "right" ? HTMLLegend : ""}</td>
                            </tr>
                             
                            <tr class="tr-hook-bottom">
                                <td colspan="5" class="td-hook-bottom">
                                    ${this.Options.Legend.Visible && this.Options.Legend.Position === "bottom" ? HTMLLegend : ""}
                                </td> 
                            </tr>
                        </table>
                      </div>`);
  }
  GenContentProps() {
  }
  MakeLegend() {
  }
  OnLegendChange(e) {
    let i = e.currentTarget.dataset.line, Episode = this.Options.Graph[i];
    if (Episode.Visible = e.currentTarget.checked, this.Options.Graph.filter((g) => g.Visible).length < 1) {
      Episode.Visible = !0, e.currentTarget.checked = !0;
      return;
    }
    this.Refresh();
  }
  OnChartMouseMove(e) {
  }
  // OnChartMouseMove(e) : void  {
  //     clearTimeout(this._ToolTipTimeout);
  //     this._ToolTipTimeout = window.setTimeout(() => {
  //         //console.log(`e.target.tagName ${e.target.tagName}`);
  //         if (e.target.tagName === 'path' || e.target.tagName === 'circle'){
  //             let i = e.target.dataset["line"];
  //             this.Options.Tooltip.Episode = this.Options.Graph[i];
  //         }
  //         if (!this.Options.Tooltip.Episode)
  //             return;
  //
  //         let x = e.clientX - this.Options.Svg.Rect.left;
  //         let EpisodeNum = e.target.dataset['line'];
  //         let ValueNum = e.target.dataset['item'];
  //         let Tip = this.GetTip(x, EpisodeNum, ValueNum);
  //         this.Tooltip.Tip = Tip;
  //
  //         //console.log(`e.pageX:${e.pageX}, e.clientX: ${e.clientX}`, e);
  //         this.StickV.style.left = Tip.x + 'px';
  //         this.Tooltip.Refresh();
  //         console.log('OnChartMouseMove');
  //     }, 50)
  //
  // }
  OnChartMouseEnter(e) {
    this.Tooltip.Reset(), this.OnChartMouseMove(e);
  }
  OnChartMouseLeave() {
    this.Tooltip.Close();
  }
  constructor(Chart) {
    this.ID = LibraryNumber.GetID(), this.Chart = Chart, this.Options = Chart.Options, this.Content = this.GetContent(), this.ChartName = LibraryDOM.Select(".chart-name", this.Content), this.HookChart = LibraryDOM.Select(".hook-chart", this.Content), this.ChartLegend = LibraryDOM.Select(".legend", this.Content), this.ChartSvg = LibraryDOM.Select(".chart-svg", this.Content), this.ChartTooltip = LibraryDOM.Select(".chart-tooltip", this.Content), this.GenContentProps(), Chart.Target.appendChild(this.Content), LibraryDOM.AddEventListenerGlobal("change", ".legend-checkbox", this.OnLegendChange.bind(this), this.Content, this), this.Tooltip = {}, this.Options.Tooltip.Visible && (this.HookChart.addEventListener("mousemove", this.OnChartMouseMove.bind(this)), this.HookChart.addEventListener("mouseenter", this.OnChartMouseEnter.bind(this)), this.HookChart.addEventListener("mouseleave", this.OnChartMouseLeave.bind(this)), this.ChartTooltip.addEventListener("mouseleave", this.OnChartMouseLeave.bind(this)), this.Tooltip = {
      Timer: null,
      Format: this.Options.Tooltip.Format,
      Hide: /* @__PURE__ */ __name(() => {
        LibraryDOM.AsyncToggle(null, null, this.ChartTooltip, () => {
        }, () => {
          this.ChartTooltip.style.display = "none";
        }, "l-appear", "l-disappear", 200, this.Tooltip.Timer), this.Tooltip.Timer = null, this.Options.Tooltip.Episode = null;
      }, "Hide"),
      Show: /* @__PURE__ */ __name(() => {
        LibraryDOM.AsyncToggle(null, null, this.ChartTooltip, () => {
          this.ChartTooltip.style.display = "";
        }, () => {
        }, "l-disappear", "l-appear", 200, this.Tooltip.Timer);
      }, "Show"),
      Reset: /* @__PURE__ */ __name(() => {
        this.Tooltip.Timer && clearTimeout(this.Tooltip.Timer);
      }, "Reset"),
      Close: /* @__PURE__ */ __name(() => {
        clearTimeout(this.Tooltip.Timer), this.Tooltip.Timer = setTimeout(() => {
          clearTimeout(this._ToolTipShowTimeout), this.Tooltip.Hide();
        }, this.Options.Tooltip.Timeout);
      }, "Close"),
      Refresh: /* @__PURE__ */ __name(() => {
        if (this.Tooltip.TipPrev === this.Tooltip.Tip)
          return;
        this.Options.Tooltip.TipPrev = this.Tooltip.Tip;
        let Tip = this.Tooltip.Tip;
        this.ChartTooltip.innerHTML = this.Tooltip.Format.call(this, Tip), Tip.Width = this.ChartTooltip.clientWidth, Tip.Height = this.ChartTooltip.clientHeight, Tip.Left = Tip.x - 30, Tip.Top = Tip.y - 20 - Tip.Height, this.ChartTooltip.style.left = Tip.Left + "px", this.ChartTooltip.style.top = Tip.Top + "px", Tip.Left + Tip.Width >= Tip.SvgWidth ? (this.ChartTooltip.classList.add("reverse"), Tip.Left = Tip.x + 30 - Tip.Width, this.ChartTooltip.style.left = Tip.Left + "px", this.ChartTooltip.style.top = Tip.Top + "px") : this.ChartTooltip.classList.remove("reverse"), this.Tooltip.Show();
      }, "Refresh")
    });
  }
};
__name(_BChartContent, "BChartContent");
let BChartContent = _BChartContent;
const _ChartContentGraph = class _ChartContentGraph extends BChartContent {
  GenContentProps() {
    this.ChartGrid = LibraryDOM.Select(".chart-grid", this.Content), this.AxisX = LibraryDOM.Select(".axis-x", this.Content), this.AxisYLeft = LibraryDOM.Select(".hook-axis-y.left", this.Content), this.AxisYRight = LibraryDOM.Select(".hook-axis-y.right", this.Content), this.StickV = LibraryDOM.Select(".v-stick", this.Content);
  }
  GetPathLine(Points, Episode, line, Options) {
    const n = Points.length;
    let xs = [], ys = [], dys = [], dxs = [], ds = [], ms = [];
    for (let i = 0; i < n; i++)
      xs[i] = Points[i][0], ys[i] = Points[i][1];
    for (let i = 0; i < n - 1; i++)
      dys[i] = ys[i + 1] - ys[i], dxs[i] = xs[i + 1] - xs[i], ds[i] = dys[i] / dxs[i];
    ms[0] = ds[0], ms[n - 1] = ds[n - 2];
    for (let i = 1; i < n - 1; i++)
      ds[i] === 0 || ds[i - 1] === 0 || ds[i - 1] > 0 != ds[i] > 0 ? ms[i] = 0 : (ms[i] = 3 * (dxs[i - 1] + dxs[i]) / ((2 * dxs[i] + dxs[i - 1]) / ds[i - 1] + (dxs[i] + 2 * dxs[i - 1]) / ds[i]), isFinite(ms[i]) || (ms[i] = 0));
    let d = `M ${xs[0]},${ys[0]}`, CSSAnimation = this.Options.Animation.Line, CSSAnimationMark = this.Options.Animation.Marker;
    CSSAnimation = Options.Animation === !1 ? "" : CSSAnimation, CSSAnimationMark = Options.Animation === !1 ? "" : CSSAnimationMark;
    let dots = '<g class="chart-markers">';
    for (let i = 0; i < n - 1; i++)
      d += ` C ${xs[i] + dxs[i] / 3},${ys[i] + ms[i] * dxs[i] / 3} ${xs[i + 1] - dxs[i] / 3},${ys[i + 1] - ms[i + 1] * dxs[i] / 3} ${xs[i + 1]},${ys[i + 1]}`, Episode.Marker.Visible && (dots += `<circle class="chart-marker ${CSSAnimationMark}" data-line="${line}" data-item="${i}" cx="${xs[i]}" cy="${ys[i]}" r="${Episode.Marker.Radius}" stroke="${Episode.Color}" stroke-width="2" fill="#fff" ></circle>`);
    return Episode.Marker.Visible && (dots += `<circle class="chart-marker" data-line="${line}" data-item="${n - 1}" cx="${xs[n - 1]}" cy="${ys[n - 1]}" r="${Episode.Marker.Radius}" stroke="${Episode.Color}" stroke-width="2" fill="#fff" ></circle>`), dots += "</g>", `<g class="chart-episode"><path class="${CSSAnimation}" data-line="${line}" d="${d}" fill="none" stroke="${Episode.Color}" stroke-width="${Episode.Width}"></path> ${dots}</g>`;
  }
  GetPathLineMarker(x, y, i, j, color, width) {
    return `<circle class="chart-marker" data-line="${i}" data-item="${j}" cx="${x}" cy="${y}" r="${width}" stroke="${color}" stroke-width="2" fill="#fff" ></circle>`;
  }
  GetPathBar(Points, Episode, line, Options) {
    let BarCount = this.Options._Series.Bar.Count, BarCountPrepared = this.Options._Series.Bar.CountPrepared, deilmit = 1;
    this.Options.SeriesOptions.BarStack || (deilmit = BarCount * 1);
    let axisXlength = this.Options.AxisX.Data.length;
    axisXlength === 0 && (axisXlength = Points.length);
    let wd = Math.round(this.HookChart.clientWidth / Points.length / 2 / deilmit);
    Episode.Width && (wd = Episode.Width);
    let height = this.HookChart.clientHeight, margin = wd * 1.2 * BarCountPrepared - (wd * 1.2 * BarCount / 2 - wd * 1.2 / 2);
    this.Options.SeriesOptions.BarStack && (margin = 0);
    let CSSAnimation = this.Options.Animation.Bar;
    CSSAnimation = Options.Animation === !1 ? "" : CSSAnimation;
    let bricks = `<g class="chart-episode ${CSSAnimation}" data-type="bar" data-line="${line}">`, GradientId = "";
    this.Options.SeriesOptions.BarGradient && (GradientId = `lc-gradient-${LibraryNumber.GetID()}`, bricks += `<linearGradient id="${GradientId}"  x1="0" y1="0%"><stop offset="0%" stop-color="rgba(0,0,0,0.2)"/><stop offset="33%" stop-color="rgba(255,255,255,0.2)"/><stop offset="100%" stop-color="rgba(0,0,0,0.3)"/></linearGradient>`);
    let dots = "";
    for (let i = 0; i < Points.length; i++) {
      let ID = LibraryNumber.GetID(), Px = margin + Points[i][0] - wd / 2, Py = Points[i][1], h = height - Points[i][1];
      wd > 1 && (Px = Math.round(Px), Py = Math.round(Py), h = Math.round(h));
      let color = Episode.Color;
      Episode.Colors && Episode.Colors[i] && (color = Episode.Colors[i]), bricks += `<g class="lc-bar-elem"><rect class="chart-bar-elem" id="chart-b-${ID}" x="${Px}" y="${Py}" width="${wd}" height="${h}" fill="${color}" data-line="${line}" data-item="${i}"></rect>`, this.Options.SeriesOptions.BarGradient && (bricks += `<rect class="chart-bar-elem-gradient " id="chart-bg-${ID}" x="${Px}" y="${Py}" width="${wd}" height="${h}" fill="url(#${GradientId})" data-line="${line}" data-item="${i}"></rect>`), bricks += "</g>";
    }
    return bricks += dots + "</g>", this.Options._Series.Bar.CountPrepared++, bricks;
  }
  GetPathBuilder(Type) {
    switch (Type) {
      case "line":
        return this.GetPathLine.bind(this);
      case "bar":
        return this.GetPathBar.bind(this);
      default:
        return this.GetPathLine.bind(this);
    }
  }
  /*content's*/
  GetSeries() {
    this.Options.Graph = this.Options.Series.filter((s) => LuffChartInitializer.isGraph(s.Type));
  }
  ChartSvgInit() {
    if (this.Options._Series.Padding = 0, this.Options._Series.Bar.Count = this.Options.Series.filter((s) => s.Type === "bar").length, this.Options._Series.Bar.Count > 0) {
      this.Options._Series.Bar.Delimit = 1, this.Options.SeriesOptions.BarStack || (this.Options._Series.Bar.Delimit = this.Options._Series.Bar.Count * 0.8);
      let xLength = this.Options.AxisX.Data.length;
      xLength === 0 && (xLength = Math.max.apply(null, this.Options.Series.map((x) => x.Data.length))), this.Options.SeriesOptions.Width = this.HookChart.clientWidth / xLength / 2 / this.Options._Series.Bar.Delimit, this.Options._Series.Bar.Count === 1 ? this.Options._Series.Padding = this.Options.SeriesOptions.Width / 2 : this.Options._Series.Padding = this.Options.SeriesOptions.Width * 1.2 / 2 * this.Options._Series.Bar.Count;
    }
    this.AxisX && (this.AxisX.style.paddingLeft = this.Options._Series.Padding + "px", this.AxisX.style.paddingRight = this.Options._Series.Padding + "px"), this.Options.Svg.Rect = this.HookChart.getBoundingClientRect(), this.ChartGrid.classList.remove("no-right"), this._AxisYHtmlRight !== "" && this.ChartGrid.classList.add("no-right"), this.Options.Title ? this.ChartName.style.display = "" : this.ChartName.style.display = "none";
  }
  MakeLegend() {
    if (this.Options.Legend.Visible) {
      this._LegendHtml = "";
      for (let i = 0; i < this.Options.Graph.length; i++) {
        let Episode = this.Options.Graph[i], Name = Episode.Name, Value = Episode.Data[i], Color = Episode.Color, ValueFormatted = Name;
        Episode.Format !== null && (ValueFormatted = Episode.Format.call(this.Chart, Name, Value, Episode, i));
        let checked = this.Options.Series[i].Visible ? 'checked="checked"' : "";
        this._LegendHtml += `<div class="legend-item">
                <input class="legend-checkbox" type="checkbox" ${checked} id="legend-ch-${this.ID}-${i}" data-line="${i}" data-name="${Name}">
                <label class="legend-label" for="legend-ch-${this.ID}-${i}">
                    <div class="legend-icon" style="background-color: ${Color}"></div>
                    <div>${ValueFormatted}</div>
                </label>
              </div>`;
      }
      this._LegendHtml = `<div class="legend-box">${this._LegendHtml}</div>`;
    }
  }
  MakeAxisX(AutoSkipCoeff = 0, stack = 0) {
    if (!this.Options.AxisX.Visible) {
      this._AxisXHtml = "";
      return;
    }
    stack++;
    let LabelList = this.Options.AxisX.Data, Len = LabelList.length, AxisHtml = "", GridLineHtml = "", FullTextLabels = "", MaxLengthLabel = "", LabelCount = 0, WidthTextList = [];
    if (this.Options.AxisX.SkipFn) {
      let Weight = 0, Weights = [], LList = LabelList.filter((l, i) => {
        let Cond = !this.Options.AxisX.SkipFn.call(this.Chart, l) || +(i > 0) % this.Options.AxisX.Skip === 0 || AutoSkipCoeff > 0 && i % AutoSkipCoeff === 0;
        return Cond ? (Weight > 0 && Weights.push(Weight), Weight = 1) : Weight++, Cond;
      }), LabelCount2 = LList.length;
      Weights.push(Weight - 1);
      for (let i = 0; i < LList.length; i++) {
        let ValueFormatted = this.Options.AxisX.Format !== null ? this.Options.AxisX.Format.call(this.Chart, LList[i]) : LList[i], w = Weights[i] * 1 / LabelCount2;
        AxisHtml += `<div class="axis-x-label no-linear ${ValueFormatted.toString().length > 0 ? "" : "label-empty"}" style="flex: ${w}"><span class="axis-x-label-text">${ValueFormatted}</span></div>`, GridLineHtml += `<div class="chart-grid-cell" style="flex: ${w}"></div>`;
      }
    } else
      for (let i = 0; i < Len; i++)
        if (i % this.Options.AxisX.Skip === 0 || this.Options.AxisX.Skip === null || AutoSkipCoeff === 0 || this.Options.AxisX.Skip === null && AutoSkipCoeff > 0 && i % AutoSkipCoeff === 0) {
          let ValueFormatted = (this.Options.AxisX.Format !== null ? this.Options.AxisX.Format.call(this, LabelList[i]) : LabelList[i]).toString(), LabelText = ValueFormatted, LabelElem = LibraryDOM.CreateElementFromString(ValueFormatted);
          LabelElem !== void 0 && (LabelText = LabelElem.innerText), WidthTextList.push(LibraryString.GetTextWidth(LabelText)), AxisHtml += `<div class="axis-x-label ${ValueFormatted.toString().length > 0 ? "" : "label-empty"}"><span class="axis-x-label-text" style="left: %MarginText%px">${ValueFormatted}</span></div>`, FullTextLabels += " " + ValueFormatted, LabelCount++, MaxLengthLabel.length < LabelText.length && (MaxLengthLabel = LabelText), i > 0 && (GridLineHtml += '<div class="chart-grid-cell"></div>');
        }
    this.AxisX.style.setProperty("--axis-x-label-rotation", "0deg"), this.AxisX.style.setProperty("--axis-x-label-translateX", "0px"), this.AxisX.style.setProperty("--axis-x-label-translateY", "0px"), this.AxisX.style.setProperty("--axis-x-label-height", "auto");
    let st = window.getComputedStyle(this.AxisX), wt = LibraryString.GetTextWidth(FullTextLabels, st.fontFamily, st.fontSize) * 1.05, MaxPossibleLabelWidth = this.AxisX.clientWidth / LabelCount * 0.85, WidestLabelWidth = LibraryString.GetTextWidth(MaxLengthLabel, st.fontFamily, st.fontSize), AngleDeg = 7, AngleRad = AngleDeg * Math.PI / 180;
    if (this.Options.AxisX.Visible && WidestLabelWidth > MaxPossibleLabelWidth) {
      let d = (wt - this.AxisX.clientWidth) / LabelCount, AngleCos = MaxPossibleLabelWidth / WidestLabelWidth;
      AngleRad = Math.acos(AngleCos), AngleRad = AngleRad * 10 / 9, AngleRad = AngleRad > Math.PI / 2 ? Math.PI / 2 : AngleRad, AngleDeg = AngleRad * 180 / Math.PI;
      let sin2 = Math.sin(AngleRad), cos2 = Math.cos(AngleRad), Y = sin2 * (WidestLabelWidth / 2), X = -d / 2, wh = sin2 * WidestLabelWidth + cos2 * 16;
      this.AxisX.style.setProperty("--axis-x-label-rotation", `-${AngleDeg}deg`), this.AxisX.style.setProperty("--axis-x-label-translateX", `${X}px`), this.AxisX.style.setProperty("--axis-x-label-translateY", `${Y}px`), this.AxisX.style.setProperty("--axis-x-label-height", `${wh}px`);
    }
    let cos = Math.cos(AngleRad);
    for (let wid of WidthTextList) {
      let val = -wid * cos / 2;
      AxisHtml = AxisHtml.replace("%MarginText%", val.toString());
    }
    this._AxisXHtml = AxisHtml, this._GridHtmlLine = GridLineHtml;
    const SkipCoeff = Math.ceil(parseFloat(st.lineHeight) / MaxPossibleLabelWidth);
    if (!this.Options.AxisX.SkipFn && this.Options.AxisX.Skip === null && SkipCoeff > 1 && stack < 2)
      return this.MakeAxisX(SkipCoeff, stack);
  }
  MakeAxisY() {
    let i = 0;
    if (!this.Options.AxisY.Visible && (this._AxisYHtml = "", i = 1, this.Options.Graph.filter((x) => x.AxisY).length < 1))
      return;
    let Scales = this.GetScaleY(this.HookChart.clientHeight), AxisYLeft = "", AxisYRight = "";
    for (this._AxisYHtmlLeft = "", this._AxisYHtmlRight = "", i; i < Scales.length; i++) {
      let Scale = Scales[i], caption = `<div class="y axis-y-caption">
    <div class="axis-y-caption-value">${i > 0 ? this.Options.Graph[Scale.SIndex].Title : this.Options.Title}</div>
</div>`, a = "";
      for (let j = 0; j < Scale.Values.length; j++)
        a += `<div class="axis-y-label"><span class="axis-y-label-text">${Scale.Values[j]}</span></div>`;
      let Axis = `<div class="axis-y" ${i > 0 ? 'style="color: ' + this.Options.Graph[Scale.SIndex].Color + '; font-weight: bold;"' : ""} data-line="${i}">
    ${caption}
    <div class="axis-y-labels">${a}</div>
</div>`;
      Scale.SIndex < 0 && this.Options.AxisY.Position === "left" ? AxisYLeft += Axis : Scale.SIndex < 0 && this.Options.AxisY.Position === "right" ? AxisYRight += Axis : Scale.SIndex > -1 && this.Options.Graph[Scale.SIndex].AxisY.Position !== "right" ? AxisYLeft += Axis : Scale.SIndex > -1 && this.Options.Graph[Scale.SIndex].AxisY.Position === "right" && (AxisYRight += Axis);
    }
    this._AxisYHtmlLeft = AxisYLeft, this._AxisYHtmlRight = AxisYRight;
  }
  GetScaleY(Height) {
    let Series = this.Options.Graph, DefaultScale = {
      Min: this.Options.AxisY.Min !== null ? this.Options.AxisY.Min : Number.MAX_VALUE,
      Max: this.Options.AxisY.Max !== null ? this.Options.AxisY.Max : -Number.MAX_VALUE,
      Step: this.Options.AxisY.Step !== null ? this.Options.AxisY.Step : "auto",
      StepMin: this.Options.AxisY.StepMin,
      _Min: this.Options.AxisY.Min,
      _Max: this.Options.AxisY.Max,
      _Step: this.Options.AxisY.Step,
      SIndex: -1
      //Position: this.Options.AxisY.Position,
      // Title: this.Options.Title,
      // Name: this.Options.Name,
    }, Scales = [DefaultScale];
    for (let i = 0; i < Series.length; i++) {
      let S = Series[i];
      if (!S.Visible)
        continue;
      let SData = Series[i].Data, Scale = {
        Min: SData[0],
        Max: SData[0],
        Step: "auto",
        SIndex: -1
      };
      if (S.AxisY.Visible && (Scale.SIndex = i, Scale.Min = S.AxisY.Min !== null ? S.AxisY.Min : Scale.Min, Scale.Max = S.AxisY.Max !== null ? S.AxisY.Max : Scale.Max, Scale.Step = S.AxisY.Step !== null ? S.AxisY.Step : Scale.Step, Scale._Min = S.AxisY.Min, Scale._Max = S.AxisY.Max, Scale._Step = S.AxisY.Step, Scales.push(Scale)), SData.length > 1)
        for (let j = 0; j < SData.length; j++) {
          let SValue = SData[j];
          !S.AxisY.Visible && DefaultScale._Min === null && SValue < DefaultScale.Min && (DefaultScale.Min = SValue), !S.AxisY.Visible && DefaultScale._Max === null && SValue > DefaultScale.Max && (DefaultScale.Max = SValue), S.AxisY && S.AxisY.Min === null && SValue < Scale.Min && (Scale.Min = SValue), S.AxisY && S.AxisY.Max === null && SValue > Scale.Max && (Scale.Max = SValue);
        }
      else
        DefaultScale.Min > SData[0] && (DefaultScale.Min = SData[0]), DefaultScale.Max < SData[0] && (DefaultScale.Max = SData[0]);
    }
    DefaultScale.Min === DefaultScale.Max && (DefaultScale.Min >= 0 ? DefaultScale.Min = 0 : DefaultScale.Max = 0);
    const MagicConst = 20;
    for (let i = 0; i < Scales.length; i++) {
      let Scale = Scales[i], Step = Scale.Step;
      Scale.Min === 0 && Scale.Max === 0 && (Scale.Max = 1);
      let OrderMax = LibraryNumber.GetNumberOrder(Scale.Max);
      if (Step === "auto") {
        let dy = Scale.Max - Scale.Min, Rounder = 5 * Math.pow(10, OrderMax - 2);
        if (Rounder >= dy) {
          let order = OrderMax - 3;
          for (Rounder = 5 * Math.pow(10, order); Rounder > dy; )
            Rounder = 5 * Math.pow(10, order), order--;
        }
        Step = LibraryNumber.RoundBy(dy * MagicConst / Height, Rounder), Scale.Max = LibraryNumber.RoundBy(Scale.Max, Rounder, "ceil"), Scale.Min = LibraryNumber.RoundBy(Scale.Min, Rounder, "floor");
      }
      if (Scale._Min === "auto" && OrderMax > -1 && Scale.Min % 5 > 0) {
        let OrderMin = LibraryNumber.GetNumberOrder(Scale.Max), ToFixed2 = OrderMin < 0 ? -OrderMin : 0;
        Scale.Min = LibraryNumber.RoundBy(Scale.Min, Step) - Step, Scale.Min = parseFloat(Scale.Min.toFixed(2 + ToFixed2).replace(".00" + "0".repeat(ToFixed2), ""));
      }
      let ToFixed = OrderMax < 0 ? -OrderMax : 0, ScaleValues = [], StageValue = Scale.Min, lim = 0;
      for (Scale.Min === Scale.Max && (Step = 1), Math.abs(Step) < Math.abs(DefaultScale.StepMin) && (Step = DefaultScale.StepMin); Step !== 0 && (StageValue <= Scale.Max && Scale._Max === "auto" || StageValue < Scale.Max && Scale._Max !== "auto") && lim < 1e4; )
        lim++, ScaleValues.push(StageValue), StageValue += Step, StageValue = parseFloat(StageValue.toFixed(2 + ToFixed).replace(".00" + "0".repeat(ToFixed), ""));
      lim >= 1e3 && console.warn("Chart.GetScaleYError", this), ScaleValues.push(StageValue), Scale.Values = ScaleValues;
    }
    return this._Scales = Scales, Scales;
  }
  MakeGrid() {
    if (this.Options.Grid.Html = "", !this.Options.Grid.Visible)
      return;
    this.Options._Series.Padding > 0 && (this._GridHtmlLine = `<div class="chart-grid-cell" style="min-width: ${this.Options._Series.Padding}px; flex: 0;"></div>` + this._GridHtmlLine, this._GridHtmlLine += `<div class="chart-grid-cell" style="min-width: ${this.Options._Series.Padding}px; flex: 0;"></div>`);
    let SizeY = this._Scales[0].Values.length - 1, Grid = "";
    for (let i = 0; i < SizeY; i++)
      Grid += `<div class="chart-grid-line" >${this._GridHtmlLine}</div>`;
    this.Options.Grid.Html = Grid, this.ChartGrid.innerHTML = this.Options.Grid.Html;
  }
  MakeSvg(Options) {
    let svgHeight = this.HookChart.clientHeight;
    svgHeight < 1 && (svgHeight = 100);
    const svgWidth = this.HookChart.clientWidth;
    this._SvgHtml = "", this.Options._Series.Line.CountPrepared = 0, this.Options._Series.Bar.CountPrepared = 0, this.Options._Series.Pie.CountPrepared = 0;
    for (let i = 0; i < this.Options.Graph.length; i++) {
      let Episode = this.Options.Graph[i];
      if (!Episode.Visible)
        continue;
      let Scale = this._Scales.find((x) => x.SIndex === i), Ys = this.GetValuesY(Episode, Scale, this._Scales[0], svgHeight), Xs = this.GetValuesX(Episode, svgWidth);
      Episode.Points = this.GetPoints(Xs, Ys);
      const getPath = this.GetPathBuilder(Episode.Type);
      this._SvgHtml += getPath(Episode.Points, Episode, i, Options);
    }
    this.ChartSvg.innerHTML = this._SvgHtml;
  }
  GetTip(ValueX, EpisodeNum, ValueNum) {
    let Episode = this.Options.Tooltip.Episode, Points = Episode.Points, Index = Math.round(ValueX / Points[Points.length - 1][0] * (Points.length - 1));
    Index > Points.length - 1 && (Index = Points.length - 1), Index < 1 && (Index = 0);
    let TipPrev = this.Options.Tooltip.TipPrev, Tip = {
      Name: Episode.Name,
      Color: Episode.Color,
      ValueX: Episode.AxisX.Data[Index],
      ValueY: Episode.Data[Index],
      Value: Episode.Data[Index],
      Episode,
      x: Points[Index][0],
      y: Points[Index][1],
      SvgWidth: this.HookChart.clientWidth,
      SvgHeight: this.HookChart.clientHeight,
      EpisodeIndex: Episode.Line,
      ValueIndex: Index,
      TipPrev
    };
    return TipPrev && TipPrev.x === Tip.x && TipPrev.y === Tip.y ? TipPrev : Tip;
  }
  FillLegend() {
    this.Options.Legend.Visible && (this.ChartLegend.innerHTML = this._LegendHtml);
  }
  FillAxisX() {
    this.Options.AxisX.Visible && (this.AxisX.innerHTML = this._AxisXHtml);
  }
  FillAxisY() {
    this.Options.AxisY.Visible && (this.AxisYLeft.innerHTML = this._AxisYHtmlLeft, this.AxisYRight.innerHTML = this._AxisYHtmlRight);
  }
  Fill() {
    this.ChartName.innerHTML = this.Options.Title, this.FillLegend(), this.FillAxisX(), this.FillAxisY();
  }
  Refresh(Options = { Animation: !0 }) {
    this.MakeAxisX(), this.MakeAxisY(), this.MakeGrid(), this.FillAxisY(), this.MakeSvg(Options);
  }
  Redraw(Options = { Animation: !0 }) {
    this.GetSeries(), this.MakeLegend(), this.MakeAxisX(0, 2), this.MakeAxisY(), (this.Options.Legend.Position === "right" || this.Options.Legend.Position === "left") && this.FillLegend(), this.FillAxisY(), this.MakeAxisX(), this.Fill(), this.ChartSvgInit(), this.MakeSvg(Options), this.MakeGrid();
  }
  OnLegendChange(e) {
    let i = e.currentTarget.dataset.line, Episode = this.Options.Graph[i];
    if (Episode.Visible = e.currentTarget.checked, this.Options.Graph.filter((g) => g.Visible).length < 1) {
      Episode.Visible = !0, e.currentTarget.checked = !0;
      return;
    }
    this.Refresh({ Animation: !1 });
  }
  OnChartMouseMove(e) {
    if (e.target.tagName === "rect" || e.target.tagName === "path" || e.target.tagName === "circle") {
      let i = e.target.dataset.line;
      this.Options.Tooltip.Episode = this.Options.Graph[i];
    }
    if (!this.Options.Tooltip.Episode)
      return;
    this.Options.Svg.Rect = this.HookChart.getBoundingClientRect();
    let x = e.clientX - this.Options.Svg.Rect.left, EpisodeNum = e.target.dataset.line, ValueNum = e.target.dataset.item, Tip = this.GetTip(x, EpisodeNum, ValueNum);
    this.Tooltip.Tip = Tip, this.StickV.style.left = Tip.x + "px", this.Tooltip.Refresh.call(this);
  }
  constructor(Chart) {
    super(Chart), this._Rendered = {
      /** @type {AxisXLabelItem[]} */
      AxisX: [],
      Grid: []
    }, this._FirstRedraw = !0, this.Tooltip.Format = this.Tooltip.Format ? this.Tooltip.Format : LuffChartInitializer.Default.R.Tooltip.FormatGraph;
  }
};
__name(_ChartContentGraph, "ChartContentGraph");
let ChartContentGraph = _ChartContentGraph;
const _ChartContentDraw = class _ChartContentDraw extends BChartContent {
  PolarToCartesius(centerX, centerY, radius, angleInDegrees) {
    let angleInRadians = (angleInDegrees - 0) * Math.PI / 180;
    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians)
    };
  }
  GetPathPie(Options) {
    let sectors = "", Width = this.HookChart.clientWidth, Height = this.HookChart.clientHeight;
    this.Options.Legend.Position === "right" || this.Options.Legend.Position;
    let d = Height < Width ? Height : Width;
    d = d - 2;
    let PrevRadius = -1, PrevWidth = -1, CSSAnimationPie = this.Options.Animation.Pie;
    CSSAnimationPie = Options.Animation === !1 ? "" : CSSAnimationPie;
    let AnimationDuration = LibraryDOM.GetDurationAnimation(CSSAnimationPie);
    for (let i = 0; i < this.Options.Draws.length; i++) {
      if (!this.Options.Draws[i].Visible)
        continue;
      let Episode = this.Options.Draws[i], sum = 0, AngleStart = Episode.AngleStart, r = d / 2 * (this.Options.Draws.length - i) / this.Options.Draws.length, wd = 2 * r;
      Episode.Type === "pie" && i > 0 && (r = PrevRadius - PrevWidth - Episode.Margin / 2 - 0.2, r < 0 && (r = PrevRadius - i / this.Options.Draws.length * PrevRadius)), Episode.Type === "ring" && (wd = Episode.Width, i > 0 && (r = PrevRadius - (PrevWidth - 0.2) - Episode.Margin)), PrevRadius = r, PrevWidth = Episode.Type === "pie" ? Episode.Width : wd;
      let Sectors = [], SectorsCount = 0;
      Episode.Sum = 0;
      for (let j = 0; j < Episode.Data.length; j++) {
        if (Episode.Sum += Episode.Data[j], !Episode.Visibles[j]) {
          Sectors.push(null);
          continue;
        }
        SectorsCount++, Sectors.push(Episode.Data[j]), sum += Episode.Data[j];
      }
      SectorsCount < 1 && (Sectors = Episode.Data.map(() => 1)), SectorsCount = Sectors.length;
      let SectorVisibleCount = Episode.Visibles.filter((x) => x).length;
      for (let j = 0; j < Sectors.length; j++) {
        if (Sectors[j] === null)
          continue;
        let angle = Sectors[j] / sum * 360;
        sum === 0 && (angle = 360 / SectorVisibleCount), (angle === 360 || !Number.isFinite(angle)) && (angle = 359.99, AngleStart = 0);
        let style = "";
        CSSAnimationPie && (style = `opacity: 0;transform: scale(0.01,0.01) ;  animation-delay: ${j * AnimationDuration / SectorsCount / 2}ms`), sectors += "<g>", Episode.Type !== "pie" && (sectors += `<path class="${CSSAnimationPie}" style="${style}" d="${this.GetRing(Width / 2, Height / 2, r, AngleStart, AngleStart + angle, wd)}" fill="${Episode.Colors[j]}" stroke="noe" stroke-width="0" fill-opacity="1" data-type="${Episode.Type}" data-line="${i}" data-sector="${j}"></path>`, this.Options.Tooltip.Visible && (sectors += `<path class="chart-hover ${CSSAnimationPie}" style="${style}" data-type="pie" data-line="${i}" data-item="${j}" d="${this.GetRing(Width / 2, Height / 2, r, AngleStart, AngleStart + angle, wd)}" fill="#fff" stroke="none" stroke-width="0" fill-opacity="0" data-line="${i}" data-sector="${j}"></path>`)), Episode.Type === "pie" && (sectors += `<path class="${CSSAnimationPie}" style="${style}" d="${this.GetSector(Width / 2, Height / 2, r, AngleStart, AngleStart + angle)}" fill="${Episode.Colors[j]}" stroke="none" data-type="${Episode.Type}" data-line="${i}" data-sector="${j}"></path>`, this.Options.Tooltip.Visible && (sectors += `<path class="chart-hover ${CSSAnimationPie}" style="${style}" data-type="pie" data-line="${i}" data-item="${j}" d="${this.GetSector(Width / 2, Height / 2, r, AngleStart, AngleStart + angle)}" fill="#fff" stroke="none"  stroke-width="0" fill-opacity="0" data-line="${i}" data-sector="${j}"></path>`)), sectors += "</g>", AngleStart += angle;
      }
    }
    return sectors;
  }
  GetArc(x, y, radius, startAngle, endAngle) {
    let start = this.PolarToCartesius(x, y, radius, endAngle), end = this.PolarToCartesius(x, y, radius, startAngle), largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArcFlag} 0 ${end.x} ${end.y}`;
  }
  GetSector(x, y, radius, startAngle, endAngle) {
    let start = this.PolarToCartesius(x, y, radius, endAngle), end = this.PolarToCartesius(x, y, radius, startAngle), largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    return [
      "M",
      start.x,
      start.y,
      "A",
      radius,
      radius,
      0,
      largeArcFlag,
      0,
      end.x,
      end.y,
      "L",
      x,
      y,
      "Z"
    ].join(" ");
  }
  GetRing(x, y, radius, startAngle, endAngle, width) {
    let start = this.PolarToCartesius(x, y, radius, endAngle), end = this.PolarToCartesius(x, y, radius, startAngle), start1 = this.PolarToCartesius(x, y, radius - width, endAngle), end1 = this.PolarToCartesius(x, y, radius - width, startAngle), largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    return [
      "M",
      start.x,
      start.y,
      "A",
      radius,
      radius,
      0,
      largeArcFlag,
      0,
      end.x,
      end.y,
      "L",
      end1.x,
      end1.y,
      "M",
      end1.x,
      end1.y,
      "A",
      radius - width,
      radius - width,
      0,
      largeArcFlag,
      1,
      start1.x,
      start1.y,
      "L",
      start.x,
      start.y
    ].join(" ");
  }
  GetContent() {
    let HTMLLegend = '<div class="legend"></div>';
    return LibraryDOM.CreateElementFromString(`<div class="l-chart l-col">
                        <table class="l-chart-t">
                            <tr class="tr-hook-top">
                                <td colspan="5" class="hook-top">
                                    <div class="chart-name"></div>
                                    ${this.Options.Legend.Visible && this.Options.Legend.Position === "top" ? HTMLLegend : ""}
                                </td>
                            </tr>
                            
                            <tr class="tr-hook-mid">
                                <td>${this.Options.Legend.Visible && this.Options.Legend.Position === "left" ? HTMLLegend : ""}</td> 
                                <td rowspan="1">
                                    <div class="hook-axis-y hook left"></div>
                                </td>
                                <td rowspan="1" class="hook-chart">
                                    <div class="chart-svg-wrapper">
                                        <svg class="chart-svg"></svg>
                                    </div>
                                    <div class="chart-tooltip"></div>
                                </td> 
                                <td rowspan="1">
                                    <div class="hook-axis-y hook right"></div>
                                </td> 
                                <td>${this.Options.Legend.Visible && this.Options.Legend.Position === "right" ? HTMLLegend : ""}</td>
                            </tr>
                             
                            <tr class="tr-hook-bottom">
                                <td colspan="5" class="td-hook-bottom">
                                    ${this.Options.Legend.Visible && this.Options.Legend.Position === "bottom" ? HTMLLegend : ""}
                                </td> 
                            </tr>
                        </table>
                      </div>`);
  }
  GenContentProps() {
  }
  /*content's*/
  GetSeries() {
    this.Options.Draws = this.Options.Series.filter((s) => LuffChartInitializer.isDraw(s.Type));
  }
  ChartSvgInit() {
    this.Options.Svg.Rect = this.HookChart.getBoundingClientRect(), this.Options.Title === "" ? this.ChartName.style.display = "none" : this.ChartName.style.display = "";
  }
  MakeLegend() {
    if (this.Options.Legend.Visible) {
      this._LegendHtml = "";
      for (let i = 0; i < this.Options.Draws.length; i++) {
        let Episode = this.Options.Draws[i], l = "";
        for (let j = 0; j < Episode.Labels.Data.length; j++) {
          let Name = Episode.Labels.Data[j], Value = Episode.Data[j], ValueFormatted = Name;
          Episode.Labels.Format !== null && (ValueFormatted = Episode.Labels.Format.call(this.Chart, Name, Value, Episode, j));
          let Color = Episode.Colors[j] ? Episode.Colors[j] : `#${LibraryNumber.GetRandom(1e5, 999999)}`, checked = this.Options.Series[i].Visibles[j] ? 'checked="checked"' : "";
          l += `<div class="legend-item">
                                  <input class="legend-checkbox" type="checkbox" ${checked} id="legend-ch-${this.ID}-${i}-${j}" data-line="${i}" data-sector="${j}">
                                  <label class="legend-label" for="legend-ch-${this.ID}-${i}-${j}">
                                     <div class="legend-icon" style="background-color: ${Color}"></div>
                                     <div>${ValueFormatted}</div>
                                  </label>
                                </div>`;
        }
        this._LegendHtml += `<div class="legend-box">${l}</div>`;
      }
    }
  }
  MakeSvg(Options) {
    this.Options._Series.Pie.CountPrepared = 0, this._SvgHtml = this.GetPathPie(Options), this.ChartSvg.innerHTML = this._SvgHtml;
  }
  Fill() {
    this.ChartName.innerHTML = this.Options.Title, this.Options.Legend.Visible && (this.ChartLegend.innerHTML = this._LegendHtml);
  }
  Refresh(Options = { Animation: !0 }) {
    this.MakeSvg(Options);
  }
  Redraw(Options = { Animation: !0 }) {
    this.GetSeries(), this.MakeLegend(), this.Fill(), this.ChartSvgInit(), this.MakeSvg(Options);
  }
  OnLegendChange(e) {
    let i = e.currentTarget.dataset.line, j = e.currentTarget.dataset.sector, Episode = this.Options.Draws[i];
    if (Episode.Visibles[j] = e.currentTarget.checked, Episode.Visibles.filter((x) => x).length < 1) {
      Episode.Visibles[j] = !0, e.currentTarget.checked = !0;
      return;
    }
    this.Refresh({ Animation: !1 });
  }
  OnChartMouseMove(e) {
    if (window.clearTimeout(this._ToolTipShowTimeout), this._ToolTipShowTimeout = window.setTimeout(() => {
    }, 50), e.target.tagName.toLowerCase() !== "path")
      return !1;
    let i = e.target.dataset.line, j = e.target.dataset.sector;
    if (this.Options.Tooltip.Episode = this.Options.Draws[i], this.Options.Svg.Rect = this.HookChart.getBoundingClientRect(), !this.Options.Tooltip.Episode)
      return !1;
    let x = e.offsetX, y = e.offsetY, EpisodeNum = e.target.dataset.line, ValueNum = e.target.dataset.item;
    this.Tooltip.Tip = {
      Name: this.Options.Tooltip.Episode.Labels.Data[j],
      Label: this.Options.Tooltip.Episode.Labels.Data[j],
      Color: this.Options.Tooltip.Episode.Colors[j],
      ValueX: this.Options.Tooltip.Episode.Labels.Data[j],
      ValueY: this.Options.Tooltip.Episode.Data[j],
      Value: this.Options.Tooltip.Episode.Data[j],
      Episode: this.Options.Tooltip.Episode,
      x,
      y,
      SvgWidth: this.HookChart.clientWidth,
      SvgHeight: this.HookChart.clientHeight,
      EpisodeNum,
      ValueNum
    }, this.Tooltip.Refresh();
  }
  constructor(Chart) {
    super(Chart), this.Tooltip.Format = this.Tooltip.Format ? this.Tooltip.Format : LuffChartInitializer.Default.R.Tooltip.FormatDraws;
  }
};
__name(_ChartContentDraw, "ChartContentDraw");
let ChartContentDraw = _ChartContentDraw;
const DELAY_REDRAW = 50, _LuffChart = class _LuffChart extends Luff.Content {
  // AfterBuild() : void {
  //     this.Redraw();
  //     console.log('[Luff.Chart] AfterBuild');
  // }
  OnAppear() {
    this.Redraw();
  }
  _Redraw(options) {
    this._ContentManager.Content.clientHeight && (this._locked = !0, this._ContentManager.Redraw(options), setTimeout(() => {
      this._locked = !1;
    }));
  }
  Redraw(options) {
    clearTimeout(this._TimeoutRedraw), this._TimeoutRedraw = window.setTimeout(() => {
      this._Redraw(options);
    }, DELAY_REDRAW);
  }
  Refresh(Options) {
    if (!this._ContentManager.Options.Graph && !this._ContentManager.Options.Draws)
      return this._ContentManager.Redraw(Options);
    this._locked = !0, this._ContentManager.Refresh(Options), setTimeout(() => {
      this._locked = !1;
    });
  }
  SerieSwitch(SeriesNumber, SectorNumber) {
    let Series = this.Options.Series[SeriesNumber], LegendID = `legend-ch-${this._ContentManager.ID}-${SeriesNumber}`, isChecked;
    Series.Type === "pie" || Series.Type === "ring" ? (LegendID = `legend-ch-${this._ContentManager.ID}-${SeriesNumber}-${SectorNumber}`, isChecked = !this.Options.Series[SeriesNumber].Visibles[SectorNumber], this.Options.Series[SeriesNumber].Visibles[SectorNumber] = isChecked) : (isChecked = !this.Options.Series[SeriesNumber].Visible, this.Options.Series[SeriesNumber].Visible = isChecked);
    let Checkbox = document.getElementById(LegendID);
    Checkbox && (Checkbox.checked = isChecked), this.Refresh({ Animation: !1 });
  }
  get Series() {
    return this.Options.Series;
  }
  set Series(se) {
    this.Options.Series = se, LuffChartInitializer.GetSeries(this.Options);
  }
  SetSeries(series, hasRedrawAnimation = !1) {
    this.Options.Series = series, LuffChartInitializer.GetSeries(this.Options), this.Redraw({ Animation: hasRedrawAnimation });
  }
  // componentDidUpdate(prevProps: Readonly<TLuffChart>, prevState: Readonly<{}>, snapshot?: any): void {
  //     //console.log('componentDidUpdate', this.props);
  //     if (this._Chart) {
  //         this._Chart.Series = this.props.options.Series;
  //         this._Chart.Redraw({Animation: false});
  //     }
  // }
  ChartCtor(R) {
    this._t = window.performance.now(), !R.Disabled && (this._locked = !1, this.Target = LibraryDOM.Select(R.Target), LuffChartInitializer.InitR.call(this, R), this.isGraph ? this._ContentManager = new ChartContentGraph(this) : this._ContentManager = new ChartContentDraw(this));
  }
  _GenerateDOM() {
    super._GenerateDOM();
    let ctor = this.props.options;
    return ctor.Target = this.GetFirstParentDOM(), this.ChartCtor(ctor), this.DOM = this._ContentManager.Content, this.AfterBuild(), this.DOM;
  }
};
__name(_LuffChart, "LuffChart");
let LuffChart = _LuffChart;
LuffChart.Type = {
  Line: "line",
  Bar: "bar",
  Ring: "ring",
  Pie: "pie"
};
LuffChart.LegendPosition = {
  Top: "top",
  Left: "left",
  Right: "right",
  Bottom: "bottom"
};
var HintDirection;
(function(HintDirection2) {
  HintDirection2[HintDirection2.BottomRight = 1] = "BottomRight";
})(HintDirection || (HintDirection = {}));
const MARGIN_X = 15, MARGIN_Y = 8, _LuffHint = class _LuffHint {
  static PopHint(hint) {
    const dom = _LuffHint.GetHintDefault(hint);
    _LuffHint.HideHintDefault(dom, hint);
  }
  static GetHintDefault(hint) {
    const dom = LibraryDOM.CreateElementFromString(`<div class="l-flow-hint ${hint.ClassName}">${hint.Text}</div>`);
    return _LuffHint.SetHintPosition(dom, hint), dom.style.opacity = "1", dom;
  }
  static SetHintPosition(hintDom, hint) {
    const rect = hint.OnElement.getBoundingClientRect();
    let rectContainment = hint.TargetArea.getBoundingClientRect();
    hintDom.isConnected || hint.TargetArea.appendChild(hintDom);
    const rectHint = hintDom.getBoundingClientRect();
    let direction = hint.Direction;
    const margin = hint.Margin;
    if (hint.IsContainment) {
      let directions = direction.split("-");
      rect.y + rect.height + rectHint.height + margin.y > rectContainment.y + rectContainment.height ? directions[0] = "top" : rect.y - rectHint.height - margin.y < rectContainment.y && (directions[0] = "bottom"), rect.x + rect.width + rectHint.width + margin.x > rectContainment.x + rectContainment.width && (directions[1] = "left"), rect.x - rectHint.width - margin.x < rectContainment.x && (directions[1] = "right"), hintDom.classList.remove(direction), direction = directions.join("-"), hintDom.classList.add(direction);
    }
    const Pos = _LuffHint.GetPos(direction, rect, rectHint, rectContainment, margin);
    hintDom.style.left = Pos.x + "px", hintDom.style.top = Pos.y + "px";
  }
  static GetPos(direction, rect, rectHint, rectContainment, margin) {
    let PosX = -rectContainment.x, PosY = -rectContainment.y;
    return direction === "bottom-right" ? (PosX += rect.x + rect.width / 2 + margin.x - MARGIN_X, PosY += rect.y + rect.height + margin.y + MARGIN_Y) : direction === "bottom-left" ? (PosX += rect.x - rectHint.width + rect.width / 2 - margin.x + MARGIN_X, PosY += rect.y + rect.height + margin.y + MARGIN_Y) : direction === "top-right" ? (PosX += rect.x + rect.width / 2 + margin.x - MARGIN_X, PosY += rect.y - rectHint.height - margin.y - MARGIN_Y) : direction === "top-left" && (PosX += rect.x - rectHint.width + rect.width / 2 - margin.x + MARGIN_X, PosY += rect.y - rectHint.height - margin.y - MARGIN_Y), {
      x: PosX,
      y: PosY
    };
  }
  static HideHintDefault(hintDom, hint) {
    window.setTimeout(() => {
      hintDom.style.opacity = "0";
      const animDuration = LibraryDOM.GetDurationAnimation("l-flow-hint");
      setTimeout(() => {
        hintDom.remove();
      }, animDuration);
    }, hint.Duration);
  }
  RunListening() {
    return this.Config.TargetArea.addEventListener("mouseover", this._ListenToShowSafeContext), !0;
  }
  StopListening() {
    return this.Config.TargetArea.removeEventListener("mouseover", this._ListenToShowSafeContext), !1;
  }
  _ListenToShow(e) {
    const hint = e.target.closest(this.Config.QuerySelector);
    if (hint) {
      const hintID = parseInt(hint.dataset.luffHintID);
      let hintPack;
      hintID > 0 ? hintPack = this._HintDict[hintID] : (hintPack = {
        ID: this._HintCounter++,
        Target: hint,
        Hint: null,
        TimeoutToShow: null,
        TimeoutToHide: null
      }, this._HintDict[hintPack.ID] = hintPack, hintPack.Target.dataset.luffHintId = hintPack.ID.toString(), hintPack.Target.addEventListener("mouseleave", (e2) => this._ListenToHide(e2, hintPack))), clearTimeout(hintPack.TimeoutToHide), clearTimeout(hintPack.TimeoutToShow), hintPack.TimeoutToShow = window.setTimeout(() => {
        this._Show(hintPack);
      }, this.Config.Delay);
    }
  }
  _ListenToHide(e, hintPack) {
    hintPack && (hintPack.TimeoutToHide = window.setTimeout(() => {
      this._Hide(hintPack);
    }, this.Config.Duration));
  }
  _GetPos(direction, rect, rectHint, rectContainment) {
    return _LuffHint.GetPos(direction, rect, rectHint, rectContainment, this.Config.Margin);
  }
  _Show(hintPack) {
    if (hintPack.Hint || (hintPack.Hint = this.Config.Render(hintPack)), hintPack.Hint === null)
      return;
    const rect = hintPack.Target.getBoundingClientRect();
    let rectContainment = this.Config.TargetArea.getBoundingClientRect();
    hintPack.Hint.parentElement || this.Config.TargetArea.appendChild(hintPack.Hint);
    const RectHint = hintPack.Hint.getBoundingClientRect();
    let direction = this.Config.Direction;
    if (this.Config.IsContainment) {
      let directions = direction.split("-");
      rect.y + rect.height + RectHint.height + this.Config.Margin.y > rectContainment.y + rectContainment.height ? directions[0] = "top" : rect.y - RectHint.height - this.Config.Margin.y < rectContainment.y && (directions[0] = "bottom"), rect.x + rect.width + RectHint.width + this.Config.Margin.x > rectContainment.x + rectContainment.width ? directions[1] = "left" : rect.x - RectHint.width - this.Config.Margin.x < rectContainment.x && (directions[1] = "right"), hintPack.Hint.classList.remove(direction), direction = directions.join("-"), hintPack.Hint.classList.add(direction);
    }
    const Pos = this._GetPos(direction, rect, RectHint, rectContainment);
    hintPack.Hint.style.left = Pos.x + "px", hintPack.Hint.style.top = Pos.y + "px", this.Config.MethodShow(hintPack.Hint);
  }
  _Hide(HintPack) {
    HintPack.Hint && (this.Config.MethodHide(HintPack.Hint), setTimeout(() => {
      HintPack.Hint.remove();
    }, this.Config.AnimationDuration));
  }
  constructor({ TargetArea = document.body, ExtraClassNames = "", QuerySelector = ".l-hint", DataProp = "hint", Direction = "top-right", Margin = { x: 0, y: 0 }, Delay = 0, Duration = 0, IsInstantRunListening = !1, IsContainment = !0, MethodShow = /* @__PURE__ */ __name((elem) => elem.style.opacity = "1", "MethodShow"), MethodHide = /* @__PURE__ */ __name((elem) => elem.style.opacity = "0", "MethodHide"), Render = /* @__PURE__ */ __name((HintPack) => {
    let HintText = HintPack.Target.dataset[this.Config.DataProp];
    return HintText === "" ? null : LibraryDOM.CreateElementFromString(`<div class="l-flow-hint ${this.Config.ExtraClassNames}"><pre>${HintText}</pre></div>`);
  }, "Render") } = {}) {
    this._HintDict = {}, this._HintCounter = 1, this._ListenToShowSafeContext = this._ListenToShow.bind(this), this.Config = {
      DataProp,
      Delay,
      Duration,
      Direction,
      Margin,
      TargetArea,
      QuerySelector,
      IsContainment,
      ExtraClassNames,
      AnimationDuration: LibraryDOM.GetDurationAnimation("l-hint-pop"),
      MethodShow,
      MethodHide,
      Render
    };
    const pos = getComputedStyle(TargetArea).position.toLowerCase();
    pos !== "absolute" && pos !== "relative" && (TargetArea.style.position = "relative"), IsInstantRunListening && this.RunListening();
  }
};
__name(_LuffHint, "LuffHint");
let LuffHint = _LuffHint;
const _CheckBox = class _CheckBox extends Luff.Content {
  get IsChecked() {
    return this.State.IsChecked.SValue;
  }
  set IsChecked(val) {
    this.State.IsChecked.SValue = val;
  }
  // get IsDisabled() : boolean {
  //     return this.State.IsDisabled.SValue;
  // }
  // set IsDisabled(val: boolean) {
  //     this.State.IsDisabled.SValue = val;
  // }
  get IsDisabled() {
    return this._IsDisabled.SValue;
  }
  set IsDisabled(val) {
    this._IsDisabled.SValue = val;
  }
  BeforeBuild() {
    initDisabled(this);
  }
  Render() {
    return React.createElement(
      React.Fragment,
      null,
      React.createElement("input", {
        type: "checkbox",
        className: "l-checkbox",
        id: "l-checkbox-id-" + this._ID,
        //checkboxGroup={this.props.radioGroup}
        compName: this.props.checkBoxGroup,
        onChange: /* @__PURE__ */ __name((e) => {
          const isChecked = e.target.checked;
          if (e.target.checked = !isChecked, this.props.onChangeAsync) {
            const wasDisabled = this.IsDisabled;
            this.IsDisabled = !0, this.props.onChangeAsync(isChecked).finally(() => this.IsDisabled = wasDisabled);
            return;
          }
          if (this.props.onChange)
            return this.props.onChange(isChecked);
          this.State.IsChecked.SValue = isChecked;
        }, "onChange"),
        checked: this.State.IsChecked,
        disabled: this._IsDisabled,
        indeterminate: this.State.IsChecked.SubState((isChecked) => isChecked == null),
        autocomplete: "nope"
      }),
      React.createElement("label", { for: "l-checkbox-id-" + this._ID, className: "l-checkbox-label " + this.props.className, style: this.props.style }, this.props.children)
    );
  }
  Ctor() {
    return {
      State: {
        IsChecked: this.props.checked,
        IsDisabled: this.props.disabled
      }
    };
  }
};
__name(_CheckBox, "CheckBox");
let CheckBox = _CheckBox;
CheckBox.defaultProps = {
  className: "",
  checked: !1,
  disabled: !1,
  indeterminate: !1,
  isPermissionWriteRequired: !1
};
const _InputBoxBase = class _InputBoxBase extends ComponentSimple {
  IsInputValidDefault() {
    return {
      IsValid: !0,
      Message: ""
    };
  }
  BeforeBuild() {
    initDisabled(this);
  }
  get IsDisabled() {
    return this._IsDisabled.SValue;
  }
  set IsDisabled(val) {
    this._IsDisabled.SValue = val;
  }
  Focus() {
    this.Input.focus();
  }
  Select() {
    this.Input.select();
  }
  AfterBuild() {
    this.Input = this.GetFirstDOM();
  }
};
__name(_InputBoxBase, "InputBoxBase");
let InputBoxBase = _InputBoxBase;
const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
function validateEmail(email) {
  return regexEmail.test(String(email).toLowerCase());
}
__name(validateEmail, "validateEmail");
const _TextBox = class _TextBox extends InputBoxBase {
  constructor() {
    super(...arguments), this.IsMasking = !1;
  }
  AfterBuild() {
    super.AfterBuild(), this.InitMask();
  }
  static IsValidEmail(text) {
    return validateEmail(text.trim());
  }
  IsInputValidDefault() {
    const { type, value } = this.props;
    return type == _TextBox.Type.Email && validateEmail(value.SValue.trim()) ? {
      IsValid: !1,
      Message: "Формат электронной почты неверен"
    } : (type == _TextBox.Type.Phone, value.SValue.trim().length == 0 ? {
      IsValid: !1,
      Message: "Поле не может быть пустым"
    } : {
      IsValid: !0,
      Message: ""
    });
  }
  InitFuck() {
    const maskPack = this.MaskPackState.SValue;
    this.pattern = maskPack.Mask, this.slot = maskPack.SlotChar || "_", this.accept = new RegExp(maskPack.AcceptRegex || "\\d", "g"), this.prev = ((j) => Array.from(this.pattern, (c, i) => c == this.slot ? j = i + 1 : j))(0), this.first = [...this.pattern].findIndex((c) => c == this.slot), this.DOM.placeholder = this.pattern;
  }
  InitMask() {
    this.props.mask && (this.IsMasking = !0);
    const el = this.DOM;
    this.IsMasking && (this.MaskPackState = Luff.State(this.props.mask), this.MaskPackState.SValue = Object.assign({ AcceptRegex: "\\d", SlotChar: "_" }, this.MaskPackState.SValue), this.MaskPackState.AddOnChange(() => {
      this.InitFuck(), this.props.value.SValue = this.CheckMask();
    }), this.IsMasking = !0, this.InitFuck(), this.Clean = (input) => (input = input.match(this.accept) || [], Array.from(this.pattern, (c) => (input[0] === c || this.slot == c) && input.shift() || c)), this.CheckMask = () => {
      const [i, j] = [el.selectionStart, el.selectionEnd].map((i2) => (i2 = this.Clean(el.value.slice(0, i2)).findIndex((c) => c == this.slot), i2 < 0 ? this.prev[this.prev.length - 1] : this.back ? this.prev[i2 - 1] || this.first : i2));
      return el.value = this.Clean(el.value).join(""), el.setSelectionRange(i, j), this.back = !1, el.value;
    }, this.back = !1), el.addEventListener("keydown", (e) => {
      this.IsMasking && (this.back = e.key === "Backspace"), this.props.onKeyDown && this.props.onKeyDown(e);
    }), el.addEventListener("input", () => {
      this.IsMasking && this.CheckMask();
      let value = el.value;
      if (this.props.onChange)
        return this.props.onChange(value);
      this.props.value.SValue = value;
    }), this.IsMasking && (el.addEventListener("focus", (e) => {
      this.IsMasking && this.CheckMask(), this.props.onFocus && this.props.onFocus(e);
    }), el.addEventListener("blur", () => el.value === this.pattern && (el.value = "")));
  }
  Render() {
    let keyUpFn;
    return (this.props.onKeyUp || this.props.onKeyEnter || this.props.onKeyEsc) && (keyUpFn = /* @__PURE__ */ __name((e) => {
      this.props.onKeyUp && this.props.onKeyUp(e), this.props.onKeyEnter && e.keyCode === 13 && this.props.onKeyEnter(), this.props.onKeyEsc && e.keyCode === 27 && this.props.onKeyEsc();
    }, "keyUpFn")), React.createElement("input", { type: this.props.type, className: Luff.State.Concat("l-textbox", this.props.className), classDict: this.props.classDict, value: this.props.value, autocomplete: this.props.autocomplete, onClick: this.props.onClick, onKeyUp: keyUpFn, placeholder: this.props.placeholder, disabled: this._IsDisabled });
  }
};
__name(_TextBox, "TextBox");
let TextBox = _TextBox;
TextBox.Type = {
  Text: "text",
  Email: "email",
  Phone: "tel",
  Search: "search"
};
TextBox.defaultProps = {
  type: TextBox.Type.Text,
  className: "",
  disabled: !1,
  placeholder: "",
  isPermissionWriteRequired: !1
};
___LuffGlobal.Inputs.TextBox = TextBox;
const _ProgressBar = class _ProgressBar extends ComponentSimple {
  Render() {
    return React.createElement(
      "div",
      { className: "l-progress-bar", style: this.props.percent.SubState((percent) => `--progress-percent: ${percent}%`) },
      this.props.caption && React.createElement(
        "div",
        { className: "l-progress-caption" },
        React.createElement("div", { className: "l-progress-caption-text" }, "caption")
      ),
      React.createElement("div", { className: "l-progress-filler" })
    );
  }
};
__name(_ProgressBar, "ProgressBar");
let ProgressBar = _ProgressBar;
ProgressBar.defaultProps = {
  percent: 100
};
const countries = [
  {
    Caption: "Россия",
    Country: "ru",
    Code: 7,
    Mask: "(___) ___-__-__"
  },
  {
    Caption: "Қазақстан",
    Country: "kz",
    Code: 7,
    Mask: "(___) ___-__-__"
  },
  {
    Caption: "O'zbekiston",
    Country: "uz",
    Code: 998,
    Mask: "(___) ___-__-__"
  }
], countrySet = Luff.Linq(countries).ToDictionary((x) => x.Country), _PhoneInput = class _PhoneInput extends Luff.ComponentSimple {
  constructor() {
    super(...arguments), this.CountryData = this.props.value.SubState((v) => {
      var _a;
      if (v.trim().length == 0 && (!((_a = this.CountryData) === null || _a === void 0) && _a.SValue))
        return this.CountryData.SValue;
      if (v.trim().length == 0)
        return countrySet[this.props.defaultCountry];
      for (let cd of countries)
        if (v.includes("+" + cd.Code + " "))
          return cd;
      return countrySet[this.props.defaultCountry];
    });
  }
  Render() {
    const mask = this.CountryData.SubState((data) => ({
      Mask: `+${data.Code} ${data.Mask}`
    }));
    let mainClassCss = "l-phone-input";
    return this.props.isReadOnlyMode && (mainClassCss += " __readonly"), this.props.className && (mainClassCss += " " + this.props.className), React.createElement(
      "div",
      { className: mainClassCss, classDict: this.props.classDict },
      this.props.isShowCountryPicker && React.createElement(ComboBox, { value: this.CountryData.Country, dataStatic: countries, dataDelegateValue: /* @__PURE__ */ __name((x) => x.Country, "dataDelegateValue"), dataRender: /* @__PURE__ */ __name((x) => React.createElement(
        "div",
        { className: "l-phone-input_country-item" },
        React.createElement("div", { className: x.Country.SubState((country) => "l-phone-input_country-icon l-flag-icon__" + country) }),
        React.createElement("div", { className: "l-phone-input_country-caption" }, x.Caption)
      ), "dataRender"), onChange: /* @__PURE__ */ __name((c) => {
        this.CountryData.SValue = countrySet[c];
      }, "onChange"), listWidth: "180px" }),
      React.createElement(TextBox, { value: this.props.value, mask, placeholder: mask.Mask, onKeyEnter: this.props.onKeyEnter, disabled: this.props.isReadOnlyMode })
    );
  }
};
__name(_PhoneInput, "PhoneInput");
let PhoneInput = _PhoneInput;
PhoneInput.defaultProps = {
  isShowCountryPicker: !0,
  isReadOnlyMode: !1,
  defaultCountry: "ru"
};
const _NumBox = class _NumBox extends InputBoxBase {
  IsInputValidDefault() {
    const { value, min, max } = this.props, v = value.SValue;
    return min !== void 0 && v < min.valueOf() ? {
      IsValid: !1,
      Message: "Значение меньше минимума"
    } : max !== void 0 && v > min.valueOf() ? {
      IsValid: !1,
      Message: "Значение больше максимума"
    } : {
      IsValid: !0,
      Message: ""
    };
  }
  Render() {
    const isHideInappropriateValue = this.props.isHideInappropriateValue, min = this.props.min, max = this.props.max;
    let valueView = this.props.value;
    if (isHideInappropriateValue) {
      const isMinState = min instanceof State, isMaxState = max instanceof State, minSt = min, maxSt = max;
      let deps = [];
      isMinState && deps.push(minSt), isMaxState && deps.push(maxSt), valueView = this.props.value.SubState((val) => val < min || val > max ? "" : val, deps);
    }
    let keyUpFn;
    return (this.props.onKeyUp || this.props.onKeyEnter || this.props.onKeyEsc) && (keyUpFn = /* @__PURE__ */ __name((e) => {
      this.props.onKeyUp && this.props.onKeyUp(e), this.props.onKeyEnter && e.keyCode === 13 && this.props.onKeyEnter(), this.props.onKeyEsc && e.keyCode === 27 && this.props.onKeyEsc();
    }, "keyUpFn")), React.createElement("input", { type: "number", className: Luff.State.Concat("l-textbox ", this.props.className), value: valueView, onChange: /* @__PURE__ */ __name((e) => {
      let value = parseFloat(e.currentTarget.value);
      if (value != this.props.value.SValue) {
        if (this.props.onChange)
          return this.props.onChange(value);
        this.props.value.SValue = value;
      }
    }, "onChange"), onKeyUp: keyUpFn, onClick: this.props.onClick, onFocus: this.props.onFocus, placeholder: this.props.placeholder, min: this.props.min, max: this.props.max, step: this.props.step, disabled: this._IsDisabled });
  }
};
__name(_NumBox, "NumBox");
let NumBox = _NumBox;
NumBox.defaultProps = {
  className: "",
  disabled: !1,
  placeholder: "",
  isPermissionWriteRequired: !1,
  isHideInappropriateValue: !0
};
const quarters = [
  { ID: 1, Name: "I квартал" },
  { ID: 2, Name: "II квартал" },
  { ID: 3, Name: "III квартал" },
  { ID: 4, Name: "IV квартал" }
], months = Culture.Current.MonthNames.map((x, i) => ({ Value: i, Name: x })), _PPMonthQuarterYear = class _PPMonthQuarterYear extends Luff.Content {
  constructor() {
    super(...arguments), this.Years = Luff.State([]);
  }
  CalculateYears() {
    const { navDate, yearRange } = this.props, dateMin = Luff.State.GetSValueOrValue(this.props.dateMin), dateMax = Luff.State.GetSValueOrValue(this.props.dateMax);
    dateMin && (yearRange[0] = dateMin.Year), dateMax && (yearRange[1] = dateMax.Year);
    let years = [];
    for (let y = yearRange[0]; y <= yearRange[1]; y++)
      years.push(y);
    const yearValue = navDate.SValue.Year;
    years.includes(yearValue) || years.push(yearValue), this.Years.SValue = years.sort((a, b) => a < b ? 1 : -1);
  }
  Render() {
    let { navDate, setNavDate, isMonth, isQuarter, yearRange, dateMin, dateMax } = this.props;
    return Luff.State.TryAddOnChange(dateMin, (_) => this.CalculateYears()), Luff.State.TryAddOnChange(dateMax, (_) => this.CalculateYears()), this.CalculateYears(), React.createElement(
      "div",
      { className: "l-pp-date-navigator l-row l-flex-center l-flexa-center" },
      isQuarter && React.createElement(
        "div",
        { className: "l-pp-nav-quarter" },
        React.createElement(ComboBox, { value: navDate.SubState((date) => date.Quarter), dataStatic: quarters, dataDelegateValue: /* @__PURE__ */ __name((x) => x.ID, "dataDelegateValue"), dataDelegateView: /* @__PURE__ */ __name((x) => x.Name, "dataDelegateView"), onChange: /* @__PURE__ */ __name((val) => (setNavDate(navDate.SValue.SetQuarter(val)), Promise.resolve(1)), "onChange") })
      ),
      isMonth && React.createElement(
        "div",
        { className: "l-pp-nav-month" },
        React.createElement(ComboBox, { value: navDate.SubState((date) => date.Month), dataStatic: months, dataDelegateValue: /* @__PURE__ */ __name((x) => x.Value, "dataDelegateValue"), dataDelegateView: /* @__PURE__ */ __name((x) => x.Name, "dataDelegateView"), onChange: /* @__PURE__ */ __name((val) => (setNavDate(navDate.SValue = navDate.SValue.SetMonth(val)), Promise.resolve(1)), "onChange") })
      ),
      React.createElement(
        "div",
        { className: "l-pp-nav-year" },
        React.createElement(ComboBox, { value: navDate.SubState((date) => date.Year), data: this.Years, onChange: /* @__PURE__ */ __name((val) => (setNavDate(navDate.SValue = navDate.SValue.SetYear(val)), Promise.resolve(1)), "onChange") })
      )
    );
  }
};
__name(_PPMonthQuarterYear, "PPMonthQuarterYear");
let PPMonthQuarterYear = _PPMonthQuarterYear;
PPMonthQuarterYear.defaultProps = {
  isMonth: !0
  //yearRange: [1960, luffDate().Year + 5],
};
function getStaticWeekDaysRow(isShowWeekDays, isShowWeekSelector) {
  if (isShowWeekDays)
    return React.createElement(
      React.Fragment,
      null,
      isShowWeekSelector && React.createElement("div", { className: "l-pp-week-select-gap", "data-value": "{{DateValue}}" }, "|"),
      Culture.Current.WeekDaysShort.map((w, i) => {
        let dayOff = PeriodPicker.WeekEndDays.includes(i + 1) ? "l-pp-dayoff" : "";
        return React.createElement("div", { className: "l-pp-weekdays-cell l-pp-cell " + dayOff }, w);
      })
    );
}
__name(getStaticWeekDaysRow, "getStaticWeekDaysRow");
const _PPRange = class _PPRange extends Luff.Content {
  Render() {
    const pp = this.props.pp;
    return React.createElement(
      "div",
      { className: "l-pp-work-area" },
      React.createElement(
        "div",
        { className: "l-pp-work-date" },
        React.createElement("div", { className: "l-pp-arrow l-pp-arrow-left pointer ${periodPicker_ctor.IsShowNavigationArrows? '':'none'}", onClick: /* @__PURE__ */ __name(() => pp._ShiftMonth(-1), "onClick") }),
        React.createElement(
          "div",
          { className: "l-pp-content", onWheel: /* @__PURE__ */ __name((e) => pp._ShiftMonthByWheel(e), "onWheel") },
          React.createElement(Each, { source: pp.State.MonthRows, render: /* @__PURE__ */ __name((mRow) => React.createElement(
            "div",
            { className: "l-pp-month-row" },
            React.createElement(Each, { source: mRow.MonthBlocks, render: /* @__PURE__ */ __name((mBlock) => React.createElement(
              "div",
              { className: "l-pp-month-block" },
              React.createElement("div", { className: "l-pp-weekdays-row" }, getStaticWeekDaysRow(pp.props.isShowWeekDays, pp.props.isShowWeekSelector && !pp.props.isOnlyDay)),
              React.createElement("div", { className: "l-pp-month-name" + (pp.props.isOnlyDay ? "" : " l-pp-month-select") + (mBlock.IsDeny ? " l-pp-deny" : ""), "data-value": mBlock.DateValue, onClick: /* @__PURE__ */ __name(() => pp._OnMonthClick(mBlock.SValue), "onClick") }, mBlock.MonthName),
              React.createElement(
                "div",
                { className: "l-pp-month-grid" },
                React.createElement(Each, { source: mBlock.MonthWeeks, render: /* @__PURE__ */ __name((week) => React.createElement(
                  "div",
                  { className: "l-pp-month-week l-row" },
                  pp.props.isShowWeekSelector && !pp.props.isOnlyDay && React.createElement("div", { className: "l-pp-week-select {{IsDeny ? 'l-pp-deny':''}} {{WeekSelectorVisible}}", onClick: /* @__PURE__ */ __name(() => pp._OnWeekClick(week.SValue), "onClick") }, "|"),
                  React.createElement(Each, { source: week.Days, render: /* @__PURE__ */ __name((day) => {
                    const dayClass = day.DayType.SubState((dayType) => "l-pp-month-cell l-pp-cell" + (day.IsDayOff.SValue ? " l-pp-dayoff " : " ") + dayType, [day.IsDayOff]);
                    return React.createElement("div", {
                      className: dayClass,
                      //data-type={day.DayType}
                      ///data-value={day.DateValue}
                      onClick: /* @__PURE__ */ __name(() => pp._OnDayClick(day.SValue), "onClick")
                    }, day.DayValue);
                  }, "render") })
                ), "render") })
              )
            ), "render") })
          ), "render") })
        ),
        React.createElement("div", { className: "l-pp-arrow l-pp-arrow-right pointer ${periodPicker_ctor.IsShowNavigationArrows? '':'none'}", onClick: /* @__PURE__ */ __name(() => pp._ShiftMonth(1), "onClick") })
      )
    );
  }
};
__name(_PPRange, "PPRange");
let PPRange = _PPRange;
var TimePickerResolution;
(function(TimePickerResolution2) {
  TimePickerResolution2[TimePickerResolution2.Hour = 0] = "Hour", TimePickerResolution2[TimePickerResolution2.Minute = 1] = "Minute", TimePickerResolution2[TimePickerResolution2.Second = 2] = "Second", TimePickerResolution2[TimePickerResolution2.Millisecond = 3] = "Millisecond";
})(TimePickerResolution || (TimePickerResolution = {}));
function dateTimeDelegateView(i) {
  return String(i).length == 2 ? i.toString() : "0" + i;
}
__name(dateTimeDelegateView, "dateTimeDelegateView");
const _PeriodPicker = class _PeriodPicker extends Luff.Content {
  constructor() {
    super(...arguments), this._CurrentSelection = Luff.State({
      DateStart: void 0,
      DateFinish: void 0
    }), this._IsShowTimePicker = Luff.State(!1), this._TimePickerResolution = Luff.State(TimePickerResolution.Minute), this._TimePickerMinuteStep = Luff.State(1);
  }
  _PropsUpdate() {
    this._IsShowTimePicker.SValue = this.props.isShowTimePick, this._TimePickerResolution.SValue = this.props.timePickerResolution, this._TimePickerMinuteStep.SValue = this.props.timePickerMinuteStep;
  }
  AfterBuild() {
  }
  BeforeBuild() {
    this._PropsUpdate();
    const dates = this.props.dates;
    if (dates) {
      let ds = dates[0].Clone(), df = dates[1].Clone();
      this._CurrentSelection.DateStart.SValue = ds, this._CurrentSelection.DateFinish.SValue = this.props.isOnlyDay ? ds.SetDayEnd() : df;
    }
    !this.props.navigationDate && dates && (this.State.NavigationDate.SValue = dates[0].Clone()), this._CurrentCells = this.props.cells, this.State.MonthRows.SValue = this._GenerateData(), this._CurrentSelection.AddOnChange(() => {
      this.State.MonthRows.SValue = this._GenerateData();
    });
  }
  _Redraw() {
    this.State.MonthRows.SValue = this._GenerateData();
  }
  _SetNavDate(navDate) {
    this.State.NavigationDate.SValue = navDate, this.State.MonthRows.SValue = this._GenerateData();
  }
  Run(dateValue, dateTarget, onChange, options) {
    this.props = Object.assign(Object.assign({}, this.props), options), this._PropsUpdate(), this._SetNavDate(Luff.Date(dateTarget)), dateValue ? this._CurrentSelection.SValue = {
      DateStart: Luff.Date(dateValue),
      DateFinish: Luff.Date(dateValue)
    } : this._CurrentSelection.SValue = {
      DateStart: void 0,
      DateFinish: void 0
    }, onChange && (this.props.onChange = onChange), this.Show();
  }
  RunRange(dateValues, onChange, options) {
    this.props = Object.assign(Object.assign({}, this.props), options), this._PropsUpdate(), dateValues ? (this._SetNavDate(Luff.Date(dateValues[0])), this._CurrentSelection.SValue = {
      DateStart: Luff.Date(dateValues[0]),
      DateFinish: Luff.Date(dateValues[1])
    }) : this._CurrentSelection.SValue = {
      DateStart: void 0,
      DateFinish: void 0
    }, onChange && (this.props.onChange = onChange), this.Show();
  }
  _CheckSelection() {
    if (this._CurrentSelection.DateFinish.SValue === void 0)
      return;
    let current = this._CurrentSelection.SValue, dateStart = current.DateStart, dateEnd = current.DateFinish;
    if (dateEnd && dateStart.Date > dateEnd.Date) {
      let temp = dateStart;
      dateStart = dateEnd, dateEnd = temp, this._CurrentSelection.DateStart.SValue = dateStart.DayStart, this._CurrentSelection.DateFinish.SValue = dateEnd.DayEnd;
    }
    const dateMin = Luff.State.GetSValueOrValue(this.props.dateMin), dateMax = Luff.State.GetSValueOrValue(this.props.dateMax);
    if (dateMin && dateEnd < dateMin.DayStart || dateMax && dateStart > dateMax.DayEnd) {
      this._CurrentSelection.DateStart.SValue = void 0, this._CurrentSelection.DateFinish.SValue = void 0;
      return;
    }
    dateMin && dateStart < dateMin && (this._CurrentSelection.DateStart.SValue = dateMin.Clone()), dateMax && dateEnd > dateMax && (this._CurrentSelection.DateFinish.SValue = dateMax.Clone());
    const timeMinuteStep = this._TimePickerMinuteStep.SValue;
    timeMinuteStep > 1 && dateEnd && (dateStart.SetMinutes(LibraryNumber.RoundBy(dateStart.Minutes, timeMinuteStep, "floor")), dateStart.SetSeconds(0), dateStart.SetMilliseconds(0), dateEnd.SetMinutes(LibraryNumber.RoundBy(dateEnd.Minutes, timeMinuteStep, "floor")), dateEnd.SetSeconds(0), dateEnd.SetMilliseconds(0));
  }
  _CheckSelectionAndDirectConfirm() {
    this._CheckSelection(), this.props.isDirectConfirm && this._CurrentSelection.DateFinish.SValue && this._Confirm(), this._Redraw();
  }
  _TryConfirm() {
    this._CurrentSelection.DateFinish.SValue && (this.props.onChange(this._CurrentSelection.DateStart.SValue.Clone(), this._CurrentSelection.DateFinish.SValue.Clone()), this.Hide());
  }
  _Confirm() {
    this.props.onChange(this._CurrentSelection.DateStart.SValue.Clone(), this._CurrentSelection.DateFinish.SValue.Clone());
  }
  _GenerateMonth(Date) {
    let MonthBlock = {
      DateValue: Date.Clone().SetMonthStart(),
      MonthName: Date.Format("MMMM YYYY"),
      MonthWeeks: [],
      IsDeny: !1
    }, cursor = luffDate("01." + Date.Format("MM.YYYY"), "DD.MM.YYYY"), CurrentWeek = {
      WeekSelectorVisible: this.props.isShowWeekSelector ? "" : "none",
      DateValue: cursor.Clone().SetWeekStart(),
      Days: [],
      IsDeny: !1
    }, current = this._CurrentSelection.SValue;
    const dateMin = Luff.State.GetSValueOrValue(this.props.dateMin), dateMax = Luff.State.GetSValueOrValue(this.props.dateMax), forbidden = this.props.forbiddenDates.SValue;
    for (; cursor.Month === Date.Month; ) {
      const dayOfWeek = cursor.DayOfWeek;
      let isDeny = !1, DayType = "";
      forbidden.find((x) => x.IsSameDate(cursor)) && (DayType = "l-pp-deny"), (dateMin && cursor < dateMin.DayStart || dateMax && cursor > dateMax.DayEnd) && (DayType = "l-pp-deny", isDeny = !0), !isDeny && current.DateStart && current.DateFinish && cursor >= current.DateStart.DayStart && cursor <= current.DateFinish.DayEnd && (DayType = "l-pp-selected"), !isDeny && !this.props.isOnlyDay && current.DateStart && current.DateFinish === void 0 && cursor >= current.DateStart.DayStart && cursor <= current.DateStart.DayEnd && (DayType = "l-pp-selection-active");
      let Day = {
        DateValue: cursor.DayStart,
        DayValue: cursor.Format("DD"),
        DayType,
        IsDayOff: _PeriodPicker.WeekEndDays.includes(dayOfWeek),
        IsDayDeny: DayType === "l-pp-deny"
        //DayOff: '',//(PP._State.Settings.WeekEndIndexes.indexOf(WeekDay) > -1 || PP.Settings.DayOffs.indexOf(Cursor.Date) > -1)? 'l-pp-dayoff':''
      };
      CurrentWeek.Days.push(Day), dayOfWeek === 7 && (CurrentWeek.IsDeny = CurrentWeek.Days.filter((x) => x.IsDayDeny).length === CurrentWeek.Days.length, MonthBlock.MonthWeeks.push(CurrentWeek), CurrentWeek = {
        WeekSelectorVisible: this.props.isShowWeekSelector ? "" : "none",
        //DateValue: Cursor.Clone().AddDays(1).Format('DD.MM.YYYY'),
        DateValue: cursor.Clone().AddDays(1).SetWeekStart(),
        Days: [],
        IsDeny: !1
      }), cursor.Day === cursor.CountDays && CurrentWeek.Days.length > 0 && (CurrentWeek.IsDeny = CurrentWeek.Days.filter((x) => x.IsDayDeny).length === CurrentWeek.Days.length, MonthBlock.MonthWeeks.push(CurrentWeek)), cursor.AddDays(1);
    }
    return MonthBlock.IsDeny = MonthBlock.MonthWeeks.filter((x) => x.IsDeny).length === MonthBlock.MonthWeeks.length, MonthBlock;
  }
  _GenerateData() {
    let monthRows = [], cursor = luffDate(this.State.NavigationDate.SValue).Clone();
    if (this.props.isMicroMode)
      return monthRows;
    for (let row = 0; row < this._CurrentCells[0]; row++) {
      let MonthBlocks = [];
      for (let col = 0; col < this._CurrentCells[1]; col++)
        MonthBlocks.push(this._GenerateMonth(cursor)), cursor.AddMonths(1);
      monthRows.push({ MonthBlocks });
    }
    return monthRows;
  }
  _ShiftMonth(delta) {
    this.State.NavigationDate.SValue = this.State.NavigationDate.SValue.AddMonths(delta), this.State.MonthRows.SValue = this._GenerateData();
  }
  _ShiftMonthByWheel(e) {
    this._ShiftMonth(e.deltaY > 0 ? 1 : -1);
  }
  _SetDateByInput(textValue, dateView, oneOrTwo) {
    if (!textValue)
      return;
    const rgx = `^${Luff.Culture.Current.DateFormat.replace(/[dmyDMYs]/g, "\\d")}$`;
    if (!new RegExp(rgx, "g").test(textValue)) {
      dateView.SValue = textValue;
      return;
    }
    let dateValue;
    try {
      dateValue = Luff.Date(textValue, Luff.Culture.Current.DateFormat);
    } catch {
      Luff.Pop.Error("Введена невалидная дата. Дата должна быть в формате " + Luff.Culture.Current.DateFormat);
      return;
    }
    if (this.props.isOnlyDay)
      this._CurrentSelection.DateStart.SValue = dateValue.DayStart, this._CurrentSelection.DateFinish.SValue = dateValue.DayEnd;
    else {
      let DateCurrent = oneOrTwo === 0 ? this._CurrentSelection.DateStart : this._CurrentSelection.DateFinish;
      DateCurrent.SValue = dateValue;
    }
    this._CheckSelectionAndDirectConfirm();
  }
  _OnDayClick(day) {
    if (day.IsDayDeny)
      return;
    const dateValue = day.DateValue;
    let selection = this._CurrentSelection.SValue;
    if (this.props.isOnlyDay)
      return selection.DateStart = dateValue.DayStart, selection.DateFinish = dateValue.DayEnd, this._CurrentSelection.SValue = selection, this._CheckSelectionAndDirectConfirm();
    selection.DateStart === void 0 || selection.DateFinish !== void 0 ? (selection.DateStart = dateValue.DayStart, selection.DateFinish = void 0) : selection.DateStart !== void 0 && selection.DateFinish === void 0 && (selection.DateFinish = dateValue.DayEnd), this._CurrentSelection.DateStart.SValue = selection.DateStart, this._CurrentSelection.DateFinish.SValue = selection.DateFinish, this._CheckSelectionAndDirectConfirm();
  }
  _OnWeekClick(week) {
    if (week.IsDeny || this.props.isOnlyDay)
      return;
    const dateValue = week.DateValue;
    this._CurrentSelection.DateStart.SValue = dateValue.Clone().SetWeekStart(), this._CurrentSelection.DateFinish.SValue = dateValue.Clone().SetWeekEnd(), this._CheckSelectionAndDirectConfirm();
  }
  _OnMonthClick(month) {
    if (month.IsDeny || this.props.isOnlyDay)
      return;
    const dateValue = month.DateValue;
    this._CurrentSelection.DateStart.SValue = dateValue.Clone().SetMonthStart(), this._CurrentSelection.DateFinish.SValue = dateValue.Clone().SetMonthEnd(), this._CheckSelectionAndDirectConfirm();
  }
  //private _Content: React.RefObject<HTMLDivElement> = React.createRef();
  _SetFullscreen() {
    if (this.State.IsFullscreen.SValue)
      this._CurrentCells = this.props.cells;
    else {
      const monthBlockElem = LibraryDOM.Select(".l-pp-month-block", this.DOM);
      let w = monthBlockElem.offsetWidth, h = monthBlockElem.offsetHeight, dw = document.body.offsetWidth, dh = document.body.offsetHeight;
      this._CurrentCells = [Math.floor((dh - 70) / h), Math.floor((dw - 50) / w)];
    }
    this.State.SValue = Object.assign(Object.assign({}, this.State.SValue), { IsFullscreen: !this.State.IsFullscreen.SValue, MonthRows: this._GenerateData() });
  }
  Render() {
    const stClassPPFullscreen = this.State.IsFullscreen.SubState((isTrue) => "l-period_picker" + (isTrue ? " l-pp-fullscreen" : "")), dsView = this._CurrentSelection.DateStart.SubState((ds) => ds ? ds.Format(Culture.Current.DateFormat) : ""), dfView = this._CurrentSelection.DateFinish.SubState((df) => df ? df.Format(Culture.Current.DateFormat) : "");
    return React.createElement(
      "div",
      { className: stClassPPFullscreen },
      React.createElement(
        "div",
        { className: "l-pp-head" },
        React.createElement("div", { className: "l-pp-caption" }, "Выберите период"),
        React.createElement(
          "div",
          { className: "l-pp-controls" },
          this.props.isFullscreenButton && React.createElement("div", { className: "l-pp-control l-pp-control-fullscreen", onClick: /* @__PURE__ */ __name(() => this._SetFullscreen(), "onClick") }),
          React.createElement("div", { className: "l-pp-control l-pp-control-close", onClick: /* @__PURE__ */ __name(() => this.Hide(), "onClick") })
        )
      ),
      this.props.navigation && React.createElement(PPMonthQuarterYear, { navDate: this.State.NavigationDate, setNavDate: /* @__PURE__ */ __name((d) => this._SetNavDate(d), "setNavDate"), isMonth: this.props.navigation.IsShowMonthSelect, isQuarter: !1, dateMax: this.props.dateMax, dateMin: this.props.dateMin, yearRange: this.props.navigation.YearRange }),
      React.createElement(
        "div",
        { className: "l-pp-inner" },
        React.createElement(PPRange, { pp: this }),
        React.createElement(
          "div",
          { className: "l-pp-bottom" },
          React.createElement(
            "div",
            { className: "l-pp-result" },
            React.createElement(
              "div",
              { className: "l-pp-date-values l-pp-date-date" },
              React.createElement(
                "div",
                { className: "l-pp-textbox-holder" },
                React.createElement("input", { className: "l-textbox tb-date-start", value: dsView, onChange: /* @__PURE__ */ __name((e) => {
                  let text = e.target.value.trim();
                  console.log("[PeriodPicker] tb-date-start:", text), this._SetDateByInput(text, dsView, 0);
                }, "onChange"), placeholder: Culture.Current.DateFormat })
              ),
              !this.props.isOnlyDay && React.createElement(
                "div",
                { className: "l-pp-date-additional" },
                React.createElement(
                  "div",
                  { className: "l-pp-textbox-gap" },
                  React.createElement("div", null, " —")
                ),
                React.createElement(
                  "div",
                  { className: "l-pp-textbox-holder" },
                  React.createElement("input", { className: "l-textbox tb-date-end", value: dfView, onChange: /* @__PURE__ */ __name((e) => {
                    let text = e.target.value.trim();
                    this._SetDateByInput(text, dfView, 1);
                  }, "onChange"), placeholder: Culture.Current.DateFormat })
                )
              )
            ),
            React.createElement(
              "div",
              { className: "l-pp-date-values l-pp-date-time", isVisible: this._IsShowTimePicker },
              React.createElement(
                "div",
                { className: "l-pp-time-face l-pp-time-face-start" },
                React.createElement(
                  "div",
                  { className: "l-pp-time-part l-pp-tp-start-hour" },
                  React.createElement(ComboBox, { value: this._CurrentSelection.DateStart.SubState((df) => df ? df.Hours : 0), dataStatic: new Array(24).fill(0).map((x, i) => i), dataDelegateView: dateTimeDelegateView, isSearchEnabled: !0, listEmptyText: "", disabled: this._CurrentSelection.DateFinish.SubState((df) => !df), onChange: /* @__PURE__ */ __name((v) => (this._CurrentSelection.DateStart.SValue = this._CurrentSelection.DateStart.SValue.SetHours(v), Promise.resolve(1)), "onChange") })
                ),
                React.createElement(
                  "div",
                  { className: "l-pp-time-part l-pp-tp-start-minute", isVisible: this._TimePickerResolution.SubState((r) => r >= TimePickerResolution.Minute) },
                  React.createElement(ComboBox, { value: this._CurrentSelection.DateStart.SubState((df) => df ? df.Minutes : 0), dataStatic: new Array(60).fill(0).map((x, i) => i), dataDelegateView: dateTimeDelegateView, isSearchEnabled: !0, listEmptyText: "", disabled: this._CurrentSelection.DateFinish.SubState((df) => !df), onChange: /* @__PURE__ */ __name((v) => (this._CurrentSelection.DateStart.SValue = this._CurrentSelection.DateStart.SValue.SetMinutes(v), Promise.resolve(1)), "onChange") })
                ),
                React.createElement(
                  "div",
                  { className: "l-pp-time-part l-pp-tp-start-second", isVisible: this._TimePickerResolution.SubState((r) => r >= TimePickerResolution.Second) },
                  React.createElement(ComboBox, { value: this._CurrentSelection.DateStart.SubState((df) => df ? df.Seconds : 0), dataStatic: new Array(60).fill(0).map((x, i) => i), dataDelegateView: dateTimeDelegateView, isSearchEnabled: !0, listEmptyText: "", disabled: this._CurrentSelection.DateFinish.SubState((df) => !df), onChange: /* @__PURE__ */ __name((v) => (this._CurrentSelection.DateStart.SValue = this._CurrentSelection.DateStart.SValue.SetSeconds(v), Promise.resolve(1)), "onChange") })
                )
              ),
              !this.props.isOnlyDay && React.createElement(
                "div",
                { className: "l-pp-date-additional" },
                React.createElement(
                  "div",
                  { className: "l-pp-textbox-gap" },
                  React.createElement("div", null, " —")
                ),
                React.createElement(
                  "div",
                  { className: "l-pp-time-face l-pp-time-face-end" },
                  React.createElement(
                    "div",
                    { className: "l-pp-time-part l-pp-tp-end-hour" },
                    React.createElement(ComboBox, { value: this._CurrentSelection.DateFinish.SubState((df) => df ? df.Hours : 0), dataStatic: new Array(24).fill(0).map((x, i) => i), dataDelegateView: dateTimeDelegateView, isSearchEnabled: !0, listEmptyText: "", disabled: this._CurrentSelection.DateFinish.SubState((df) => !df), onChange: /* @__PURE__ */ __name((v) => (this._CurrentSelection.DateFinish.SValue = this._CurrentSelection.DateFinish.SValue.SetHours(v), Promise.resolve(1)), "onChange") })
                  ),
                  React.createElement(
                    "div",
                    { className: "l-pp-time-part l-pp-tp-end-minute", isVisible: this._TimePickerResolution.SubState((r) => r >= TimePickerResolution.Minute) },
                    React.createElement(ComboBox, { value: this._CurrentSelection.DateFinish.SubState((df) => df ? df.Minutes : 0), dataStatic: new Array(60).fill(0).map((x, i) => i), dataDelegateView: dateTimeDelegateView, isSearchEnabled: !0, listEmptyText: "", disabled: this._CurrentSelection.DateFinish.SubState((df) => !df), onChange: /* @__PURE__ */ __name((v) => (this._CurrentSelection.DateFinish.SValue = this._CurrentSelection.DateFinish.SValue.SetMinutes(v), Promise.resolve(1)), "onChange") })
                  ),
                  React.createElement(
                    "div",
                    { className: "l-pp-time-part l-pp-tp-end-second", isVisible: this._TimePickerResolution.SubState((r) => r >= TimePickerResolution.Second) },
                    React.createElement(ComboBox, { value: this._CurrentSelection.DateFinish.SubState((df) => df ? df.Seconds : 0), dataStatic: new Array(60).fill(0).map((x, i) => i), dataDelegateView: dateTimeDelegateView, isSearchEnabled: !0, listEmptyText: "", disabled: this._CurrentSelection.DateFinish.SubState((df) => !df), onChange: /* @__PURE__ */ __name((v) => (this._CurrentSelection.DateFinish.SValue = this._CurrentSelection.DateFinish.SValue.SetSeconds(v), Promise.resolve(1)), "onChange") })
                  )
                )
              )
            )
          ),
          React.createElement(
            "div",
            { className: "button-holder row flex-end" },
            React.createElement("button", { className: "l-button btn-l-pp-ok", onClick: /* @__PURE__ */ __name(() => this._TryConfirm(), "onClick") }, Culture.Current.Lang.Ok)
          )
        )
      )
    );
  }
  Ctor() {
    return {
      Dialog: {
        IsGlobal: !0
      },
      State: {
        IsFullscreen: !1,
        MonthRows: [],
        NavigationDate: luffDate()
      }
    };
  }
};
__name(_PeriodPicker, "PeriodPicker");
let PeriodPicker = _PeriodPicker;
PeriodPicker.defaultProps = {
  onChange: /* @__PURE__ */ __name(() => {
  }, "onChange"),
  //dates?: LuffDate[],
  //navigationDate: luffDate(),
  // navigation: {
  //
  // },
  isMicroMode: !1,
  cells: [1, 3],
  ////////
  //Target: void 0,
  //DateRange: [void 0, void 0],
  //DatesDayOff: [],
  //DatesForbidden: [],
  forbiddenDates: Luff.StateArr([]),
  //DateTarget: new LuffDate(new Date()),
  //FirstDayOfWeek: 0,
  //Format: Culture.Current.DateFormat,
  //IsBuildInMode: false,
  //isDirectConfirm: false,
  //isDirectConfirmClosesPicker: false,
  //isFullscreen: false,
  //isMonthPickerMode: false,
  isOnlyDay: !1,
  isDirectConfirm: !1,
  isFullscreenButton: !0,
  //isShowButtonConfirm: true,
  //isShowNavigationArrows: true,
  //isShowTimePick: false,
  isShowWeekDays: !0,
  isShowWeekSelector: !0,
  //isTargetImmutable: false,
  navigation: {
    IsShowMonthSelect: !0,
    YearRange: [1900, luffDate().Year + 5]
  },
  isShowTimePick: !1,
  timePickerMinuteStep: 1,
  timePickerResolution: TimePickerResolution.Minute
};
PeriodPicker.WeekEndDays = [6, 7];
PeriodPicker.TimePickerResolution = TimePickerResolution;
___LuffGlobal.PeriodPicker = PeriodPicker;
PeriodPicker.GlobalSinglePicker = new PeriodPicker({
  InnerIndex: void 0,
  Attributes: {
    //Target: document.body,
    isOnlyDay: !0
  }
});
PeriodPicker.GlobalRangePicker = new PeriodPicker({
  InnerIndex: void 0,
  Attributes: {
    //Target: document.body,
    isOnlyDay: !1
  }
});
const noImageIcon = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3csvg%20xmlns:svg='http://www.w3.org/2000/svg'%20xmlns='http://www.w3.org/2000/svg'%20width='50mm'%20height='50mm'%20viewBox='0%200%2050%2050'%20version='1.1'%20id='svg8'%20%3e%3cdefs%20id='defs2'%20/%3e%3cg%20id='layer1'%20transform='translate(0,-247)'%3e%3cpath%20style='fill:%23a2a2a2;fill-opacity:1;stroke:none;stroke-width:0.11770657px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1'%20d='m%208.0121181,262.36666%20v%2019.94771%20H%2041.512483%20v%20-20.07558%20h%20-6.633735%20l%20-1.990122,-4.60332%20h%20-8.29217%20l%20-2.344416,4.69631%20z'%20id='path4522'%20/%3e%3crect%20style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:0.30680698;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke%20fill%20markers'%20id='rect4538'%20width='4.4360909'%20height='2.2814775'%20x='26.510546'%20y='259.40375'%20/%3e%3ccircle%20style='fill:%23a2a2a2;fill-opacity:1;stroke:%23ffffff;stroke-width:3.99120784;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke%20fill%20markers'%20id='path4544'%20cx='24.296032'%20cy='272.4725'%20r='5.019659'%20/%3e%3cpath%20style='fill:none;stroke:%23ffffff;stroke-width:2.37652755;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1'%20d='M%20-6.6453646,246.55716%2054.022206,297.0786%20v%200'%20id='path4548'%20/%3e%3ccircle%20style='fill:%23ffffff;fill-opacity:0.02010049;stroke:%23a2a2a2;stroke-width:2.59512949;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke%20fill%20markers'%20id='path4554'%20cx='25.012131'%20cy='271.97818'%20r='23.556957'%20/%3e%3c/g%3e%3c/svg%3e", ImgNoImage = new Image();
ImgNoImage.src = noImageIcon;
const _LuffImageViewer = class _LuffImageViewer extends Luff.Content {
  constructor() {
    super(...arguments), this.ImageSrcList = Luff.StateArr([]), this.ImageIndex = Luff.State(0), this._IsArrowsVisible = this.ImageSrcList.SubState((x) => x.length > 1), this.ImageCache = {}, this.ImagePrevent = {
      Src: "",
      Promise: void 0
    };
  }
  AfterBuild() {
    this.ImageHolder = this.GetComponentByName("l-iv-image-holder").GetFirstDOM(), this.ImageCanvas = this.GetComponentByName("l-iv-body").GetFirstDOM();
  }
  Run(ImageSrcList, startIndex = 0) {
    (!ImageSrcList || ImageSrcList.length < 1) && (ImageSrcList = [noImageIcon]), this.ImageSrcList.SValue = ImageSrcList, this.ImageIndex.SValue = startIndex, this.NextImage(0), this.Show();
  }
  NextImage(direction) {
    this.Load.IsActive || (this.ChangeIndex(direction), this.GetImage(this.ImageSrcList[this.ImageIndex.SValue].SValue).then((image) => {
      this.ImageHolder.innerHTML = "", this.ImageHolder.appendChild(image);
    }), this.PreventingImage(direction));
  }
  ChangeIndex(direction) {
    let nextIndex = this.ImageIndex.SValue + direction;
    nextIndex >= this.ImageSrcList.length && (nextIndex = 0), nextIndex < 0 && (nextIndex = this.ImageSrcList.length - 1), this.ImageIndex.SValue = nextIndex;
  }
  PreventingImage(direction) {
    let indexPrevent = this.ImageIndex.SValue + direction;
    indexPrevent >= this.ImageSrcList.length && (indexPrevent = 0), indexPrevent < 0 && (indexPrevent = this.ImageSrcList.length - 1);
    const src = this.ImageSrcList[indexPrevent].SValue;
    if (this.ImageCache[src])
      return this.ImagePrevent = {
        Src: src,
        Promise: Promise.resolve(this.ImageCache[src])
      };
    this.ImagePrevent = {
      Src: src,
      Promise: new Promise((resolve) => {
        let img = new Image();
        img.onload = () => {
          this.ImageCache[src] = img, resolve(img);
        }, img.onerror = () => {
          this.ImageCache[src] = ImgNoImage, resolve(ImgNoImage);
        }, img.src = src;
      })
    };
  }
  GetImage(src) {
    if (this.ImageCache[src])
      return Promise.resolve(this.ImageCache[src]);
    if (src.indexOf("data:") == 0) {
      let img = new Image();
      return img.src = src, Promise.resolve(img);
    }
    return this.Load.Show(), this.ImagePrevent.Src === src && this.ImagePrevent.Promise.then(() => (this.Load.Hide(), this.ImagePrevent.Promise)), new Promise((resolve, reject) => {
      let img = new Image();
      img.onload = () => {
        this.ImageCache[src] = img, resolve(img), this.Load.Hide();
      }, img.onerror = () => {
        this.ImageCache[src] = ImgNoImage, resolve(ImgNoImage), this.Load.Hide();
      }, img.src = src;
    });
  }
  Render() {
    const maxImageHeight = this.props.maxImageHeight ? `--max-image-height: ${this.props.maxImageHeight}px` : "";
    return React.createElement(
      "div",
      { className: "l-image-viewer" },
      !this.props.isBuildIn && React.createElement("div", { className: "l-close", onClick: /* @__PURE__ */ __name(() => this.Hide(), "onClick") }),
      React.createElement(
        "div",
        { className: "l-iv-inner" },
        React.createElement(
          "div",
          { className: "l-iv-slider" },
          React.createElement(
            "div",
            { className: "l-iv-control", onClick: /* @__PURE__ */ __name(() => this.NextImage(-1), "onClick"), isVisible: this._IsArrowsVisible },
            React.createElement("div", { className: "l-iv-control-arrow l-iv-control-arrow-left" })
          ),
          React.createElement(
            "div",
            { className: "l-iv-body", compName: "l-iv-body" },
            React.createElement("div", { className: "l-iv-image-holder", compName: "l-iv-image-holder", style: maxImageHeight })
          ),
          React.createElement(
            "div",
            { className: "l-iv-control", onClick: /* @__PURE__ */ __name(() => this.NextImage(1), "onClick"), isVisible: this._IsArrowsVisible },
            React.createElement("div", { className: "l-iv-control-arrow l-iv-control-arrow-right" })
          )
        ),
        this.props.isShowPaging && React.createElement(
          "div",
          { className: "l-iv-paging" },
          this.ImageIndex.SubState((index) => index + 1),
          " / ",
          this.ImageSrcList.SubState((list) => list.length)
        )
      )
    );
  }
  Ctor() {
    return {
      LoadTarget: "l-iv-body",
      Dialog: this.props.isBuildIn ? void 0 : {
        IsGlobal: !0
      }
    };
  }
};
__name(_LuffImageViewer, "LuffImageViewer");
let LuffImageViewer = _LuffImageViewer;
LuffImageViewer.defaultProps = {
  isBuildIn: !1,
  isShowPaging: !0
};
const _ImageCarousel = class _ImageCarousel extends Luff.Content {
  constructor() {
    super(...arguments), this.ImageIndex = Luff.State(0);
  }
  BeforeBuild() {
    this.props.srcPathListWithThumbnails ? this.ImageSrcList = this.props.srcPathListWithThumbnails : this.ImageSrcList = this.props.srcPathList.SubStateArr((items) => items.map((x) => ({
      srcPathFull: x,
      srcPathThumbnail: x
    }))), this.ImageSrcList.AddOnChange(() => {
      this.ImageIndex.SValue = 0, this.ImageCarouselItems.style.left = "0px";
    });
  }
  AfterBuild() {
    this.LuffImageViewer = this.GetComponentByName("LuffImageViewer"), this.ImageCarouselItems = this.GetComponentByName("l-iv-carousel_items").GetFirstDOM(), this.ImageCarouselEach = this.GetComponentByName("l-iv-carousel_each"), this.ImageCanvas = this.GetComponentByName("l-iv-body").GetFirstDOM();
  }
  NextImage(direction) {
    this.ChangeIndex(direction);
    let dom = this.ImageCarouselEach.GetDOMByItemState(this.ImageSrcList[this.ImageIndex.SValue]);
    this.ImageCarouselItems.style.left = -dom.offsetLeft + "px";
  }
  ChangeIndex(direction) {
    let nextIndex = this.ImageIndex.SValue + direction;
    nextIndex >= this.ImageSrcList.length && (nextIndex = 0), nextIndex < 0 && (nextIndex = this.ImageSrcList.length - 1), this.ImageIndex.SValue = nextIndex;
  }
  OpenImage(index) {
    this.LuffImageViewer.Run(this.ImageSrcList.SValue.map((x) => x.srcPathFull), index);
  }
  Render() {
    const { isShowPaging, isUseViewer, extraRender, render } = this.props, maxImageHeight = this.props.maxImageHeight ? `--max-image-height: ${this.props.maxImageHeight}px` : "", issArrowsVisible = this.ImageSrcList.SubState((x) => x.length > 1);
    return React.createElement(
      "div",
      { className: "l-image-viewer l-image-carousel", style: maxImageHeight },
      isUseViewer && React.createElement(LuffImageViewer, { isShowPaging }),
      React.createElement(
        "div",
        { className: "l-iv-inner" },
        React.createElement(
          "div",
          { className: "l-iv-slider" },
          React.createElement(
            "div",
            { className: "l-iv-control l", onClick: /* @__PURE__ */ __name(() => this.NextImage(-1), "onClick"), isVisible: issArrowsVisible },
            React.createElement("div", { className: "l-iv-control-arrow l-iv-control-arrow-left" })
          ),
          React.createElement(
            "div",
            { className: "l-iv-body l-iv-carousel", compName: "l-iv-body" },
            React.createElement(
              "div",
              { className: "l-iv-carousel_items", compName: "l-iv-carousel_items" },
              React.createElement(Each, { compName: "l-iv-carousel_each", source: this.ImageSrcList, render: /* @__PURE__ */ __name((src, index, each) => React.createElement("div", { className: "l-iv-image-holder" + (isUseViewer ? " l-pointer" : ""), onClick: /* @__PURE__ */ __name(() => isUseViewer && this.OpenImage(index.SValue), "onClick") }, render(src, index, this, each)), "render") }),
              extraRender && React.createElement("div", { className: "l-iv-image-holder", compName: "l-iv-image-holder" }, extraRender())
            )
          ),
          React.createElement(
            "div",
            { className: "l-iv-control r", onClick: /* @__PURE__ */ __name(() => this.NextImage(1), "onClick"), isVisible: issArrowsVisible },
            React.createElement("div", { className: "l-iv-control-arrow l-iv-control-arrow-right" })
          )
        ),
        isShowPaging && React.createElement(
          "div",
          { className: "l-iv-paging" },
          this.ImageIndex.SubState((index) => index + 1),
          " / ",
          this.ImageSrcList.SubState((list) => list.length)
        )
      )
    );
  }
  Ctor() {
    return {
      LoadTarget: "l-iv-body"
      // Dialog: this.props.isBuildIn ? void 0 : {
      //     IsGlobal: true,
      // }
    };
  }
};
__name(_ImageCarousel, "ImageCarousel");
let ImageCarousel = _ImageCarousel;
ImageCarousel.defaultProps = {
  isShowPaging: !1,
  maxImageHeight: 150,
  isOptimizeImageLoading: !1,
  isUseViewer: !1,
  render: /* @__PURE__ */ __name((src) => React.createElement("img", { src: src.srcPathThumbnail }), "render")
};
const _PopMenu = class _PopMenu extends Luff.Content {
  Render() {
    return React.createElement("div", { className: "l-pop-popMenu" }, this.props.items.map((menuItem) => {
      let content = menuItem.Caption;
      return menuItem.Render && (content = menuItem.Render(this)), React.createElement("div", { className: "l-pop-popMenu_li", onClick: /* @__PURE__ */ __name((e) => {
        menuItem.IsCustomClick || (menuItem == null || menuItem.OnClick.call(this.props.context ? this.props.context : void 0, e, this), this.Hide());
      }, "onClick"), isVisible: menuItem.IsVisible }, content);
    }));
  }
  Ctor() {
    return {
      Dialog: {
        IsGlobal: !1,
        HasWrapper: !1,
        Animation: {
          Show: "l-animation_slideUp-show",
          Hide: "l-animation_slideUp-hide"
        },
        OnOutsideClick: /* @__PURE__ */ __name(() => {
          this.Hide();
        }, "OnOutsideClick")
      },
      Route: this.props.route
    };
  }
};
__name(_PopMenu, "PopMenu");
let PopMenu = _PopMenu;
const _ContextMenu = class _ContextMenu extends Luff.Content {
  constructor() {
    super(...arguments), this.Items = Luff.StateArr([]), this.ClassDir = Luff.State("left-top"), this.Offset = { x: -30, y: 2 };
  }
  Render() {
    return this.props.offset && (this.Offset = this.props.offset), React.createElement(
      "div",
      { className: this.ClassDir.SubState((direction) => "l-pop-popMenu " + (this.props.className ? this.props.className : "") + " " + direction) },
      this.props.items && this.props.items.map((menuItem) => React.createElement(
        "div",
        { className: "l-pop-popMenu_li", classDict: {
          static: Luff.State(!menuItem.OnClick)
        }, onClick: /* @__PURE__ */ __name(() => {
          let onClick = menuItem == null ? void 0 : menuItem.OnClick;
          onClick && (onClick.call(this.props.context ? this.props.context : void 0), this.Hide());
        }, "onClick"), isVisible: menuItem.IsVisible },
        menuItem.Caption,
        menuItem.Render()
      )),
      this.props.render && this.props.render(),
      React.createElement(Each, { source: this.Items, render: /* @__PURE__ */ __name((menuItem) => React.createElement("div", { className: "l-pop-popMenu_li", classDict: {
        static: menuItem.SubState((m) => !m.OnClick)
      }, onClick: /* @__PURE__ */ __name(() => {
        var _a;
        let onClick = (_a = menuItem.SValue) === null || _a === void 0 ? void 0 : _a.OnClick;
        onClick && (onClick.call(this.props.context ? this.props.context : void 0), this.Hide());
      }, "onClick") }, menuItem.Caption), "render") })
    );
  }
  AfterShow() {
    super.AfterShow();
    const pos = Luff.DOM.GetGlobalElementPositionOverAnother(this.DOM, this.HookElement, { x: -30, y: 2 });
    this.DOM.style.left = pos.x + "px", this.DOM.style.top = pos.y + "px", this.ClassDir.SValue = pos.direction, document.addEventListener("scroll", this.OnScroll, !0);
  }
  BeforeHide() {
    super.BeforeHide(), document.removeEventListener("scroll", this.OnScroll, !0);
  }
  BeforeShow() {
    super.BeforeShow();
  }
  BeforeBuild() {
    this.OnScroll = (e) => {
      this.Hide();
    };
  }
  Run(items, elem) {
    this.Items.SValue = items, this.HookElement = elem, this.Show();
  }
  Ctor() {
    return {
      Dialog: {
        IsGlobal: !0,
        HasWrapper: !1,
        Animation: {
          Show: "l-animation_slideUp-show",
          Hide: "l-animation_slideUp-hide"
        },
        OnOutsideClick: /* @__PURE__ */ __name(() => {
          this.Hide();
        }, "OnOutsideClick")
      }
    };
  }
};
__name(_ContextMenu, "ContextMenu");
let ContextMenu = _ContextMenu;
const _DateBox = class _DateBox extends InputBoxBase {
  get PeriodPicker() {
    return ___LuffGlobal.PeriodPicker.GlobalSinglePicker;
  }
  BeforeBuild() {
    super.BeforeBuild();
    const { min, max } = this.props;
    this.isMinState = min instanceof State, this.isMaxState = max instanceof State, this.minSt = min, this.maxSt = max;
  }
  AfterBuild() {
  }
  IsInputValidDefault() {
    const { value, min, max } = this.props, v = value.SValue;
    return min !== void 0 && v < min.valueOf() ? {
      IsValid: !1,
      Message: "Дата меньше минимумального значения"
    } : max !== void 0 && v > max.valueOf() ? {
      IsValid: !1,
      Message: "Дата больше максимального значения"
    } : {
      IsValid: !0,
      Message: ""
    };
  }
  GetMin() {
    return this.isMinState ? this.minSt.SValue : this.props.min;
  }
  GetMax() {
    return this.isMaxState ? this.maxSt.SValue : this.props.max;
  }
  CallDatePicker() {
    if (this._IsDisabled.SValue)
      return;
    const date = this.props.value.SValue;
    let dateMin, dateMax;
    if (this.props.min) {
      const minVal = Luff.State.GetSValueOrValue(this.props.min);
      minVal && (dateMin = Luff.Date(minVal));
    }
    if (this.props.max) {
      const minVal = Luff.State.GetSValueOrValue(this.props.max);
      minVal && (dateMax = Luff.Date(minVal));
    }
    this.PeriodPicker.Run(date, date, (dateStart) => {
      if (this.props.onChange) {
        this.props.onChange(dateStart.Date);
        return;
      }
      this.props.value.SValue = dateStart.Date;
    }, {
      dateMin,
      dateMax,
      isShowTimePick: this.props.isTimePick
    });
  }
  Render() {
    const { className, onChange, hasRemoveButton } = this.props;
    let isDisab = this._IsDisabled.SubState((isDis) => isDis ? "" : " l-pointer"), classState = Luff.State.Concat("l-textbox l-datebox", className, isDisab);
    const hasValue = this.props.value.SubState((v) => v != null), noValue = hasValue.SubState((s) => !s);
    return React.createElement(
      "div",
      { className: classState, classDict: {
        disabled: this._IsDisabled
      }, onClick: /* @__PURE__ */ __name(() => this.CallDatePicker(), "onClick") },
      React.createElement("div", { className: "l-datebox-value", classDict: {
        "__no-value": noValue
      } }, this.props.value.SubState((x) => x ? Luff.Date(x).Format(this.props.format) : this.props.placeholder)),
      hasRemoveButton && React.createElement("div", { className: "l-datebox-remove-btn", isVisible: hasValue, onClick: /* @__PURE__ */ __name((e) => {
        if (e.preventDefault(), e.stopPropagation(), onChange) {
          onChange(null);
          return;
        }
        this.props.value.SValue = null;
      }, "onClick") })
    );
  }
};
__name(_DateBox, "DateBox");
let DateBox = _DateBox;
DateBox.defaultProps = {
  className: "",
  placeholder: "",
  isPermissionWriteRequired: !1,
  format: Culture.Current.DateFormat,
  formatTime: Culture.Current.DateFormatTime,
  isTimePick: !1
};
const _TextBoxRich = class _TextBoxRich extends InputBoxBase {
  IsInputValidDefault() {
    const { value } = this.props;
    return value.SValue.trim().length == 0 ? {
      IsValid: !1,
      Message: "Поле не может быть пустым"
    } : {
      IsValid: !0,
      Message: ""
    };
  }
  Render() {
    let keyUpFn;
    return (this.props.onKeyUp || this.props.onKeyEnter || this.props.onKeyEsc) && (keyUpFn = /* @__PURE__ */ __name((e) => {
      this.props.onKeyUp && this.props.onKeyUp(e), this.props.onKeyEnter && e.keyCode === 13 && this.props.onKeyEnter(), this.props.onKeyEsc && e.keyCode === 27 && this.props.onKeyEsc();
    }, "keyUpFn")), React.createElement("textarea", { class: Luff.State.Concat("l-textbox l-textarea", this.props.className), value: this.props.value, onChange: /* @__PURE__ */ __name((e) => {
      let value = e.currentTarget.value;
      if (this.props.onChange)
        return this.props.onChange(value);
      this.props.value.SValue = value;
    }, "onChange"), onKeyUp: keyUpFn, onKeyDown: this.props.onKeyDown, placeholder: this.props.placeholder, disabled: this._IsDisabled });
  }
};
__name(_TextBoxRich, "TextBoxRich");
let TextBoxRich = _TextBoxRich;
TextBoxRich.defaultProps = {
  className: "",
  placeholder: "",
  isPermissionWriteRequired: !1
};
const _DateBarItem = class _DateBarItem extends Luff.ComponentSimple {
  Render() {
    const classState = this.props.isActive.SubState((isActive) => "l-date-bar-item-value" + (isActive ? " active" : ""));
    return React.createElement(
      "div",
      { class: "l-date-bar-item" },
      React.createElement("div", { className: classState, onClick: /* @__PURE__ */ __name(() => {
        this.props.DateBar.DateType.SValue = this.props.type, this.props.DateBar.Dates.SValue = getDatesByPreset(this.props.type, this.props.DateBar.Dates.SValue);
        const dts = this.props.DateBar.Dates.map((x) => x.Date);
        this.props.DateBar.props.onChange(dts[0], dts[1]);
      }, "onClick") }, this.props.children)
    );
  }
};
__name(_DateBarItem, "DateBarItem");
let DateBarItem = _DateBarItem;
var DatePresetType;
(function(DatePresetType2) {
  DatePresetType2[DatePresetType2.Today = 1] = "Today", DatePresetType2[DatePresetType2.YToday = 2] = "YToday", DatePresetType2[DatePresetType2.Week = 3] = "Week", DatePresetType2[DatePresetType2.Month = 4] = "Month", DatePresetType2[DatePresetType2.Quarter = 5] = "Quarter", DatePresetType2[DatePresetType2.Year = 6] = "Year", DatePresetType2[DatePresetType2.Range = 7] = "Range";
})(DatePresetType || (DatePresetType = {}));
function getDatesByPreset(type, dates) {
  let start = null, end = null;
  switch (type) {
    case DatePresetType.Today:
      start = Luff.Date().DayStart, end = Luff.Date().DayEnd;
      break;
    case DatePresetType.YToday:
      start = Luff.Date().AddDays(-1).DayStart, end = Luff.Date().AddDays(-1).DayEnd;
      break;
    case DatePresetType.Week:
      start = Luff.Date().WeekStart, end = Luff.Date().WeekEnd;
      break;
    case DatePresetType.Month:
      start = Luff.Date().MonthStart, end = Luff.Date().MonthEnd;
      break;
    case DatePresetType.Quarter:
      start = Luff.Date().QuarterStart, end = Luff.Date().QuarterEnd;
      break;
    case DatePresetType.Year:
      start = Luff.Date().YearStart, end = Luff.Date().YearEnd;
      break;
    case DatePresetType.Range:
      start = dates[0].Clone().DayStart, end = dates[1].Clone().DayEnd;
  }
  return [start, end];
}
__name(getDatesByPreset, "getDatesByPreset");
const _DatePickBar = class _DatePickBar extends Luff.Content {
  constructor() {
    super(...arguments), this.DateType = Luff.State(DatePresetType.Range), this.Dates = Luff.StateArr([]);
  }
  BeforeBuild() {
    this.props.datesInit ? (this.DateType.SValue = DatePresetType.Range, this.Dates.SValue = this.props.datesInit.map((x) => Luff.Date(x))) : this.props.datesPresetType && (this.DateType.SValue = this.props.datesPresetType, this.Dates.SValue = getDatesByPreset(this.props.datesPresetType, this.Dates.SValue));
  }
  AfterBuild() {
    this.PeriodPicker = this.GetComponentByName("PeriodPicker");
  }
  RunPicker() {
    this.PeriodPicker.RunRange(this.Dates.map((x) => x.Date));
  }
  Render() {
    const dateView = this.Dates.SubState((dates) => {
      const dateStart = dates[0], dateFinish = dates[1];
      return dateStart ? dateFinish ? `${dateStart.Format("DD.MM.YYYY")} — ${dateFinish.Format("DD.MM.YYYY")}` : dateStart.Format("DD.MM.YYYY") : "Выберите";
    });
    let dateMax;
    return this.props.hasNoFuture && (dateMax = Luff.Date().SetDayEnd()), React.createElement(
      "div",
      { class: "l-date-bar" },
      React.createElement(PeriodPicker, { dates: this.Dates.SValue, dateMax, onChange: /* @__PURE__ */ __name((dateStart, dateFinish) => {
        this.DateType.SValue = DatePresetType.Range, this.Dates.SValue = [
          dateStart,
          dateFinish
        ], this.props.onChange(dateStart.Date, dateFinish.Date);
      }, "onChange") }),
      React.createElement(
        "div",
        { className: "l-date-bar-item" },
        React.createElement("div", { className: "l-date-bar-item-value", onClick: /* @__PURE__ */ __name(() => this.RunPicker(), "onClick") }, dateView)
      ),
      React.createElement(DateBarItem, { DateBar: this, type: DatePresetType.YToday, isActive: this.DateType.SubState((t) => t === DatePresetType.YToday) }, "Вчера"),
      React.createElement(DateBarItem, { DateBar: this, type: DatePresetType.Today, isActive: this.DateType.SubState((t) => t === DatePresetType.Today) }, "Сегодня"),
      React.createElement(DateBarItem, { DateBar: this, type: DatePresetType.Week, isActive: this.DateType.SubState((t) => t === DatePresetType.Week) }, "Неделя"),
      React.createElement(DateBarItem, { DateBar: this, type: DatePresetType.Month, isActive: this.DateType.SubState((t) => t === DatePresetType.Month) }, "Месяц"),
      React.createElement(DateBarItem, { DateBar: this, type: DatePresetType.Quarter, isActive: this.DateType.SubState((t) => t === DatePresetType.Quarter) }, "Квартал"),
      React.createElement(DateBarItem, { DateBar: this, type: DatePresetType.Year, isActive: this.DateType.SubState((t) => t === DatePresetType.Year) }, "Год")
    );
  }
};
__name(_DatePickBar, "DatePickBar");
let DatePickBar = _DatePickBar;
DatePickBar.defaultProps = {
  hasNoFuture: !0
};
DatePickBar.DatePresetType = DatePresetType;
var ChartSeriesType;
(function(ChartSeriesType2) {
  ChartSeriesType2[ChartSeriesType2.Unknown = 0] = "Unknown", ChartSeriesType2[ChartSeriesType2.Line = 1] = "Line", ChartSeriesType2[ChartSeriesType2.Bar = 2] = "Bar", ChartSeriesType2[ChartSeriesType2.Pie = 3] = "Pie";
})(ChartSeriesType || (ChartSeriesType = {}));
var ChartPositionType;
(function(ChartPositionType2) {
  ChartPositionType2[ChartPositionType2.Left = 1] = "Left", ChartPositionType2[ChartPositionType2.Right = 2] = "Right", ChartPositionType2[ChartPositionType2.Top = 3] = "Top", ChartPositionType2[ChartPositionType2.Bottom = 4] = "Bottom";
})(ChartPositionType || (ChartPositionType = {}));
const legend = {
  Position: ChartPositionType.Top,
  Visible: !0
}, defaultAnimation = {
  Bar: "l-animate-svg-bar",
  Line: "l-animate-svg-line",
  Marker: "l-animate-svg-mark",
  Pie: "l-animate-svg-pie",
  Ring: "l-animate-svg-ring"
}, defaultToolTip = {
  Render: /* @__PURE__ */ __name((tip) => {
    let percent = tip.ValueY.SubState((valueY) => {
      let p = Math.round(valueY / tip.EpisodeSum.SValue * 1e3) / 10;
      return isNaN(p) && (p = 0), p;
    }, [tip.EpisodeSum]);
    const styleIcon = tip.Color.SubState((c) => `background-color: ${c}`);
    return React.createElement(
      "div",
      { className: "tip" },
      React.createElement("div", { className: "tip-bg" }),
      React.createElement(
        "div",
        { className: "tip-value" },
        React.createElement(
          "div",
          { className: "l-row l-flexa-center" },
          React.createElement("div", { className: "tip-icon", style: styleIcon }),
          React.createElement(
            "div",
            { className: "tip-label" },
            tip.Name,
            ": ",
            tip.ValueOriginalY,
            " (",
            percent,
            "%)"
          )
        )
      )
    );
  }, "Render"),
  Visible: !1,
  Duration: 200,
  Timeout: 700
}, _ChartBase = class _ChartBase extends Luff.Content {
  constructor() {
    super(...arguments), this.Options = {};
  }
  OnAppear() {
    this.Redraw();
  }
  Redraw() {
  }
  _InitializeLegend() {
    this.props.Legend = Object.assign(Object.assign({}, legend), this.props.Legend);
  }
  _InitializeToolTip() {
    this.props.ToolTip = Object.assign(Object.assign({}, defaultToolTip), this.props.ToolTip), this.props.ToolTip.Visible && (this._ToolTipState = Luff.State({
      TypeID: 0,
      j: 0,
      i: 0,
      ValueX: 0,
      ValueY: 0,
      ValueOriginalY: 0,
      EpisodeSum: 0,
      Color: "",
      Label: "",
      Name: "",
      SvgHeight: 0,
      SvgWidth: 0,
      Left: 0,
      Top: 0
    }));
  }
  _InitializeAnimation() {
    if (this.props.Animation === null) {
      this.props.Animation = {
        Bar: "",
        Line: "",
        Marker: "",
        Pie: "",
        Ring: ""
      };
      return;
    }
    this.props.Animation = Object.assign(Object.assign({}, defaultAnimation), this.props.Animation), this.props.Animation.Line && (this.Options.AnimationDurationLine = LibraryDOM.GetDurationAnimation(this.props.Animation.Line)), this.props.Animation.Bar && (this.Options.AnimationDurationBar = LibraryDOM.GetDurationAnimation(this.props.Animation.Bar)), this.props.Animation.Pie && (this.Options.AnimationDurationPie = LibraryDOM.GetDurationAnimation(this.props.Animation.Pie));
  }
  _InitializeOptions() {
    this.Options = Object.assign(Object.assign({}, this.props), this.Options);
  }
  _InitializeCommon() {
    this._InitializeAnimation(), this._InitializeLegend(), this._InitializeToolTip(), this._InitializeOptions();
  }
};
__name(_ChartBase, "ChartBase");
let ChartBase = _ChartBase;
const seriesDrawingPieDefault = {
  IsRelative: !1,
  AngleStart: -90,
  Width: 0
}, seriesDrawingDefault = {
  Pie: Object.assign({}, seriesDrawingPieDefault)
}, defaultColors = [
  "red",
  "green",
  "cornflowerblue",
  "purple",
  "palevioletred",
  "orange",
  "tomato",
  "darkblue",
  "cadetblue",
  "crimson"
], _ChartDrawingEpisodeBase = class _ChartDrawingEpisodeBase {
  MakeLegend(chartID, index) {
    const episode = this.Episode;
    let legend2 = "";
    for (let j = 0; j < episode.Labels.length; j++) {
      let Name = episode.Labels[j];
      episode.Data[j];
      let ValueFormatted = Name, color = episode.Colors && episode.Colors[j] ? episode.Colors[j] : `#${LibraryNumber.GetRandom(1e5, 999999)}`, checked = this.EpisodeDataVisibles[j] ? 'checked="checked"' : "";
      legend2 += `<div class="legend-item">
                          <input class="legend-checkbox" type="checkbox" ${checked} id="legend-ch-${chartID}-${index}-${j}" data-line="${index}" data-sector="${j}">
                          <label class="legend-label" for="legend-ch-${chartID}-${index}-${j}">
                             <div class="legend-icon" style="background-color: ${color}"></div>
                             <div>${ValueFormatted}</div>
                          </label>
                        </div>`;
    }
    return legend2;
  }
  // GetPath(i : number, diameter: number, svgHeight: number, svgWidth: number, prevState: TPrevState) : string {
  //     return '';
  // }
  CompileData() {
  }
  CompileSeries(chartOptions) {
    this.Options = chartOptions, this.EpisodeDataVisibles = this.Episode.Data.map(() => !0), this.Episode.Colors || (this.Episode.Colors = defaultColors);
  }
  constructor(ctor) {
    this.Sum = 0, this.Episode = ctor;
  }
};
__name(_ChartDrawingEpisodeBase, "ChartDrawingEpisodeBase");
let ChartDrawingEpisodeBase = _ChartDrawingEpisodeBase;
const defaultEpisode = {
  Width: 0,
  AngleStart: -90,
  IsRelative: !1
}, _ChartEpisodePie = class _ChartEpisodePie extends ChartDrawingEpisodeBase {
  CompileData() {
    if (this.Episode.IsRelative && this.Episode.Data.length > 2)
      throw new Error("[Luff.Chart] Pie chart with IsRelative=true must have 2 values only");
    if (this.Episode = Object.assign(Object.assign({}, defaultEpisode), this.Episode), this.Episode.IsRelative) {
      let data = this.Episode.Data.SValue, episodeData = [0, 0];
      episodeData[0] = data[0] / data[1] || 0, episodeData[1] = 1 - episodeData[0], episodeData[0] > 1 && (episodeData[0] = 1, episodeData[1] = 0), this.Data = episodeData.map((x, i) => ({
        ValueOriginal: data[i],
        Value: x
      }));
      return;
    }
    this.Data = this.Episode.Data.map((x) => ({
      ValueOriginal: x,
      Value: x
    }));
  }
  CompileSeries(chartOptions) {
    super.CompileSeries(chartOptions), this.Episode = Object.assign(Object.assign({ Name: "" }, chartOptions.SeriesDefault.Pie), this.Episode), this.CompileData();
  }
  constructor(ctor) {
    super(ctor), this.Type = ChartSeriesType.Pie;
  }
};
__name(_ChartEpisodePie, "ChartEpisodePie");
let ChartEpisodePie = _ChartEpisodePie;
const _ChartDrawing = class _ChartDrawing extends ChartBase {
  constructor() {
    super(...arguments), this.ID = LibraryNumber.GetID(), this._ToolTipDict = {};
  }
  /////
  PolarToCartesius(centerX, centerY, radius, angleInDegrees) {
    let angleInRadians = (angleInDegrees - 0) * Math.PI / 180;
    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians)
    };
  }
  GetArc(x, y, radius, startAngle, endAngle) {
    let start = this.PolarToCartesius(x, y, radius, endAngle), end = this.PolarToCartesius(x, y, radius, startAngle), largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArcFlag} 0 ${end.x} ${end.y}`;
  }
  GetSector(x, y, radius, startAngle, endAngle) {
    let start = this.PolarToCartesius(x, y, radius, endAngle), end = this.PolarToCartesius(x, y, radius, startAngle), largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArcFlag} 0 ${end.x} ${end.y} L ${x} ${y} Z`;
  }
  GetRing(x, y, radius, startAngle, endAngle, width) {
    let start = this.PolarToCartesius(x, y, radius, endAngle), end = this.PolarToCartesius(x, y, radius, startAngle), start1 = this.PolarToCartesius(x, y, radius - width, endAngle), end1 = this.PolarToCartesius(x, y, radius - width, startAngle), largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    return [
      "M",
      start.x,
      start.y,
      "A",
      radius,
      radius,
      0,
      largeArcFlag,
      0,
      end.x,
      end.y,
      "L",
      end1.x,
      end1.y,
      "M",
      end1.x,
      end1.y,
      "A",
      radius - width,
      radius - width,
      0,
      largeArcFlag,
      1,
      start1.x,
      start1.y,
      "L",
      start.x,
      start.y
    ].join(" ");
  }
  // GetPath(i, diameter, svgHeight, svgWidth, prevState) : string {
  //     const episodeOptions = this.Episode;
  //     let sectors = '';
  //
  //     let CSSAnimationPie = this.Options.Animation.Pie;
  //     let AnimationDuration = this.Options.AnimationDurationPie;
  //
  //     let sum = 0;
  //     let AngleStart = episodeOptions.AngleStart; //-45;
  //     let r = diameter/2 * (this.Options.Series.length-i)/this.Options.Series.length;
  //     let wd = 2 * r;
  //
  //     let pieWidth = episodeOptions.Width;
  //
  //     if (pieWidth == 0 && i > 0){ //pie
  //         r = prevState.PrevRadius - prevState.PrevWidth /*- episodeOptions.Margin*/ / 2 - 0.2;
  //         if (r < 0){
  //             r = prevState.PrevRadius - i/this.Options.Series.length*prevState.PrevRadius;
  //         }
  //     }
  //     if (pieWidth > 0){ //ring
  //         wd = episodeOptions.Width;
  //         //r = r*2;// - wd/2;
  //         if (i > 0){
  //             r = prevState.PrevRadius - (prevState.PrevWidth- 0.2) /*- episodeOptions.Margin*/; //-0.2 for remove gap between rings
  //         }
  //     }
  //     prevState.PrevRadius = r;
  //     //prevState.PrevWidth = episodeOptions.Type === "pie" ? episodeOptions.Width : wd;
  //     prevState.PrevWidth = wd;
  //
  //
  //     let Sectors : number[] = [];
  //     let SectorsCount = 0;
  //     this.Sum = 0;
  //     for (let j = 0; j < this.Data.length; j++){
  //         this.Sum += this.Data[j].Value;
  //         if (!this.EpisodeDataVisibles[j])
  //         {
  //             Sectors.push(null);
  //             continue;
  //         }
  //         SectorsCount++;
  //         Sectors.push(this.Data[j].Value);
  //         sum += this.Data[j].Value;
  //     }
  //     //draw something if data empty
  //     if (SectorsCount < 1)
  //         Sectors = this.Data.map(() => 1);
  //     SectorsCount = Sectors.length;
  //     let SectorVisibleCount = this.EpisodeDataVisibles.filter(x => x).length;
  //     for (let j = 0; j < Sectors.length; j++){
  //         if(Sectors[j] === null)
  //             continue;
  //         let angle = Sectors[j]/sum * 360;
  //         if (sum === 0){
  //             angle = 360/ SectorVisibleCount;
  //         }
  //         if (angle === 360 || !Number.isFinite(angle))
  //         {
  //             angle = 359.99; //collapsing 360deg = 0deg
  //             AngleStart = 0;
  //         }
  //         let style= '';
  //         if (CSSAnimationPie) {
  //             style = `opacity: 0;transform: scale(0.01,0.01) ;  animation-delay: ${j * AnimationDuration / SectorsCount / 2}ms`;
  //         }
  //         sectors += `<g>`;
  //         if (pieWidth > 0)
  //         {
  //             sectors += `<path class="${CSSAnimationPie}" style="${style}" d="${this.GetRing(svgWidth/2, svgHeight/2, r, AngleStart, AngleStart + angle, wd)}" fill="${episodeOptions.Colors[j]}" stroke="noe" stroke-width="0" fill-opacity="1" data-type="${this.Type}" data-line="${i}" data-sector="${j}"></path>`;
  //             //if (this.props.Tooltip.Visible)
  //             //    sectors += `<path class="chart-hover ${CSSAnimationPie}" style="${style}" data-type="pie" data-line="${i}" data-item="${j}" d="${this.GetRing(Width/2, Height/2, r, AngleStart, AngleStart+angle, wd)}" fill="#fff" stroke="none" stroke-width="0" fill-opacity="0" data-line="${i}" data-sector="${j}"></path>`;
  //         }
  //         if (pieWidth === 0)
  //         {
  //             sectors += `<path class="${CSSAnimationPie}" style="${style}" d="${this.GetSector(svgWidth/2, svgHeight/2, r, AngleStart, AngleStart + angle)}" fill="${episodeOptions.Colors[j]}" stroke="none" data-type="${this.Type}" data-line="${i}" data-sector="${j}"></path>`;
  //             //if (this.props.Tooltip.Visible)
  //             //    sectors += `<path class="chart-hover ${CSSAnimationPie}" style="${style}" data-type="pie" data-line="${i}" data-item="${j}" d="${this.GetSector(Width/2, Height/2, r, AngleStart, AngleStart+angle)}" fill="#fff" stroke="none"  stroke-width="0" fill-opacity="0" data-line="${i}" data-sector="${j}"></path>`;
  //         }
  //
  //         sectors += `</g>`;
  //         AngleStart += angle;
  //     }
  //     return sectors;
  // }
  GetSvg(redrawOptions) {
    return this.GetSvgPie(redrawOptions);
  }
  GetSvgPie(redrawOptions) {
    let sectors = "", svgHeight = this.HookChart.clientHeight, svgWidth = this.HookChart.clientWidth, diameter = svgHeight < svgWidth ? svgHeight : svgWidth;
    diameter = diameter - 2;
    let prevRadius = -1, prevWidth = -1;
    for (let i = 0; i < this.props.Series.length; i++) {
      let episode = this.props.Series[i], episodeOptions = episode.Episode, CSSAnimationPie = redrawOptions.Animation === !1 ? "" : this.Options.Animation.Pie, AnimationDuration = this.Options.AnimationDurationPie, sum = 0, AngleStart = episodeOptions.AngleStart, r = diameter / 2 * (this.Options.Series.length - i) / this.Options.Series.length, wd = 2 * r, pieWidth = episodeOptions.Width;
      pieWidth == 0 && i > 0 && (r = prevRadius - prevWidth / 2 - 0.2, r < 0 && (r = prevRadius - i / this.Options.Series.length * prevRadius)), pieWidth > 0 && (wd = episodeOptions.Width, i > 0 && (r = prevRadius - (prevWidth - 0.2))), prevRadius = r, prevWidth = wd;
      let sectorsDrawing = [], sectorsDrawingCount = 0;
      episode.Sum = 0;
      for (let j = 0; j < episode.Data.length; j++) {
        if (episode.Sum += episode.Data[j].Value, !episode.EpisodeDataVisibles[j]) {
          sectorsDrawing.push(null);
          continue;
        }
        sectorsDrawingCount++, sectorsDrawing.push(episode.Data[j].Value), sum += episode.Data[j].Value;
      }
      sectorsDrawingCount < 1 && (sectorsDrawing = episode.Data.map(() => 1)), sectorsDrawingCount = sectorsDrawing.length;
      let SectorVisibleCount = episode.EpisodeDataVisibles.filter((x) => x).length;
      for (let j = 0; j < sectorsDrawing.length; j++) {
        if (sectorsDrawing[j] === null)
          continue;
        let angle = sectorsDrawing[j] / sum * 360;
        sum === 0 && (angle = 360 / SectorVisibleCount), (angle === 360 || !Number.isFinite(angle)) && (angle = 359.99, AngleStart = 0);
        let style = "";
        CSSAnimationPie && (style = `opacity: 0;transform: scale(0.01,0.01) ;  animation-delay: ${j * AnimationDuration / sectorsDrawingCount / 2}ms`);
        let episodeColor = episodeOptions.Colors[j];
        episodeColor || (episodeColor = `#${LibraryNumber.GetRandom(1e5, 999999)}`), sectors += "<g>", pieWidth > 0 && (sectors += `<path class="${CSSAnimationPie}" style="${style}" d="${this.GetRing(svgWidth / 2, svgHeight / 2, r, AngleStart, AngleStart + angle, wd)}" fill="${episodeColor}" stroke="noe" stroke-width="0" fill-opacity="1" data-type="${episode.Type}" data-line="${i}" data-sector="${j}"></path>`, this.Options.ToolTip.Visible && (sectors += `<path class="chart-hover ${CSSAnimationPie}" style="${style}" data-type="pie" data-line="${i}" data-item="${j}" d="${this.GetRing(svgWidth / 2, svgHeight / 2, r, AngleStart, AngleStart + angle, wd)}" fill="#fff" stroke="none" stroke-width="0" fill-opacity="0" data-line="${i}" data-sector="${j}"></path>`)), pieWidth === 0 && (sectors += `<path class="${CSSAnimationPie}" style="${style}" d="${this.GetSector(svgWidth / 2, svgHeight / 2, r, AngleStart, AngleStart + angle)}" fill="${episodeColor}" stroke="none" data-type="${episode.Type}" data-line="${i}" data-sector="${j}"></path>`), sectors += "</g>", AngleStart += angle;
      }
    }
    return sectors;
  }
  //-----
  _InitializeSeries() {
    for (let s of this.props.Series)
      s.CompileSeries(this.Options), s.Episode.Data.AddOnChange((newValue, changedState) => {
        s.CompileData(), this.Redraw();
      });
  }
  MakeLegend() {
    if (!this.props.Legend.Visible)
      return;
    let legend2 = "";
    for (let i = 0; i < this.props.Series.length; i++) {
      let episode = this.props.Series[i];
      legend2 += episode.MakeLegend(this.ID, i);
    }
    this._LegendHtml = `<div class="legend-box">${legend2}</div>`;
  }
  Fill() {
    this.props.Legend.Visible && (this.ChartLegend.innerHTML = this._LegendHtml);
  }
  ChartSvgInit() {
    this._SvgRect = this.HookChart.getBoundingClientRect();
  }
  MakeSvg(redrawOptions) {
    this._PieCountPrepared = 0, this._SvgHtml = this.GetSvg(redrawOptions), this.ChartSvg.innerHTML = this._SvgHtml;
  }
  Redraw(redrawOptions = { Animation: !0 }) {
    this.MakeLegend(), this.Fill(), this.ChartSvgInit(), this.MakeSvg(redrawOptions);
  }
  _InitializeSeriesDefault() {
    this.props.SeriesDefault = Object.assign(Object.assign({}, seriesDrawingDefault), this.props.SeriesDefault), this.props.SeriesDefault.Pie = Object.assign(Object.assign({}, seriesDrawingPieDefault), this.props.SeriesDefault.Pie);
  }
  GetContent() {
    let htmlLegend = '<div class="legend"></div>', title = React.createElement(
      "div",
      { className: "chart-name" },
      "$",
      this.props.Title
    );
    return LibraryDOM.CreateElementFromString(`<div class="l-chart l-chart-2 l-col">
                        <table class="l-chart-t">
                            <tr class="tr-hook-top">
                                <td colspan="5" class="hook-top">
                                    ${this.props.Title && title} 
                                    ${this.props.Legend.Visible && this.props.Legend.Position === ChartPositionType.Top ? htmlLegend : ""}
                                </td>
                            </tr>
                            
                            <tr class="tr-hook-mid">
                                <td>${this.props.Legend.Visible && this.props.Legend.Position === ChartPositionType.Left ? htmlLegend : ""}</td> 
                                <td rowspan="1">
                                    <div class="hook-axis-y hook left"></div>
                                </td>
                                <td rowspan="1" class="hook-chart">
                                    <div class="chart-svg-wrapper">
                                        <svg class="chart-svg"></svg>
                                    </div>
                                    <div class="chart-tooltip" style="display: none"></div>
                                </td> 
                                <td rowspan="1">
                                    <div class="hook-axis-y hook right"></div>
                                </td> 
                                <td>${this.props.Legend.Visible && this.props.Legend.Position === ChartPositionType.Right ? htmlLegend : ""}</td>
                            </tr>
                             
                            <tr class="tr-hook-bottom">
                                <td colspan="5" class="td-hook-bottom">
                                    ${this.props.Legend.Visible && this.props.Legend.Position === ChartPositionType.Bottom ? htmlLegend : ""}
                                </td> 
                            </tr>
                        </table>
                      </div>`);
  }
  // GetRender() {
  //     const htmlLegend = <div className="legend"/>;
  //     return (
  //         <div className="l-chart l-col">
  //             <table className="l-chart-t">
  //                 <tr className="tr-hook-top">
  //                     <td colSpan={5} className="td-hook-top">
  //                         <div className="chart-name">${this.props.Title}</div>
  //                         {
  //                             (this.props.Legend.Visible && this.props.Legend.Position === ChartPositionType.Top)
  //                             &&
  //                             htmlLegend
  //                         }
  //                     </td>
  //                 </tr>
  //
  //                 <tr className="tr-hook-mid">
  //                     <td>
  //                         {
  //                             (this.props.Legend.Visible && this.props.Legend.Position === ChartPositionType.Left)
  //                             &&
  //                             htmlLegend
  //                         }
  //                     </td>
  //                     <td rowSpan={1}>
  //                         <div className="hook-axis-y hook left"/>
  //                     </td>
  //                     <td rowSpan={1} className="hook-chart">
  //                         <div className="chart-svg-wrapper">
  //                             <svg className="chart-svg"/>
  //                         </div>
  //                         <div className="chart-tooltip"/>
  //                     </td>
  //                     <td rowSpan={1}>
  //                         <div className="hook-axis-y hook right"/>
  //                     </td>
  //                     <td>
  //                         {
  //                             (this.props.Legend.Visible && this.props.Legend.Position === ChartPositionType.Right)
  //                             &&
  //                             htmlLegend
  //                         }
  //                     </td>
  //                 </tr>
  //
  //                 <tr className="tr-hook-bottom">
  //                     <td colSpan={1} className="td-hook-bottom">
  //                         {
  //                             (this.props.Legend.Visible && this.props.Legend.Position === ChartPositionType.Bottom)
  //                             &&
  //                             htmlLegend
  //                         }
  //                     </td>
  //                 </tr>
  //             </table>
  //         </div>
  //     )
  // }
  OnLegendChange(e) {
    let i = e.currentTarget.dataset.line, j = e.currentTarget.dataset.sector, Episode = this.Options.Series[i];
    if (Episode.EpisodeDataVisibles[j] = e.currentTarget.checked, Episode.EpisodeDataVisibles.filter((x) => x).length < 1) {
      Episode.EpisodeDataVisibles[j] = !0, e.currentTarget.checked = !0;
      return;
    }
    this.Redraw({ Animation: !1 });
  }
  OnChartMouseEnter() {
    this.Tooltip.Reset();
  }
  OnChartMouseLeave() {
    this.Tooltip.Close();
  }
  OnChartMouseMove(e) {
    clearTimeout(this._ToolTipTimeout), this._ToolTipTimeout = window.setTimeout(() => {
      if (e.target.tagName.toLowerCase() !== "path")
        return !1;
      let i = parseInt(e.target.dataset.line), j = parseInt(e.target.dataset.sector);
      const episode = this.Options.Series[i];
      if (!episode)
        return;
      let x = e.clientX - this._SvgRect.left, y = e.clientY - this._SvgRect.top;
      this._ToolTipState.SValue = {
        Name: episode.Episode.Labels[j],
        Label: episode.Episode.Labels[j],
        Color: episode.Episode.Colors[j],
        ValueX: episode.Episode.Labels[j],
        ValueY: episode.Data[j].Value,
        ValueOriginalY: episode.Data[j].ValueOriginal,
        EpisodeSum: episode.Sum,
        SvgWidth: this.HookChart.clientWidth,
        SvgHeight: this.HookChart.clientHeight,
        i,
        j,
        TypeID: episode.Type,
        Left: x,
        Top: y
      }, this.Tooltip.Refresh();
    }, 10);
  }
  _Initialize() {
    if (this._InitializeCommon(), this._InitializeSeriesDefault(), this._InitializeSeries(), this.Target = this.GetFirstParentDOM(), this.DOM = this.GetContent(), this.HookChart = LibraryDOM.Select(".hook-chart", this.DOM), this.ChartLegend = LibraryDOM.Select(".legend", this.DOM), this.ChartSvg = LibraryDOM.Select(".chart-svg", this.DOM), this.ChartTooltip = LibraryDOM.Select(".chart-tooltip", this.DOM), this.Target.appendChild(this.DOM), LibraryDOM.AddEventListenerGlobal("change", ".legend-checkbox", this.OnLegendChange.bind(this), this.DOM, this), this.props.ToolTip.Visible) {
      this.HookChart.addEventListener("mousemove", this.OnChartMouseMove.bind(this)), this.HookChart.addEventListener("mouseenter", this.OnChartMouseEnter.bind(this)), this.HookChart.addEventListener("mouseleave", this.OnChartMouseLeave.bind(this));
      let toolTipRendered = this.props.ToolTip.Render(this._ToolTipState), toolTipInner = ComponentFactory.Build(toolTipRendered, null, null)._GenerateDOM();
      this.ChartTooltip.appendChild(toolTipInner), this.Tooltip = {
        Timer: null,
        Hide: /* @__PURE__ */ __name(() => {
          LibraryDOM.AsyncToggle(null, null, this.ChartTooltip, () => {
          }, () => {
            this.ChartTooltip.style.display = "none";
          }, "l-appear", "l-disappear", 200, this.Tooltip.Timer);
        }, "Hide"),
        Show: /* @__PURE__ */ __name(() => {
          LibraryDOM.AsyncToggle(null, null, this.ChartTooltip, () => {
            this.ChartTooltip.style.display = "";
          }, () => {
          }, "l-disappear", "l-appear", 200, this.Tooltip.Timer);
        }, "Show"),
        Reset: /* @__PURE__ */ __name(() => {
          this.Tooltip.Timer && clearTimeout(this.Tooltip.Timer);
        }, "Reset"),
        Close: /* @__PURE__ */ __name(() => {
          clearTimeout(this.Tooltip.Timer), this.Tooltip.Timer = setTimeout(() => {
            this.Tooltip.Hide(), this.Tooltip.Timer = null;
          }, this.props.ToolTip.Timeout);
        }, "Close"),
        Refresh: /* @__PURE__ */ __name(() => {
          let Tip = this._ToolTipState.SValue;
          const Width = this.ChartTooltip.clientWidth, Height = this.ChartTooltip.clientHeight;
          let Left = Tip.Left - 30, Top = Tip.Top - 20 - Height;
          this.ChartTooltip.style.left = Tip.Left + "px", this.ChartTooltip.style.top = Tip.Top + "px", Left + Width >= Tip.SvgWidth ? (this.ChartTooltip.classList.add("reverse"), Left = Tip.Left + 30 - Width, this.ChartTooltip.style.left = Left + "px", this.ChartTooltip.style.top = Top + "px") : this.ChartTooltip.classList.remove("reverse"), this.Tooltip.Show();
        }, "Refresh")
      }, this._ToolTipState.Left.AddOnChange(() => this.Tooltip.Refresh()), this._ToolTipState.Top.AddOnChange(() => this.Tooltip.Refresh());
    }
  }
  _GenerateDOM() {
    return super._GenerateDOM(), this._Initialize(), this.DOM;
  }
};
__name(_ChartDrawing, "ChartDrawing");
let ChartDrawing = _ChartDrawing;
ChartDrawing.Pie = ChartEpisodePie;
ChartDrawing.PositionType = ChartPositionType;
ChartDrawing.defaultProps = {
  Title: ""
};
const _Paginator = class _Paginator extends Luff.ComponentSimple {
  get Paging() {
    return this.props.paging;
  }
  NextPage() {
    this.Paging.NextPage();
  }
  PrevPage() {
    this.Paging.PrevPage();
  }
  FirstPage() {
    this.Paging.Paging.Skip.SValue = 0;
  }
  LastPage() {
    this.Paging.LastPage();
  }
  BeforeBuild() {
    super.BeforeBuild();
    const p = this.props.paging.Paging, pageCount = p.Take.SubState((take) => {
      if (take == 0)
        return 0;
      const count = p.Count.SValue;
      return Math.ceil(count / take);
    }, [p.Count]), page = p.SubState((p2) => {
      let pageIndex = 1 + Math.ceil(p2.Skip / p2.Take);
      return isFinite(pageIndex) || (pageIndex = 1), pageIndex > pageCount.SValue && (pageIndex = pageCount.SValue), pageIndex;
    }), shownFrom = p.Skip.SubState((skip) => {
      let from = skip + 1;
      return from > p.Count.SValue && (from = p.Count.SValue - p.Take.SValue), from < 1 && (from = 1), from;
    }, [p.Take, p.Count]), shownTo = p.Skip.SubState((skip) => {
      let shown = skip + p.Take.SValue;
      return shown > p.Count.SValue && (shown = p.Count.SValue), shown;
    }, [p.Take, p.Count]);
    this.props.pageSizeList.includes(p.Take.SValue) || (this.props.pageSizeList.push(p.Take.SValue), this.props.pageSizeList.sort((a, b) => a - b)), this.PagesCount = pageCount, this.CurrentPage = page, this.ShownFrom = shownFrom, this.ShownTo = shownTo;
  }
  AfterBuild() {
  }
  Render() {
    const p = this.Paging.Paging;
    return React.createElement(
      "div",
      { className: "l-paginator " + this.props.className },
      React.createElement(
        "div",
        { className: "l-paginator-elem" },
        React.createElement(
          "button",
          { className: "l-button button", onClick: /* @__PURE__ */ __name(() => this.FirstPage(), "onClick") },
          React.createElement("div", { class: "l-paginator-control-icon prev prev-max" })
        )
      ),
      React.createElement(
        "div",
        { className: "l-paginator-elem" },
        React.createElement(
          "button",
          { className: "l-button button", onClick: /* @__PURE__ */ __name(() => this.PrevPage(), "onClick") },
          React.createElement("div", { class: "l-paginator-control-icon prev" })
        )
      ),
      React.createElement(
        "div",
        { class: "l-paginator-elem" },
        "Стр. ",
        this.CurrentPage,
        " из ",
        this.PagesCount,
        " "
      ),
      React.createElement(
        "div",
        { className: "l-paginator-elem" },
        React.createElement(
          "button",
          { className: "l-button button", onClick: /* @__PURE__ */ __name(() => this.NextPage(), "onClick") },
          React.createElement("div", { class: "l-paginator-control-icon next" })
        )
      ),
      React.createElement(
        "div",
        { className: "l-paginator-elem" },
        React.createElement(
          "button",
          { className: "l-button button", onClick: /* @__PURE__ */ __name(() => this.LastPage(), "onClick") },
          React.createElement("div", { class: "l-paginator-control-icon next next-max" })
        )
      ),
      React.createElement(
        "div",
        { className: "l-paginator-elem l-paginator-item-take" },
        React.createElement("div", { className: "div" }, "Показывать по "),
        React.createElement(ComboBox, { value: p.Take, dataStatic: this.props.pageSizeList, notFoundValue: "" })
      ),
      React.createElement(
        "div",
        { class: "l-paginator-elem" },
        "Показано ",
        this.ShownFrom,
        "-",
        this.ShownTo,
        " из ",
        p.Count
      ),
      this.props.children
    );
  }
};
__name(_Paginator, "Paginator");
let Paginator = _Paginator;
Paginator.defaultProps = {
  className: "",
  pageSizeList: [20, 50, 100]
};
const _DateBoxRange = class _DateBoxRange extends InputBoxBase {
  CallDatePicker() {
    if (this._IsDisabled.SValue)
      return;
    const dateStart = this.props.dateStart.SValue, dateFinish = this.props.dateFinish.SValue;
    PeriodPicker.GlobalRangePicker.RunRange([dateStart, dateFinish], (dateStart2, dateFinish2) => {
      if (this.props.onChange) {
        this.props.onChange(dateStart2.Date, dateFinish2.Date);
        return;
      }
      this.props.dateStart.SValue = dateStart2.Date, this.props.dateFinish.SValue = dateFinish2.Date;
    }, {
      dateMin: this.props.min ? Luff.Date(Luff.State.GetSValueOrValue(this.props.min)) : void 0,
      dateMax: this.props.max ? Luff.Date(Luff.State.GetSValueOrValue(this.props.max)) : void 0,
      isShowTimePick: this.props.isTimePick
    });
  }
  IsInputValidDefault() {
    const { dateStart, dateFinish, min, max } = this.props;
    return dateStart ? dateFinish ? min !== void 0 && dateStart.SValue.valueOf() < min.valueOf() ? {
      IsValid: !1,
      Message: "Дата начала меньше минимального значения"
    } : max !== void 0 && dateFinish.SValue.valueOf() > max.valueOf() ? {
      IsValid: !1,
      Message: "Дата конца больше максимального значения"
    } : {
      IsValid: !0,
      Message: ""
    } : {
      IsValid: !1,
      Message: "Дата конца не указана"
    } : {
      IsValid: !1,
      Message: "Дата начала не указана"
    };
  }
  Render() {
    const isTimePick = this.props.isTimePick;
    let classState = this._IsDisabled.SubState((isDis) => "l-textbox l-datebox " + this.props.className + (isDis ? "" : " l-pointer"));
    const formatFull = `${this.props.formatDate} ${isTimePick ? this.props.formatTime : ""}`;
    return React.createElement(
      "div",
      { className: classState, onClick: /* @__PURE__ */ __name(() => this.CallDatePicker(), "onClick") },
      React.createElement("div", { className: "l-datebox-value" }, this.props.dateStart.SubState((dateStart) => {
        const dateFinish = this.props.dateFinish.SValue;
        if (!dateFinish)
          return this.props.noValueCaption;
        if (dateStart && dateFinish) {
          let luffDateStart = Luff.Date(dateStart), luffDateFinish = Luff.Date(dateFinish);
          return luffDateStart.IsSameDate(luffDateFinish) && this.props.isTimePick ? `${luffDateStart.Format(this.props.formatDate)} с ${luffDateStart.Format(this.props.formatTime)} по ${luffDateFinish.Format(this.props.formatTime)}` : `${luffDateStart.Format(formatFull)} — ${luffDateFinish.Format(formatFull)}`;
        }
        return this.props.placeholder;
      }, [this.props.dateFinish]))
    );
  }
};
__name(_DateBoxRange, "DateBoxRange");
let DateBoxRange = _DateBoxRange;
DateBoxRange.defaultProps = {
  formatDate: Culture.Current.DateFormat,
  formatTime: Culture.Current.DateFormatTime,
  className: "",
  placeholder: "",
  isPermissionWriteRequired: !1,
  isTimePick: !1,
  noValueCaption: "выберите период"
};
const _EditableContent = class _EditableContent extends Luff.Content {
  Render() {
    return this.props.children && React.createElement("div", { className: "l-edit-container-content" }, this.props.children);
  }
  Ctor() {
    return {
      OnOutSideClick: /* @__PURE__ */ __name((e) => {
        Luff.DOM.Closest(e.target, ".l-period_picker") || this.props.Mode.SValue > 0 && (this.props.Mode.SValue = -1);
      }, "OnOutSideClick")
    };
  }
};
__name(_EditableContent, "EditableContent");
let EditableContent = _EditableContent;
const _EditableBase = class _EditableBase extends Luff.Content {
  constructor() {
    super(...arguments), this.Mode = Luff.State(-1), this.IsBusy = Luff.State(!1), this.ValueTemp = Luff.State("default");
  }
  GoToEdit(e) {
    this.ValueTemp.SValue = this.props.value.SValue, this.Mode.SValue = 1, e == null || e.stopPropagation();
  }
  GoToView() {
    this.Mode.SValue = -1;
  }
  BeforeBuild() {
    this.ValueView = this.props.value.SubState((v) => this.props.getValueView(v));
  }
  SetOriginalValue(newValue) {
    if (this.props.onChange) {
      this.props.onChange(newValue);
      return;
    }
    this.props.value.SValue = newValue;
  }
  Confirm() {
    this.GoToView();
    let value = this.props.value.SValue, tempValue = this.ValueTemp.SValue;
    if (value != tempValue) {
      if (!this.props.serverConfirm) {
        this.SetOriginalValue(tempValue);
        return;
      }
      this.IsBusy.SValue = !0, this.props.serverConfirm(tempValue).then((res) => {
        if (this.IsBusy.SValue = !1, res > -1) {
          this.SetOriginalValue(tempValue);
          return;
        }
        throw new Error();
      }).catch(() => {
        this.IsBusy.SValue = !1, this.ValueTemp.SValue = value;
        const st = this.props.value;
        console.error(`[Luff.Editable] failed to update property "${st._Property ? st._Property : ""}" to ${tempValue}`);
      });
    }
  }
  RenderContent() {
    return null;
  }
  Render() {
    const children = this.props.children, className = this.Mode.SubState((mode) => {
      let classNameList = "l-edit-container " + this.props.className;
      const value = this.props.value.SValue, valueTemp = this.ValueTemp.SValue, isBusy = this.IsBusy.SValue;
      return mode > 0 && value != valueTemp && (classNameList += " l-edit-changed"), isBusy && (classNameList += " l-busy"), classNameList;
    }, [this.props.value, this.ValueTemp, this.IsBusy]), isViewMode = this.Mode.SubState((m) => m < 0), isEditMode = this.Mode.SubState((m) => m > 0);
    let isControlsVisible = isViewMode;
    return this.props.disabled && (isControlsVisible = this.props.disabled.SubState((isDisabled) => this.Mode.SValue > 0 ? !1 : !isDisabled, [this.Mode])), React.createElement(
      "div",
      { className },
      React.createElement(
        "div",
        { className: "l-edit l-edit-value", isVisible: isViewMode },
        (!children || children.length === 0) && this.ValueView,
        !!children && children
      ),
      React.createElement(
        EditableContent,
        { Mode: this.Mode, isVisible: isEditMode },
        this.RenderContent(),
        React.createElement(
          "div",
          { className: "l-edit l-edit-controls" },
          React.createElement("div", { className: "l-edit l-edit-icon l-edit-proto l-edit-btn-save", title: "Применить", onClick: /* @__PURE__ */ __name((e) => {
            this.Confirm(), e.stopPropagation();
          }, "onClick") })
        )
      ),
      React.createElement(
        "div",
        { className: "l-edit l-edit-controls", isVisible: isControlsVisible, permission: "Write" },
        React.createElement("div", { className: "l-edit l-edit-icon l-edit-proto l-edit-btn-edit", title: "Изменить", onClick: /* @__PURE__ */ __name((e) => this.GoToEdit(e), "onClick") })
      )
    );
  }
};
__name(_EditableBase, "EditableBase");
let EditableBase = _EditableBase;
EditableBase.defaultProps = {
  caption: "",
  getValueView: /* @__PURE__ */ __name((v) => String(v), "getValueView"),
  className: ""
};
const _EditableText = class _EditableText extends EditableBase {
  AfterBuild() {
    super.AfterBuild(), this.TextBox = this.GetComponentByName("editableTextBox");
  }
  GoToEdit(e) {
    super.GoToEdit(e), this.TextBox.Focus(), this.TextBox.Select();
  }
  RenderContent() {
    return React.createElement(TextBox, { compName: "editableTextBox", className: "l-edit l-edit-editor l-edit-textbox", value: this.ValueTemp, onKeyEnter: /* @__PURE__ */ __name(() => this.Confirm(), "onKeyEnter"), onKeyEsc: /* @__PURE__ */ __name(() => this.GoToView(), "onKeyEsc"), mask: this.props.mask });
  }
};
__name(_EditableText, "EditableText");
let EditableText = _EditableText;
const _EditableNumber = class _EditableNumber extends EditableBase {
  AfterBuild() {
    super.AfterBuild(), this.TextBox = this.GetComponentByName("editableTextBox");
  }
  GoToEdit(e) {
    super.GoToEdit(e), this.TextBox.Focus(), this.TextBox.Select();
  }
  RenderContent() {
    return React.createElement(NumBox, { compName: "editableTextBox", className: "l-edit l-edit-editor l-edit-textbox", value: this.ValueTemp, onKeyEnter: /* @__PURE__ */ __name(() => this.Confirm(), "onKeyEnter"), onKeyEsc: /* @__PURE__ */ __name(() => this.GoToView(), "onKeyEsc"), min: this.props.min, max: this.props.max });
  }
};
__name(_EditableNumber, "EditableNumber");
let EditableNumber = _EditableNumber;
function delegateView(item) {
  return item.Name;
}
__name(delegateView, "delegateView");
function delegateValue(item) {
  return item.Value;
}
__name(delegateValue, "delegateValue");
const _EditableSelect = class _EditableSelect extends EditableBase {
  RenderContent() {
    return !this.props.data && !this.props.dataStatic && console.error("[Luff.Editable] 'EditableSelect' must have 'data' or 'dataStatic' property"), React.createElement(ComboBox, { value: this.ValueTemp, data: this.props.data, dataStatic: this.props.dataStatic, dataDelegateView: delegateView, dataDelegateValue: delegateValue, isSearchEnabled: this.props.isSearchEnabled });
  }
};
__name(_EditableSelect, "EditableSelect");
let EditableSelect = _EditableSelect;
const _EditableDate = class _EditableDate extends EditableBase {
  AfterBuild() {
    super.AfterBuild(), this.DateBox = this.GetComponentByName("editableTextBox");
  }
  RenderContent() {
    return React.createElement(DateBox, { compName: "editableTextBox", className: "l-edit l-edit-editor l-edit-date", value: this.ValueTemp, min: this.props.min, max: this.props.max, format: this.props.format, isTimePick: this.props.isTimePick });
  }
};
__name(_EditableDate, "EditableDate");
let EditableDate = _EditableDate;
const _EditableSpecial = class _EditableSpecial extends EditableBase {
  RenderContent() {
    return this.props.specialRender(this.props, this.ValueTemp, this.ValueView);
  }
};
__name(_EditableSpecial, "EditableSpecial");
let EditableSpecial = _EditableSpecial;
const _EditableSpecialArr = class _EditableSpecialArr extends Luff.Content {
  constructor() {
    super(...arguments), this.Mode = Luff.State(-1), this.IsBusy = Luff.State(!1), this.ValueTemp = Luff.StateArr([]);
  }
  //protected ValueView: IObservableStateSimple<string>;
  BeforeBuild() {
  }
  GoToEdit(e) {
    this.ValueTemp.SValue = this.props.value.SValue, this.Mode.SValue = 1, this.props.onClick && this.props.onClick(e), e.stopPropagation();
  }
  Confirm() {
    this.GoToView();
    let value = this.props.value.SValue, tempValue = this.ValueTemp.SValue;
    if (value != tempValue) {
      if (!this.props.serverConfirm) {
        this.props.value.SValue = tempValue;
        return;
      }
      this.IsBusy.SValue = !0, this.props.serverConfirm(tempValue).then((res) => {
        if (this.IsBusy.SValue = !1, res > -1) {
          this.props.value.SValue = tempValue;
          return;
        }
        throw new Error();
      }).catch(() => {
        this.IsBusy.SValue = !1, this.ValueTemp.SValue = value;
        const st = this.props.value;
        console.error(`[Luff.Editable] failed to update property "${st._Property ? st._Property : ""}" to ${tempValue}`);
      });
    }
  }
  GoToView() {
    this.Mode.SValue = -1;
  }
  Render() {
    const children = this.props.children, className = this.Mode.SubState((mode) => {
      let classNameList = "l-edit-container " + this.props.className;
      const value = this.props.value.SValue, valueTemp = this.ValueTemp.SValue, isBusy = this.IsBusy.SValue;
      return mode > 0 && value != valueTemp && (classNameList += " l-edit-changed"), isBusy && (classNameList += " l-busy"), classNameList;
    }, [this.props.value, this.ValueTemp, this.IsBusy]), isViewMode = this.Mode.SubState((m) => m < 0), isEditMode = this.Mode.SubState((m) => m > 0);
    return React.createElement(
      "div",
      { className, onDoubleClick: /* @__PURE__ */ __name((e) => this.GoToEdit(e), "onDoubleClick") },
      React.createElement("div", { className: "l-edit l-edit-value", isVisible: isViewMode }, children),
      React.createElement(
        EditableContent,
        { Mode: this.Mode, isVisible: isEditMode },
        children,
        this.props.specialRender(this.props, this.ValueTemp, null)
      ),
      React.createElement(
        "div",
        { className: "l-edit l-edit-controls" },
        React.createElement("div", { className: "l-edit l-edit-icon l-edit-proto l-edit-btn-edit", title: "Изменить", onClick: /* @__PURE__ */ __name((e) => this.GoToEdit(e), "onClick") })
      )
    );
  }
};
__name(_EditableSpecialArr, "EditableSpecialArr");
let EditableSpecialArr = _EditableSpecialArr;
EditableSpecialArr.defaultProps = {
  caption: "",
  className: ""
};
const _EditableMini = class _EditableMini extends Luff.Content {
  constructor() {
    super(...arguments), this.IsBusy = Luff.State(!1);
  }
  GoToEdit(e) {
    this.props.onClick && this.props.onClick(e, (val) => this.Confirm(val)), e.stopPropagation();
  }
  Confirm(val) {
    let tempValue = val;
    return this.props.serverConfirm ? (this.IsBusy.SValue = !0, this.props.serverConfirm(tempValue).then((res) => {
      if (this.IsBusy.SValue = !1, res > -1)
        return tempValue;
      throw new Error();
    }).catch(() => (this.IsBusy.SValue = !1, console.error("[Luff.EditableMini] failed to update"), tempValue))) : Promise.resolve(tempValue);
  }
  Render() {
    const children = this.props.children, className = this.IsBusy.SubState((isBusy) => {
      let classNameList = "l-edit-container " + this.props.className;
      return isBusy && (classNameList += " l-busy"), classNameList;
    });
    return React.createElement(
      "div",
      { className, onDoubleClick: /* @__PURE__ */ __name((e) => this.GoToEdit(e), "onDoubleClick") },
      React.createElement("div", { className: "l-edit l-edit-value" }, children),
      React.createElement(
        "div",
        { className: "l-edit l-edit-controls" },
        React.createElement("div", { className: "l-edit l-edit-icon l-edit-proto l-edit-btn-edit", title: "Изменить", onClick: /* @__PURE__ */ __name((e) => this.GoToEdit(e), "onClick") })
      )
    );
  }
};
__name(_EditableMini, "EditableMini");
let EditableMini = _EditableMini;
EditableMini.defaultProps = {
  className: ""
};
const _TimeBox = class _TimeBox extends InputBoxBase {
  constructor() {
    super(...arguments), this.RouteOfferList = new Route({ DoNotUseRouter: !0 });
  }
  BeforeBuild() {
    super.BeforeBuild();
    const { min, max } = this.props;
    this.isMinState = min instanceof State, this.isMaxState = max instanceof State, this.minSt = min, this.maxSt = max;
  }
  GetMin() {
    return this.isMinState ? this.minSt.SValue : this.props.min;
  }
  GetMax() {
    return this.isMaxState ? this.maxSt.SValue : this.props.max;
  }
  IsInputValidDefault() {
    const { value, min, max } = this.props, v = value.SValue;
    return min !== void 0 && v < min.valueOf() ? {
      IsValid: !1,
      Message: "Значение меньше минимума"
    } : max !== void 0 && v > max.valueOf() ? {
      IsValid: !1,
      Message: "Значение больше максимума"
    } : {
      IsValid: !0,
      Message: ""
    };
  }
  CallDatePicker() {
    if (this._IsDisabled.SValue)
      return;
    const date = this.props.value.SValue;
    PeriodPicker.GlobalSinglePicker.Run(date, date, (dateStart, dateFinish) => {
      if (this.props.onChange) {
        this.props.onChange(dateStart.Date);
        return;
      }
      this.props.value.SValue = dateStart.Date;
    }, {
      dateMin: this.props.min ? Luff.Date(this.GetMin()) : void 0,
      dateMax: this.props.max ? Luff.Date(this.GetMax()) : void 0
    });
  }
  Render() {
    let classState = this._IsDisabled.SubState((isDis) => "l-textbox l-timebox" + this.props.className + (isDis ? "" : " l-pointer"));
    return this.props.children, Luff.State(!1), React.createElement(
      "div",
      { className: classState },
      React.createElement("span", { onClick: /* @__PURE__ */ __name(() => this.RouteOfferList.Toggle(), "onClick") }, this.props.value.SubState((x) => x ? Luff.Date(x).Format("HH:mm") : this.props.placeholder)),
      React.createElement(TimeBoxLists, { timeBox: this })
    );
  }
};
__name(_TimeBox, "TimeBox");
let TimeBox = _TimeBox;
TimeBox.defaultProps = {
  className: "",
  placeholder: "__:__",
  isPermissionWriteRequired: !1,
  format: Culture.Current.DateFormat,
  formatTime: Culture.Current.DateFormatTime,
  isTimePick: !1,
  hourStep: 1,
  minuteStep: 1
};
const _TimeBoxLists = class _TimeBoxLists extends Luff.Content {
  constructor() {
    super(...arguments), this.IsReverseShow = Luff.State(!1);
  }
  OnAppear() {
    let boxRect = this.props.timeBox.DOM.getBoundingClientRect(), listRect = this.DOM.getBoundingClientRect();
    const windowHeight = window.innerHeight, itemBottom = boxRect.top + boxRect.height + listRect.height;
    let isOver = itemBottom > windowHeight;
    console.log("windowHeight", windowHeight, "itemBottom", itemBottom, "boxRect.bottom", boxRect.top + boxRect.height, "listRect.height", listRect.height, "isOver:", isOver), this.IsReverseShow.SValue = isOver;
  }
  Render() {
    const dt = this.props.timeBox.props.value, hour = dt.SubState((d) => d.getHours()), minute = dt.SubState((d) => d.getMinutes());
    return React.createElement(
      "div",
      { className: "l-timebox-time-list list l-row", classDict: { reverseShow: this.IsReverseShow } },
      React.createElement("div", { className: "sublist hours" }, new Array(24).fill(0).map((x, i) => React.createElement("div", { className: "l-tbt-item", onClick: /* @__PURE__ */ __name(() => {
        let d = dt.SValue;
        d.setHours(i), dt.SValue = d;
      }, "onClick"), classDict: {
        "l-tbt-selected": hour.SubState((h) => h == i)
      } }, i))),
      React.createElement("div", { className: "sublist minutes" }, new Array(60).fill(0).map((x, i) => React.createElement("div", { className: "l-tbt-item", onClick: /* @__PURE__ */ __name(() => {
        let d = dt.SValue;
        d.setMinutes(i), dt.SValue = d;
      }, "onClick"), classDict: {
        "l-tbt-selected": minute.SubState((m) => m == i)
      } }, i)))
    );
  }
  Ctor() {
    return {
      Dialog: {
        IsGlobal: !1,
        HasWrapper: !1,
        //IsHideOnOutsideClick: true,
        OnOutsideClick: /* @__PURE__ */ __name((e) => {
          Luff.DOM.IsDescendant(e.target, this.ParentElement.DOM) || this.Hide();
        }, "OnOutsideClick"),
        Animation: null
      },
      Route: this.props.timeBox.RouteOfferList
    };
  }
};
__name(_TimeBoxLists, "TimeBoxLists");
let TimeBoxLists = _TimeBoxLists;
function defaultRenderView(value) {
  return value;
}
__name(defaultRenderView, "defaultRenderView");
const _RangeSlider = class _RangeSlider extends Luff.Content {
  constructor() {
    super(...arguments), this.IsActive = !1;
  }
  AfterBuild() {
    var _a;
    this.ValueView1DOM = this.GetComponentByName("l-sr-value-view-1").DOM, this.ValueView2DOM = (_a = this.GetComponentByName("l-sr-value-view-2")) === null || _a === void 0 ? void 0 : _a.DOM, this.ValueBodyDOM = this.GetComponentByName("l-sr-body").DOM;
  }
  OnAppear() {
    var _a;
    this.Value1.ForceUpdate(), (_a = this.Value2) === null || _a === void 0 || _a.ForceUpdate();
  }
  GetClosestValueState(value) {
    if (!this.props.value2)
      return this.props.value1;
    let d1 = Math.abs(this.props.value1.SValue - value), d2 = Math.abs(this.props.value2.SValue - value);
    return d1 < d2 ? this.props.value1 : this.props.value2;
  }
  GetPositionValue(e) {
    const { min, max, step } = this.props, rect = e.currentTarget.getBoundingClientRect(), pos = (e.clientX - rect.left) / e.currentTarget.clientWidth;
    let value = Math.round((max - min) * pos);
    if (step > 1) {
      const deltaStep = (value - min) % step, halfStep = step / 2;
      deltaStep >= halfStep ? value = value + (step - deltaStep) : value = value - deltaStep;
    }
    return value;
  }
  GetValue1State() {
    const { min, max } = this.props;
    return this.props.value2 ? this.props.value1.SubState((value1) => {
      const value2 = this.props.value2.SValue, valueRange = max - min;
      return Math.min(value1, value2 - 1) / valueRange * 100;
    }, [this.props.value2]) : this.props.value1.SubState((value1) => Math.round(value1 / (max - min) * 100));
  }
  GetValue2State() {
    const { min, max } = this.props;
    return this.props.value2 ? this.props.value2.SubState((value2) => {
      const value1 = this.props.value1.SValue;
      return Math.max(value2, value1 + 1) / max * 100;
    }, [this.props.value1]) : Luff.State(100);
  }
  Render() {
    const { min, max } = this.props, isSingle = !this.props.value2;
    this.Value1 = this.GetValue1State(), this.Value2 = this.GetValue2State();
    const width1 = this.Value1.SubState((v) => v + "%"), width2 = this.Value2.SubState((v) => 100 - v + "%"), widthView1 = this.Value1.SubState((v) => {
      if (!this.ValueBodyDOM)
        return "0";
      const wBody = this.ValueBodyDOM.getBoundingClientRect().width, offset = this.ValueView1DOM.getBoundingClientRect().width / 2 / wBody * 100;
      let dt = v - offset;
      return dt < 0 && (dt = 0), dt + "%";
    }), widthView2 = this.Value2.SubState((v) => {
      if (!this.props.value2 || !this.ValueBodyDOM)
        return "0";
      const wBody = this.ValueBodyDOM.getBoundingClientRect().width, offset = this.ValueView2DOM.getBoundingClientRect().width / 2 / wBody * 100;
      let dt = 100 - v - offset;
      return dt > 100 && (dt = 100), dt + "%";
    });
    return React.createElement(
      "div",
      { className: "l-slider-range" + (isSingle ? " l-sr-single" : "") },
      React.createElement(
        "div",
        { className: "l-sr-head" },
        React.createElement("div", { className: "l-sr-line-part l-sr-empty", style: { width: widthView1 } }),
        React.createElement(
          "div",
          { className: "l-sr-line-part l-sr-caption", style: { flex: "1" } },
          React.createElement("div", { className: "l-sr-value-view", compName: "l-sr-value-view-1" }, this.props.renderView(this.props.value1)),
          this.props.value2 && React.createElement("div", { className: "l-sr-value-view", compName: "l-sr-value-view-2" }, this.props.renderView(this.props.value2))
        ),
        React.createElement("div", { className: "l-sr-line-part l-sr-empty", style: { width: widthView2 } })
      ),
      React.createElement(
        "div",
        { compName: "l-sr-body", className: "l-sr-body", onMouseLeave: /* @__PURE__ */ __name(() => this.IsActive = !1, "onMouseLeave"), onMouseUp: /* @__PURE__ */ __name(() => this.IsActive = !1, "onMouseUp"), onMouseDown: /* @__PURE__ */ __name((e) => {
          const value = this.GetPositionValue(e);
          this.CurrentValue = this.GetClosestValueState(value), this.IsActive = !0, !(value < min || value > max) && (this.CurrentValue.SValue = value);
        }, "onMouseDown"), onMouseMove: /* @__PURE__ */ __name((e) => {
          if (!this.IsActive)
            return;
          const value = this.GetPositionValue(e);
          value < min || value > max || (this.props.value2 && (this.CurrentValue === this.props.value1 && value >= this.props.value2.SValue && (this.props.value1.SValue = this.props.value2.SValue, this.CurrentValue = this.props.value2), this.CurrentValue === this.props.value2 && value <= this.props.value1.SValue && (this.props.value2.SValue = this.props.value1.SValue, this.CurrentValue = this.props.value1)), this.CurrentValue.SValue = value);
        }, "onMouseMove") },
        React.createElement(
          "div",
          { className: "l-sr-line" },
          React.createElement("div", { className: "l-sr-line-part l-sr-line-left l-sr-empty", style: { width: width1 } }),
          React.createElement(
            "div",
            { className: "l-sr-hook l-sr-hook-1" },
            React.createElement("div", { className: "l-sr-pin" })
          ),
          this.props.value2 && React.createElement(
            React.Fragment,
            null,
            React.createElement("div", { className: "l-sr-line-part l-sr-fill", style: { flex: "1" } }),
            React.createElement(
              "div",
              { className: "l-sr-hook l-sr-hook-1" },
              React.createElement("div", { className: "l-sr-pin" })
            ),
            React.createElement("div", { className: "l-sr-line-part l-sr-empty", style: { width: width2 } })
          )
        )
      )
    );
  }
};
__name(_RangeSlider, "RangeSlider");
let RangeSlider = _RangeSlider;
RangeSlider.defaultProps = {
  renderView: defaultRenderView,
  step: 1
};
const _SelectButtons = class _SelectButtons extends Luff.ComponentSimple {
  Render() {
    const { data, value, setValue, valuesDeprecated } = this.props, dataArray = data, dataStateArray = data;
    return Array.isArray(dataArray) ? React.createElement("div", { className: "l-select-buttons" }, dataArray.map((item) => React.createElement(
      "div",
      { class: "l-sb-holder" },
      React.createElement(RadioButton, { className: "l-select-button-radio", currentValue: value, value: item.Value, onChange: setValue }, item.Name)
    ))) : React.createElement(
      "div",
      { className: "l-select-buttons" },
      React.createElement(Each, { source: dataStateArray, render: /* @__PURE__ */ __name((item) => React.createElement(
        "div",
        { class: "l-sb-holder" },
        React.createElement(RadioButton, { className: "l-select-button-radio", currentValue: value, value: item.Value, onChange: setValue }, item.Name)
      ), "render") })
    );
  }
};
__name(_SelectButtons, "SelectButtons");
let SelectButtons = _SelectButtons;
const _InputValidator = class _InputValidator {
  constructor(ctor) {
    this.Checks = [], this.HintDuration = 5e3, this.HintMargin = { x: 25, y: -5 }, this.Ctor = ctor, this.HintDuration = ctor.HintDuration !== void 0 ? ctor.HintDuration : this.HintDuration, this.HintMargin = ctor.HintMargin !== void 0 ? ctor.HintMargin : this.HintMargin;
    for (let ch of ctor.Comps) {
      let isValidFn = ch.IsValidFn;
      isValidFn || (isValidFn = ch.Comp.IsInputValidDefault), this.Checks.push({
        Comp: ch.Comp,
        IsValidFn: isValidFn
      });
    }
  }
  Check() {
    let failedItems = [];
    for (let ch of this.Checks) {
      const res = ch.IsValidFn.call(ch.Comp);
      if (!res.IsValid) {
        const dom = ch.Comp.GetFirstDOMElement();
        failedItems.push(ch), LuffHint.PopHint({
          Margin: this.HintMargin,
          Direction: "top-left",
          OnElement: dom,
          Text: res.Message,
          ClassName: "l-hint-error",
          TargetArea: document.body,
          IsContainment: !0,
          Duration: this.HintDuration
        });
      }
    }
    return failedItems;
  }
  IsValid() {
    return this.Check().length === 0;
  }
};
__name(_InputValidator, "InputValidator");
let InputValidator = _InputValidator;
export {
  ButtonBusy,
  ChartDrawing,
  CheckBox,
  ComboBox,
  ComboBoxTree,
  ContextMenu,
  DateBox,
  DateBoxRange,
  DatePickBar,
  EditableDate,
  EditableMini,
  EditableNumber,
  EditableSelect,
  EditableSpecial,
  EditableSpecialArr,
  EditableText,
  ImageCarousel,
  LuffImageViewer as ImageViewer,
  InputValidator,
  LuffChart,
  LuffHint,
  LuffImageViewer,
  NumBox,
  Paginator,
  PeriodPicker,
  PhoneInput,
  PopMenu,
  ProgressBar,
  RadioButton,
  RangeSlider,
  SelectButtons,
  TextBox,
  TextBoxRich,
  TimeBox
};
//# sourceMappingURL=index.js.map
